import * as React from 'react';

declare module 'react' {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  interface SVGProps<T> {
    input?: any;
  }
}

export function ic_tele_geofence_unavailable() {
  return (
    <svg
      id="ic_tele_geofence_unavailable"
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
    >
      <circle id="BG" cx="8" cy="8" r="8" fill="none" />
      <path
        id="Pin"
        d="M-809,1568.166a6.183,6.183,0,0,1,6.2-6.165,6.184,6.184,0,0,1,6.2,6.165c0,4.831-5.037,8.994-6.2,8.994S-809,1573-809,1568.166Z"
        transform="translate(811 -1561.581)"
        fill="#ff0700"
      />
      <path
        id="Icon"
        d="M2.267-2.565v-.111A4.324,4.324,0,0,1,2.414-3.9a1.857,1.857,0,0,1,.407-.735,3.184,3.184,0,0,1,.643-.513,2.989,2.989,0,0,0,.467-.356,1.518,1.518,0,0,0,.326-.435,1.2,1.2,0,0,0,.119-.539,1.062,1.062,0,0,0-.158-.584,1.073,1.073,0,0,0-.424-.384A1.285,1.285,0,0,0,3.2-7.585a1.307,1.307,0,0,0-.573.13,1.118,1.118,0,0,0-.447.392,1.286,1.286,0,0,0-.2.663H.464A2.465,2.465,0,0,1,.859-7.756a2.3,2.3,0,0,1,.989-.818,3.325,3.325,0,0,1,1.362-.273,3.4,3.4,0,0,1,1.434.286,2.26,2.26,0,0,1,.967.812A2.211,2.211,0,0,1,5.957-6.5a2.3,2.3,0,0,1-.156.869,2.141,2.141,0,0,1-.441.682,3.212,3.212,0,0,1-.678.533,2.831,2.831,0,0,0-.565.443,1.438,1.438,0,0,0-.324.539,2.472,2.472,0,0,0-.109.761v.111ZM3.009.094a.909.909,0,0,1-.661-.273.9.9,0,0,1-.277-.665A.888.888,0,0,1,2.348-1.5a.909.909,0,0,1,.661-.273.911.911,0,0,1,.658.273.885.885,0,0,1,.279.656.891.891,0,0,1-.13.473.985.985,0,0,1-.341.339A.894.894,0,0,1,3.009.094Z"
        transform="translate(4.991 12)"
        fill="#fff"
      />
    </svg>
  );
}

export function ic_tele_geofence_unavailable_content() {
  return (
    <svg
      id="ic_tele_geofence_unavailable_content"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="36"
      height="36"
      viewBox="0 0 36 36"
    >
      <defs>
        <filter
          id="Path_476"
          x="3.473"
          y="0.908"
          width="29.059"
          height="34.186"
          filterUnits="userSpaceOnUse"
        >
          <feOffset input="SourceAlpha" />
          <feGaussianBlur stdDeviation="1" result="blur" />
          <feFlood flood-opacity="0.2" />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <rect id="Box" width="36" height="36" fill="none" />
      <g id="icon" transform="translate(-511.488 -856)">
        <g transform="matrix(1, 0, 0, 1, 511.49, 856)" filter="url(#Path_476)">
          <path
            id="Path_476-2"
            data-name="Path 476"
            d="M22577.49,24367.467a11.529,11.529,0,0,1,23.059,0c0,8.979-9.369,16.719-11.529,16.719S22577.49,24376.445,22577.49,24367.467Z"
            transform="translate(-22571.02 -24352.09)"
            fill="#ff0700"
          />
        </g>
        <path
          id="Icon-2"
          data-name="Icon"
          d="M3.881,3.058v-.21A8.2,8.2,0,0,1,4.159.522,3.52,3.52,0,0,1,4.931-.871a6.034,6.034,0,0,1,1.22-.973,5.666,5.666,0,0,0,.884-.674,2.877,2.877,0,0,0,.618-.824,2.269,2.269,0,0,0,.226-1.022,2.013,2.013,0,0,0-.3-1.106,2.034,2.034,0,0,0-.8-.727A2.436,2.436,0,0,0,5.65-6.456a2.478,2.478,0,0,0-1.086.246,2.119,2.119,0,0,0-.848.743A2.438,2.438,0,0,0,3.34-4.211H.464a4.672,4.672,0,0,1,.747-2.568A4.362,4.362,0,0,1,3.085-8.33a6.3,6.3,0,0,1,2.58-.517,6.435,6.435,0,0,1,2.718.541,4.284,4.284,0,0,1,1.833,1.539A4.19,4.19,0,0,1,10.875-4.4a4.352,4.352,0,0,1-.295,1.648,4.057,4.057,0,0,1-.836,1.292A6.087,6.087,0,0,1,8.46-.455a5.365,5.365,0,0,0-1.07.84,2.725,2.725,0,0,0-.614,1.022A4.685,4.685,0,0,0,6.57,2.848v.21ZM5.286,8.1a1.722,1.722,0,0,1-1.252-.517,1.7,1.7,0,0,1-.525-1.26,1.683,1.683,0,0,1,.525-1.244,1.769,1.769,0,0,1,2.5,0,1.738,1.738,0,0,1,.283,2.14,1.867,1.867,0,0,1-.646.642A1.7,1.7,0,0,1,5.286,8.1Z"
          transform="translate(523.822 874.198)"
          fill="#fff"
        />
      </g>
    </svg>
  );
}

export function ill_signout() {
  return (
    <svg
      id="ill_signout"
      xmlns="http://www.w3.org/2000/svg"
      width="120"
      height="120"
      viewBox="0 0 120 120"
    >
      <rect id="BG" width="120" height="120" rx="60" fill="#f7f7f7" />
      <g id="Icon" transform="translate(-6.239 -13.267)">
        <path
          id="Vector"
          d="M0,12.135C.742,3.519,5.17,0,14.864,0h.311c10.7,0,14.984,4.284,14.984,14.984V30.59c0,10.7-4.284,14.984-14.984,14.984h-.311C5.242,45.573.814,42.1.024,33.629"
          transform="translate(80.658 96.054) rotate(180)"
          fill="none"
          stroke="#ff0601"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
        <path
          id="Vector-2"
          data-name="Vector"
          d="M27.239,0H0"
          transform="translate(93.299 73.292) rotate(180)"
          fill="none"
          stroke="#ff0601"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
        <path
          id="Vector-3"
          data-name="Vector"
          d="M8.018,0,0,8.018l8.018,8.018"
          transform="translate(95.978 81.309) rotate(180)"
          fill="none"
          stroke="#ff0601"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
      </g>
    </svg>
  );
}

export function add_eq_error() {
  return (
    <svg
      id="ic_banner_info"
      xmlns="http://www.w3.org/2000/svg"
      width="42"
      height="42"
      viewBox="0 0 42 42"
    >
      <rect
        id="Box"
        width="32"
        height="32"
        transform="translate(5 5)"
        fill="none"
      />
      <circle id="Circle" cx="21" cy="21" r="21" fill="#ff0700" />
      <g id="ic_info" transform="translate(9 9)">
        <path
          id="Vector"
          d="M10,20A10,10,0,1,0,0,10,10.029,10.029,0,0,0,10,20Z"
          transform="translate(22 22) rotate(180)"
          fill="none"
          stroke="#fff"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          id="Vector-2"
          data-name="Vector"
          d="M0,0V5"
          transform="translate(12 16) rotate(180)"
          fill="none"
          stroke="#fff"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          id="Vector-3"
          data-name="Vector"
          d="M0,0H.009"
          transform="translate(12.006 8) rotate(180)"
          fill="none"
          stroke="#fff"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
        <path
          id="Vector-4"
          data-name="Vector"
          d="M0,0H24V24H0Z"
          fill="none"
          opacity="0"
        />
      </g>
    </svg>
  );
}

export function chevron_down() {
  return (
    <svg
      id="chevron_down"
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
    >
      <rect id="Box" width="20" height="20" fill="none" />
      <path
        id="Vector"
        d="M0,9.467,4.72,4.733,0,0"
        transform="translate(14.732 7.639) rotate(90)"
        fill="none"
        stroke="#dc4405"
        strokeLinecap="round"
        strokeWidth="1.5"
      />
    </svg>
  );
}

export function chevron_right({ color = '#dc4405', width = 20, height = 20 }) {
  return (
    <svg
      id="chevron_right"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox={`0 0 20 20`}
    >
      <rect id="Box" width={width} height={height} fill="none" />
      <path
        id="Vector"
        d="M0,9.467,4.72,4.733,0,0"
        transform="translate(7.641 5.266)"
        fill="none"
        stroke={color}
        strokeLinecap="round"
        strokeWidth="1.7"
      />
    </svg>
  );
}

export function ic_account() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18.612"
      viewBox="0 0 18 18.612"
    >
      <g id="ic_account" transform="translate(0 0.612)">
        <path
          id="account"
          d="M44,28a4,4,0,1,0-4-4,4.006,4.006,0,0,0,4,4"
          transform="translate(-35 -20)"
          fill="none"
          stroke="#fff"
          strokeLinecap="square"
          strokeWidth="1.2"
        />
        <g
          id="Rectangle_50"
          data-name="Rectangle 50"
          transform="translate(0 11)"
          fill="none"
          stroke="#fff"
          strokeWidth="1.2"
        >
          <path
            d="M4,0H14a4,4,0,0,1,4,4V7a0,0,0,0,1,0,0H0A0,0,0,0,1,0,7V4A4,4,0,0,1,4,0Z"
            stroke="none"
          />
          <path
            d="M4,.6H14A3.4,3.4,0,0,1,17.4,4V5.8a.6.6,0,0,1-.6.6H1.2a.6.6,0,0,1-.6-.6V4A3.4,3.4,0,0,1,4,.6Z"
            fill="none"
          />
        </g>
      </g>
    </svg>
  );
}

export function ic_account_language() {
  return (
    <svg
      id="ic_account_language"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <rect id="Box" width="24" height="24" fill="none" />
      <g id="global" transform="translate(-171 -251)">
        <path
          id="Vector"
          d="M18,9A9,9,0,1,1,9,0,9,9,0,0,1,18,9Z"
          transform="translate(174 254)"
          fill="none"
          stroke="#909090"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.2"
        />
        <path
          id="Vector-2"
          data-name="Vector"
          d="M.463,0h1a22.612,22.612,0,0,0,0,16h-1"
          transform="translate(178.869 255)"
          fill="none"
          stroke="#909090"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.2"
        />
        <path
          id="Vector-3"
          data-name="Vector"
          d="M0,0A22.612,22.612,0,0,1,0,16"
          transform="translate(185.669 255)"
          fill="none"
          stroke="#909090"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.2"
        />
        <path
          id="Vector-4"
          data-name="Vector"
          d="M0,1V0A22.612,22.612,0,0,0,16,0V1"
          transform="translate(175 265.669)"
          fill="none"
          stroke="#909090"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.2"
        />
        <path
          id="Vector-5"
          data-name="Vector"
          d="M0,1.463a22.612,22.612,0,0,1,16,0"
          transform="translate(175 258.869)"
          fill="none"
          stroke="#909090"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.2"
        />
        <path
          id="Vector-6"
          data-name="Vector"
          d="M0,0H22V22H0Z"
          transform="translate(194 274) rotate(180)"
          fill="none"
          opacity="0"
        />
      </g>
    </svg>
  );
}

export function ic_account_logout() {
  return (
    <svg
      id="ic_account_logout"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <path
        id="Vector"
        d="M0,5.07C.31,1.47,2.16,0,6.21,0h.13c4.47,0,6.26,1.79,6.26,6.26v6.52c0,4.47-1.79,6.26-6.26,6.26H6.21c-4.02,0-5.87-1.45-6.2-4.99"
        transform="translate(16.1 21.53) rotate(180)"
        fill="none"
        stroke="#909090"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.2"
      />
      <path
        id="Vector-2"
        data-name="Vector"
        d="M11.38,0H0"
        transform="translate(21.381 12.021) rotate(180)"
        fill="none"
        stroke="#909090"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.2"
      />
      <path
        id="Vector-3"
        data-name="Vector"
        d="M3.35,0,0,3.35,3.35,6.7"
        transform="translate(22.5 15.37) rotate(180)"
        fill="none"
        stroke="#909090"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.2"
      />
      <path
        id="Vector-4"
        data-name="Vector"
        d="M0,0H24V24H0Z"
        transform="translate(24 24) rotate(180)"
        fill="none"
        opacity="0"
      />
    </svg>
  );
}

export function ic_account_password() {
  return (
    <svg
      id="ic_account_password"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <path
        id="Vector"
        d="M7.08.233,2.09,2.113A3.47,3.47,0,0,0,0,5.122v7.43a4.862,4.862,0,0,0,1.73,3.44l4.3,3.21a4.552,4.552,0,0,0,5.14,0l4.3-3.21a4.862,4.862,0,0,0,1.73-3.44V5.122A3.472,3.472,0,0,0,15.11,2.1L10.12.233A5.085,5.085,0,0,0,7.08.233Z"
        transform="translate(3.41 1.997)"
        fill="none"
        stroke="#909090"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.2"
      />
      <path
        id="Vector-2"
        data-name="Vector"
        d="M0,0H24V24H0Z"
        transform="translate(24 24) rotate(180)"
        fill="none"
        opacity="0"
      />
      <path
        id="Vector-3"
        data-name="Vector"
        d="M4,2A2,2,0,1,1,2,0,2,2,0,0,1,4,2Z"
        transform="translate(10 8.5)"
        fill="none"
        stroke="#909090"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.2"
      />
      <path
        id="Vector-4"
        data-name="Vector"
        d="M0,0V3"
        transform="translate(12 12.5)"
        fill="none"
        stroke="#909090"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.2"
      />
    </svg>
  );
}

export function ic_account_settings() {
  return (
    <svg
      id="ic_account_settings"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <path
        id="Vector"
        d="M6,3A3,3,0,1,1,3,0,3,3,0,0,1,6,3Z"
        transform="translate(9 9)"
        fill="none"
        stroke="#909090"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.2"
      />
      <path
        id="Vector-2"
        data-name="Vector"
        d="M0,10.319V8.559a1.906,1.906,0,0,1,1.9-1.9c1.81,0,2.55-1.28,1.64-2.85a1.9,1.9,0,0,1,.7-2.59L5.97.229a1.669,1.669,0,0,1,2.28.6l.11.19c.9,1.57,2.38,1.57,3.29,0l.11-.19a1.669,1.669,0,0,1,2.28-.6l1.73.99a1.9,1.9,0,0,1,.7,2.59c-.91,1.57-.17,2.85,1.64,2.85a1.906,1.906,0,0,1,1.9,1.9v1.76a1.906,1.906,0,0,1-1.9,1.9c-1.81,0-2.55,1.28-1.64,2.85a1.9,1.9,0,0,1-.7,2.59l-1.73.99a1.669,1.669,0,0,1-2.28-.6l-.11-.19c-.9-1.57-2.38-1.57-3.29,0l-.11.19a1.669,1.669,0,0,1-2.28.6l-1.73-.99a1.9,1.9,0,0,1-.7-2.59c.91-1.57.17-2.85-1.64-2.85A1.906,1.906,0,0,1,0,10.319Z"
        transform="translate(2 2.562)"
        fill="none"
        stroke="#909090"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.2"
      />
      <path
        id="Vector-3"
        data-name="Vector"
        d="M0,0H24V24H0Z"
        fill="none"
        opacity="0"
      />
    </svg>
  );
}

export function ic_account_support() {
  return (
    <svg
      id="ic_account_support"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <path
        id="Vector"
        d="M10,17H5c-3,0-5-1.5-5-5V5C0,1.5,2,0,5,0H15c3,0,5,1.5,5,5V8"
        transform="translate(2 3.5)"
        fill="none"
        stroke="#909090"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.2"
      />
      <path
        id="Vector-2"
        data-name="Vector"
        d="M10,0,6.87,2.5a3.166,3.166,0,0,1-3.75,0L0,0"
        transform="translate(7 9)"
        fill="none"
        stroke="#909090"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.2"
      />
      <g id="Group" transform="translate(15.172 14.197)">
        <path
          id="Vector-3"
          data-name="Vector"
          d="M4.039.573.5,4.113a1.232,1.232,0,0,0-.3.59l-.19,1.35a.635.635,0,0,0,.76.76l1.35-.19a1.189,1.189,0,0,0,.59-.3l3.54-3.54a1.365,1.365,0,0,0,0-2.22A1.361,1.361,0,0,0,4.039.573Z"
          fill="none"
          stroke="#909090"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.2"
        />
        <path
          id="Vector-4"
          data-name="Vector"
          d="M0,0A3.185,3.185,0,0,0,2.22,2.22"
          transform="translate(3.529 1.083)"
          fill="none"
          stroke="#909090"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.2"
        />
      </g>
      <path
        id="Vector-5"
        data-name="Vector"
        d="M0,0H24V24H0Z"
        fill="none"
        opacity="0"
      />
    </svg>
  );
}

export function ic_banner_close() {
  return (
    <svg
      id="ic_banner_close"
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
    >
      <rect id="Box" width="16" height="16" fill="none" />
      <line
        id="Line"
        x2="8"
        y2="8"
        transform="translate(4 4)"
        fill="none"
        stroke="#a3a3a3"
        strokeLinecap="round"
        strokeWidth="1.5"
      />
      <line
        id="Line-2"
        data-name="Line"
        x1="8"
        y2="8"
        transform="translate(4 4)"
        fill="none"
        stroke="#a3a3a3"
        strokeLinecap="round"
        strokeWidth="1.5"
      />
    </svg>
  );
}

export function ic_banner_info_secondary() {
  return (
    <svg
      id="ic_banner_info_secondary"
      xmlns="http://www.w3.org/2000/svg"
      width="42"
      height="42"
      viewBox="0 0 42 42"
    >
      <rect
        id="Box"
        width="32"
        height="32"
        transform="translate(5 4.998)"
        fill="none"
      />
      <circle id="Circle" cx="21" cy="21" r="21" fill="#dc4405" />
      <g id="ic_info" transform="translate(9 9)">
        <path
          id="Vector"
          d="M10,20A10,10,0,1,0,0,10,10.029,10.029,0,0,0,10,20Z"
          transform="translate(22 22) rotate(180)"
          fill="none"
          stroke="#fff"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          id="Vector-2"
          data-name="Vector"
          d="M0,0V5"
          transform="translate(12 16) rotate(180)"
          fill="none"
          stroke="#fff"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          id="Vector-3"
          data-name="Vector"
          d="M0,0H.009"
          transform="translate(12.006 8) rotate(180)"
          fill="none"
          stroke="#fff"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
        <path
          id="Vector-4"
          data-name="Vector"
          d="M0,0H24V24H0Z"
          fill="none"
          opacity="0"
        />
      </g>
    </svg>
  );
}

export function ic_close_small() {
  return (
    <svg
      id="ic_close_small"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <rect id="Box" width="24" height="24" fill="none" />
      <g id="Icon" transform="translate(-2078.936 -713.936)">
        <line
          id="Line_1"
          data-name="Line 1"
          x2="8"
          y2="8"
          transform="translate(2086.935 721.935)"
          fill="none"
          stroke="#fff"
          strokeLinecap="round"
          strokeWidth="1"
        />
        <line
          id="Line_2"
          data-name="Line 2"
          x1="8"
          y2="8"
          transform="translate(2086.935 721.935)"
          fill="none"
          stroke="#fff"
          strokeLinecap="round"
          strokeWidth="1"
        />
      </g>
    </svg>
  );
}

export function ic_close_small_black() {
  return (
    <svg
      id="ic_close_small"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <rect id="Box" width="24" height="24" fill="none" />
      <g id="Icon" transform="translate(-2078.936 -713.936)">
        <line
          id="Line_1"
          data-name="Line 1"
          x2="8"
          y2="8"
          transform="translate(2086.935 721.935)"
          fill="none"
          stroke="#000000"
          strokeLinecap="round"
          strokeWidth="1"
        />
        <line
          id="Line_2"
          data-name="Line 2"
          x1="8"
          y2="8"
          transform="translate(2086.935 721.935)"
          fill="none"
          stroke="#000000"
          strokeLinecap="round"
          strokeWidth="1"
        />
      </g>
    </svg>
  );
}

export function ic_favourite_off() {
  return (
    <svg
      id="ic_favourite_off"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <rect id="Box" width="24" height="24" fill="none" />
      <path
        id="star"
        d="M12,17.27,18.18,21l-1.64-7.03L22,9.24l-7.19-.62L12,2,9.19,8.62,2,9.24l5.45,4.73L5.82,21Z"
        transform="translate(0 1)"
        fill="none"
        stroke="#909090"
        strokeWidth="1"
      />
    </svg>
  );
}

export function ic_favourite_on() {
  return (
    <svg
      id="ic_favourite_on"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <rect id="Box" width="24" height="24" fill="none" />
      <path
        id="star"
        d="M12,17.27,18.18,21l-1.64-7.03L22,9.24l-7.19-.62L12,2,9.19,8.62,2,9.24l5.45,4.73L5.82,21Z"
        transform="translate(0 0.5)"
        fill="#dc4405"
      />
    </svg>
  );
}

export function ic_field_hidepass() {
  return (
    <svg
      id="ic_field_hidepass"
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
    >
      <rect id="Box" width="32" height="32" fill="none" />
      <g
        id="Icon_feather-eye-off"
        data-name="Icon feather-eye-off"
        transform="translate(5.008 5.008)"
      >
        <path
          id="Path_482"
          data-name="Path 482"
          d="M16.118,18.029a8.69,8.69,0,0,1-5.126,1.778c-6.04,0-9.492-6.9-9.492-6.9A15.921,15.921,0,0,1,5.866,7.778M9.18,6.207A7.87,7.87,0,0,1,10.992,6c6.04,0,9.492,6.9,9.492,6.9a15.964,15.964,0,0,1-1.864,2.753m-5.8-.923a2.589,2.589,0,1,1-3.659-3.659"
          transform="translate(0 -1.911)"
          fill="none"
          stroke="#909090"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          id="Path_483"
          data-name="Path 483"
          d="M1.5,1.5,20.484,20.484"
          fill="none"
          stroke="#909090"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
      </g>
    </svg>
  );
}

export function ic_field_showpass() {
  return (
    <svg
      id="ic_field_showpass"
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
    >
      <rect id="Box" width="32" height="32" fill="none" />
      <g
        id="Icon_feather-eye"
        data-name="Icon feather-eye"
        transform="translate(4.951 3.555)"
      >
        <path
          id="Path_480"
          data-name="Path 480"
          d="M1.5,12.945S4.973,6,11.05,6s9.55,6.945,9.55,6.945-3.473,6.945-9.55,6.945S1.5,12.945,1.5,12.945Z"
          fill="none"
          stroke="#909090"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          id="Path_481"
          data-name="Path 481"
          d="M18.709,16.1a2.6,2.6,0,1,1-2.6-2.6A2.6,2.6,0,0,1,18.709,16.1Z"
          transform="translate(-5.055 -3.159)"
          fill="none"
          stroke="#909090"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
      </g>
    </svg>
  );
}

export function ic_filter() {
  return (
    <svg
      id="ic_filter"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <rect id="Box" width="24" height="24" fill="none" />
      <g id="filter" transform="translate(-552.111 -504.111)">
        <path
          id="Vector"
          d="M1.1,0h7.23a1.163,1.163,0,0,1,1.1,1.214V2.55a2.39,2.39,0,0,1-.548,1.4L6.518,6.253a2.082,2.082,0,0,0-.548,1.4v2.61a1.4,1.4,0,0,1-.493,1.032l-.767.546a1.117,1.117,0,0,1-1.7-1.032V7.589a2.5,2.5,0,0,0-.438-1.275L.493,3.885A2.12,2.12,0,0,1,0,2.671v-1.4A1.182,1.182,0,0,1,1.1,0Z"
          transform="translate(559.4 510.1)"
          fill="none"
          stroke="#1a1a1a"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.2"
        />
        <path
          id="Vector-2"
          data-name="Vector"
          d="M0,0H16.221V16.221H0Z"
          transform="translate(556 508)"
          fill="none"
          opacity="0"
        />
      </g>
    </svg>
  );
}

export function ic_location_call() {
  return (
    <svg
      id="ic_location_call"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <rect id="Box" width="24" height="24" fill="none" />
      <path
        id="phone"
        d="M6.218,9.924a13.419,13.419,0,0,0,5.858,5.858l1.956-1.956a.892.892,0,0,1,.907-.222,10.1,10.1,0,0,0,3.173.507A.889.889,0,0,1,19,15v3.111a.889.889,0,0,1-.889.889A15.111,15.111,0,0,1,3,3.889.889.889,0,0,1,3.889,3H7a.889.889,0,0,1,.889.889A10.1,10.1,0,0,0,8.4,7.062a.892.892,0,0,1-.222.907Z"
        transform="translate(1 1)"
        fill="#dc4405"
      />
    </svg>
  );
}

export function ic_location_directions() {
  return (
    <svg
      id="ic_location_directions"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <rect id="Box" width="24" height="24" fill="none" />
      <path
        id="directions"
        d="M14,14.5V12H10v3H8V11a1,1,0,0,1,1-1h5V7.5L17.5,11m4.21.29-9-9H12.7a1,1,0,0,0-1.41,0l-9,9a1.008,1.008,0,0,0,0,1.42l9,9a1.017,1.017,0,0,0,1.42,0l9-9A1.008,1.008,0,0,0,21.71,11.29Z"
        transform="translate(0.002 0.002)"
        fill="#dc4405"
      />
    </svg>
  );
}

export function ic_location_web() {
  return (
    <svg
      id="ic_location_web"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <rect id="Box" width="24" height="24" fill="none" />
      <g id="global" transform="translate(-171 -251)">
        <path
          id="Vector"
          d="M18,9A9,9,0,1,1,9,0,9,9,0,0,1,18,9Z"
          transform="translate(174 254)"
          fill="none"
          stroke="#dc4405"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.2"
        />
        <path
          id="Vector-2"
          data-name="Vector"
          d="M.463,0h1a22.612,22.612,0,0,0,0,16h-1"
          transform="translate(178.869 255)"
          fill="none"
          stroke="#dc4405"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.2"
        />
        <path
          id="Vector-3"
          data-name="Vector"
          d="M0,0A22.612,22.612,0,0,1,0,16"
          transform="translate(185.669 255)"
          fill="none"
          stroke="#dc4405"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.2"
        />
        <path
          id="Vector-4"
          data-name="Vector"
          d="M0,1V0A22.612,22.612,0,0,0,16,0V1"
          transform="translate(175 265.669)"
          fill="none"
          stroke="#dc4405"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.2"
        />
        <path
          id="Vector-5"
          data-name="Vector"
          d="M0,1.463a22.612,22.612,0,0,1,16,0"
          transform="translate(175 258.869)"
          fill="none"
          stroke="#dc4405"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.2"
        />
        <path
          id="Vector-6"
          data-name="Vector"
          d="M0,0H22V22H0Z"
          transform="translate(194 274) rotate(180)"
          fill="none"
          opacity="0"
        />
      </g>
    </svg>
  );
}

export function ic_maintenance_edit({
  color = '#1a1a1a',
  width = 20,
  height = 20,
}) {
  return (
    <svg
      id="ic_maintenance_edit"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox={`0 0 20 20`}
    >
      <rect id="Box" width={width} height={height} fill="none" />
      <g id="edit-2" transform="translate(4.528 4)">
        <path
          id="Vector"
          d="M5.633.875.64,6.159a1.854,1.854,0,0,0-.407.87L.008,9a.929.929,0,0,0,1.137,1.076L3.1,9.74a1.746,1.746,0,0,0,.845-.456L8.94,4A1.981,1.981,0,0,0,8.849.778,1.982,1.982,0,0,0,5.633.875Z"
          transform="translate(0.606 0)"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        />
        <path
          id="Vector-2"
          data-name="Vector"
          d="M0,0A3.725,3.725,0,0,0,3.314,3.131"
          transform="translate(5.406 1.757)"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        />
        <path
          id="Vector-3"
          data-name="Vector"
          d="M0,0H10.945"
          transform="translate(0 12.063)"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        />
      </g>
    </svg>
  );
}

export function ic_menu_about() {
  return (
    <svg
      id="ic_menu_about"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <rect id="Box" width="24" height="24" fill="none" />
      <g id="icon">
        <path
          id="Vector"
          d="M9,18A9,9,0,1,0,0,9,9.026,9.026,0,0,0,9,18Z"
          transform="translate(21 21) rotate(180)"
          fill="none"
          stroke="#909090"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.2"
        />
        <path
          id="Vector-2"
          data-name="Vector"
          d="M0,0V4.5"
          transform="translate(12 15.6) rotate(180)"
          fill="none"
          stroke="#909090"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.2"
        />
        <path
          id="Vector-3"
          data-name="Vector"
          d="M0,0H.008"
          transform="translate(12.006 8.4) rotate(180)"
          fill="none"
          stroke="#909090"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
      </g>
    </svg>
  );
}

export function ic_menu_dealers() {
  return (
    <svg
      id="ic_menu_dealers"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <rect id="Box" width="24" height="24" fill="none" />
      <g id="Icon">
        <path
          id="Vector"
          d="M15.368.162,5.751,2.573A4.786,4.786,0,0,0,2.574,5.75L.162,15.367c-.726,2.906,1.056,4.7,3.971,3.971l9.617-2.4a4.825,4.825,0,0,0,3.177-3.177l2.412-9.627C20.065,1.227,18.274-.565,15.368.162Z"
          transform="translate(2.25 2.322)"
          fill="none"
          stroke="#909090"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.2"
        />
        <path
          id="Vector-2"
          data-name="Vector"
          d="M6,3A3,3,0,1,1,3,0,3,3,0,0,1,6,3Z"
          transform="translate(9 9.072)"
          fill="none"
          stroke="#909090"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.2"
        />
      </g>
    </svg>
  );
}

export function ic_menu_equipment() {
  return (
    <svg
      id="ic_menu_equipment"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <rect id="Box" width="24" height="24" fill="none" />
      <path
        id="Logo"
        d="M21197.7,22166.4v-.432c0-4.619,5.158-8.381,11.5-8.381s11.5,3.75,11.5,8.381v.432c0,4.617-5.154,8.383-11.5,8.383S21197.7,22171.018,21197.7,22166.4Zm.473-2.049a6.964,6.964,0,0,0,1.35,6.043c.168.232.363.545.49.756a11.97,11.97,0,0,0,6.08,3.111,13.966,13.966,0,0,1-1.828-.83,9.9,9.9,0,0,1-5.414-4.236,13.566,13.566,0,0,0,2.545,2.207,14.389,14.389,0,0,0,7.807,2.123,12.992,12.992,0,0,0,8.871-3.07c.744-.705,2.176-2.652,2.186-3.863h0s0-.008,0-.012h0a6.1,6.1,0,0,0-1.588-4.76,9.9,9.9,0,0,0-2.066-1.691h0a14.172,14.172,0,0,0-7.4-1.99C21203.895,22158.139,21199.426,22160.789,21198.172,22164.352Zm22.088,2.236.006.029c0,2.186-1.395,4.172-3.582,5.57a16.978,16.978,0,0,1-1.8,1.285c3.363-1.42,5.623-4.059,5.623-7.072v-.205A2.492,2.492,0,0,1,21220.26,22166.588Zm-22.107-2.326a8.492,8.492,0,0,1,3.6-4.162c0-.008,0-.01.01-.02l1.184-.918A8.7,8.7,0,0,0,21198.152,22164.262Zm.9,1.059c0-3.705,4.545-6.715,10.146-6.715a14.23,14.23,0,0,1,5.406,1.031,9.711,9.711,0,0,1,2.953,1.9l0-.01c.02.023.051.057.086.094.131.127.252.258.363.389.141.16.273.32.395.486a3.318,3.318,0,0,1,.545.9,4.4,4.4,0,0,1,.445,1.9,4.51,4.51,0,0,1-.381,1.795l.008-.008-.049.119a3.609,3.609,0,0,1-.35.633,6.28,6.28,0,0,1-.686.9,8.527,8.527,0,0,1-2.6,1.938,13.731,13.731,0,0,1-6.137,1.367C21203.611,22172.037,21199.055,22169.027,21199.055,22165.32Zm6.629,1.758c-.539,1.637-.973,2.959-1.025,3.107a15.252,15.252,0,0,0,9.049.006c-.666-.523-6.5-5.1-6.58-5.17l-.014-.012-.082-.143c.033-.012.033-.012.033-.025s0-.012.014-.023l.07-.121.012-.012c.105-.08,5.771-3.934,6.486-4.418a14.757,14.757,0,0,0-4.375-.643c-.346,0-.707.012-1.064.037l-.066-.008Zm.975-7.584a.082.082,0,0,1,.025.059v.037l0,0a.011.011,0,0,1,0,.01.033.033,0,0,1-.021.043l-3.373,10.008a.48.48,0,0,1-.105.156.011.011,0,0,1,0,.01.044.044,0,0,1-.037.027.671.671,0,0,1-.113.08l1.584.25v0c-.3-.234.02-.4.053-.641a79.818,79.818,0,0,1,2.006-7.916c.121-.387.379-1.611.5-2.08l-.52-.061A.031.031,0,0,1,21206.658,22159.494Zm12.008,6.668a5.882,5.882,0,0,1-3.055,3.531.039.039,0,0,0,.027.018.16.16,0,0,0,.107.051l.072-.014a.072.072,0,0,1,.035.008,7.081,7.081,0,0,0,2.318-1.939v-.014h.012a2.571,2.571,0,0,0,.719-.584,4.516,4.516,0,0,0,.441-1.922,4.3,4.3,0,0,0-.361-1.709A9.777,9.777,0,0,1,21218.666,22166.162Zm-15.512,3.6a.414.414,0,0,0,.074-.119l3.361-9.959a14.644,14.644,0,0,0-2.414.652c-2.705,1.055-4.449,2.914-4.449,4.941a3.748,3.748,0,0,0,.268,1.379c.008.018.012.031.02.049l.014.021h0A6.323,6.323,0,0,0,21203.154,22169.758Zm12.281-8.682-.014.012c-.049.035-5.357,3.586-5.635,3.768l-.072.107.061.105c.225.191,5.055,4,5.746,4.551a.025.025,0,0,1,.012,0c2-1.105,3.141-2.687,3.141-4.344,0-1.617-1.113-3.186-3.051-4.289A.594.594,0,0,0,21215.436,22161.076Zm-8.225,3.68-.051.086.063.109a.638.638,0,0,1,.061.049l.262.01s1.727,1.283,2.9,2.051a16.33,16.33,0,0,0,3.746,1.617c-1.7-1.34-4.373-3.455-4.465-3.547l-.014-.014-.084-.143a.038.038,0,0,1,0-.049l.035-.053-2.41-.146A.453.453,0,0,0,21207.211,22164.756Zm-7.328-1.828.014.008a3.379,3.379,0,0,0-.148,3.215,3.677,3.677,0,0,1-.105-.877,4.337,4.337,0,0,1,1.34-3.029,6.8,6.8,0,0,1,1.8-1.516,12.477,12.477,0,0,1,3.047-1.211l.721-.158a.015.015,0,0,0,0,.006,15.136,15.136,0,0,1,2.719-.244,13,13,0,0,1,6.008,1.387c.25.125.492.26.725.4.025.014.051.027.08.045a6.3,6.3,0,0,1,1.549,1.344c.1.115.188.23.266.344a1.31,1.31,0,0,0-.234-.895,9.16,9.16,0,0,0-.779-.674,12.906,12.906,0,0,0-7.684-2.34C21204.967,22158.736,21201.338,22160.475,21199.883,22162.928Z"
        transform="translate(-21197.199 -22154.186)"
        fill="#909090"
      />
    </svg>
  );
}

export function ic_menu_geofence() {
  return (
    <svg
      id="ic_menu_geofence"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <rect id="Box" width="24" height="24" fill="none" />
      <g id="icon" transform="translate(-5171 -1649.5)">
        <path
          id="Path"
          d="M5176,1666l-3,6h20l-3-6"
          transform="translate(0 -1)"
          fill="none"
          stroke="#909090"
          strokeLinecap="round"
          strokeWidth="1.2"
        />
        <g id="Pin" transform="translate(0 1)">
          <path
            id="Path-2"
            data-name="Path"
            d="M5188,1656c0,3.7-6,9.75-6,9.75s-6-6.047-6-9.75a6,6,0,0,1,12,0Z"
            transform="translate(1 1)"
            fill="none"
            stroke="#909090"
            strokeLinecap="round"
            strokeWidth="1.2"
          />
          <circle
            id="Path-3"
            data-name="Path"
            cx="1.875"
            cy="1.875"
            r="1.875"
            transform="translate(5181.125 1655.125)"
            fill="none"
            stroke="#909090"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.2"
          />
        </g>
      </g>
    </svg>
  );
}

export function ic_menu_page() {
  return (
    <svg
      id="ic_menu_page"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <rect id="Box" width="24" height="24" fill="none" />
      <g id="icon" transform="translate(-491.6 -251)">
        <g
          id="Vector"
          transform="translate(495.1 253)"
          fill="none"
          stroke="#909090"
          strokeWidth="1.2"
        >
          <path
            d="M.5,0H14a3,3,0,0,1,3,3V19.5a.5.5,0,0,1-.5.5H.5a.5.5,0,0,1-.5-.5V.5A.5.5,0,0,1,.5,0Z"
            stroke="none"
          />
          <path
            d="M.7.6H14A2.4,2.4,0,0,1,16.4,3V19.3a.1.1,0,0,1-.1.1H.7a.1.1,0,0,1-.1-.1V.7A.1.1,0,0,1,.7.6Z"
            fill="none"
          />
        </g>
        <path
          id="Vector-2"
          data-name="Vector"
          d="M0,0V1.8A1.805,1.805,0,0,0,1.8,3.6H3.6"
          transform="translate(505.35 256.25)"
          fill="none"
          stroke="#909090"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.2"
        />
        <path
          id="Vector-3"
          data-name="Vector"
          d="M0,0H4.119"
          transform="translate(499.461 263.9)"
          fill="none"
          stroke="#909090"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.2"
        />
        <path
          id="Vector-4"
          data-name="Vector"
          d="M0,0H8.238"
          transform="translate(499.461 267.5)"
          fill="none"
          stroke="#909090"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.2"
        />
      </g>
    </svg>
  );
}

export function ic_menu_resources() {
  return (
    <svg
      id="ic_menu_resources"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <rect id="Box" width="24" height="24" fill="none" />
      <g id="Icon" transform="translate(1.82 1.128)">
        <path
          id="Vector"
          d="M18.249,2.476,14.784,15.949H-.817L3.68,1.406A1.975,1.975,0,0,1,5.556,0H16.338a1.957,1.957,0,0,1,1.815,1.22A1.968,1.968,0,0,1,18.249,2.476Z"
          transform="translate(0.997 3.739)"
          fill="none"
          stroke="#909090"
          strokeWidth="1.2"
        />
        <path
          id="Vector-2"
          data-name="Vector"
          d="M0,14.146H4.19a1.952,1.952,0,0,0,1.937-2.1L5.26,0"
          transform="translate(14.048 5.542)"
          fill="none"
          stroke="#909090"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.2"
        />
        <path
          id="Vector-3"
          data-name="Vector"
          d="M0,3.819.912,0"
          transform="translate(8.507 2.059)"
          fill="none"
          stroke="#909090"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.2"
        />
        <path
          id="Vector-4"
          data-name="Vector"
          d="M0,3.837.824,0"
          transform="translate(14.381 2.05)"
          fill="none"
          stroke="#909090"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.2"
        />
        <path
          id="Vector-5"
          data-name="Vector"
          d="M0,0H7.013"
          transform="translate(6.772 10.847)"
          fill="none"
          stroke="#909090"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.2"
        />
        <path
          id="Vector-6"
          data-name="Vector"
          d="M0,0H7.013"
          transform="translate(5.895 14.383)"
          fill="none"
          stroke="#909090"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.2"
        />
      </g>
    </svg>
  );
}

export function ic_more_info() {
  return (
    <svg
      id="ic_more_info"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <rect id="Box" width="24" height="24" fill="none" />
      <g id="icon">
        <path
          id="Vector"
          d="M11,22A11,11,0,1,0,0,11,11.032,11.032,0,0,0,11,22Z"
          transform="translate(23 23) rotate(180)"
          fill="#dc4405"
        />
        <path
          id="Vector-2"
          data-name="Vector"
          d="M0,0V5.576"
          transform="translate(12 16.676) rotate(180)"
          fill="none"
          stroke="#fff"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          id="Vector-3"
          data-name="Vector"
          d="M0,0H.008"
          transform="translate(12.006 8.4) rotate(180)"
          fill="none"
          stroke="#fff"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
      </g>
    </svg>
  );
}

export function ic_nav_back() {
  return (
    <svg
      id="ic_nav_back"
      xmlns="http://www.w3.org/2000/svg"
      width="48"
      height="48"
      viewBox="0 0 48 48"
    >
      <rect id="Box" width="48" height="48" fill="none" />
      <path
        id="ic_nav_up"
        d="M16.465,8.482H1.483"
        transform="translate(15.518 15.518)"
        fill="none"
        stroke="#1a1a1a"
        strokeLinecap="round"
        strokeWidth="2"
      />
      <path
        id="Path_470"
        data-name="Path 470"
        d="M23.676,16.018,16.2,23.748l7.477,7.73"
        transform="translate(0.324 0.252)"
        fill="none"
        stroke="#1a1a1a"
        strokeLinecap="round"
        strokeWidth="2"
      />
    </svg>
  );
}

export function geofenceic_nav_back() {
  return (
    <svg
      id="ic_nav_back"
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
    >
      <rect id="Box" width="32" height="32" fill="none" />
      <path
        id="ic_nav_up"
        d="M16.465,8.482H1.483"
        transform="translate(7.518 7.518)"
        fill="none"
        stroke="#1a1a1a"
        strokeLinecap="round"
        strokeWidth="2"
      />
      <path
        id="Path_470"
        data-name="Path 470"
        d="M23.676,16.018,16.2,23.748l7.477,7.73"
        transform="translate(-7.676 -7.748)"
        fill="none"
        stroke="#1a1a1a"
        strokeLinecap="round"
        strokeWidth="2"
      />
    </svg>
  );
}

export function ic_nav_close() {
  return (
    <svg
      id="ic_nav_close"
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
    >
      <rect id="Box" width="32" height="32" fill="none" />
      <g id="Icon" transform="translate(-2076.936 -711.936)">
        <line
          id="Line_1"
          data-name="Line 1"
          x2="12"
          y2="12"
          transform="translate(2086.935 721.935)"
          fill="none"
          stroke="#1a1a1a"
          strokeLinecap="round"
          strokeWidth="2"
        />
        <line
          id="Line_2"
          data-name="Line 2"
          x1="12"
          y2="12"
          transform="translate(2086.935 721.935)"
          fill="none"
          stroke="#1a1a1a"
          strokeLinecap="round"
          strokeWidth="2"
        />
      </g>
    </svg>
  );
}

export function ic_nav_info() {
  return (
    <svg
      id="ic_nav_info"
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
    >
      <rect id="Box" width="32" height="32" fill="none" />
      <g id="icon" transform="translate(3 3)">
        <path
          id="Vector"
          d="M11,22A11,11,0,1,0,0,11,11.032,11.032,0,0,0,11,22Z"
          transform="translate(24 24) rotate(180)"
          fill="none"
          stroke="#1a1a1a"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          id="Vector-2"
          data-name="Vector"
          d="M0,0V5"
          transform="translate(13 17) rotate(180)"
          fill="none"
          stroke="#1a1a1a"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          id="Vector-3"
          data-name="Vector"
          d="M0,0H.009"
          transform="translate(13.007 9) rotate(180)"
          fill="none"
          stroke="#1a1a1a"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
      </g>
    </svg>
  );
}

export function ic_res_fault_code() {
  return (
    <svg
      id="ic_res_fault_code"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <g id="danger" transform="translate(-428 -252)">
        <path
          id="Vector"
          d="M0,0V5"
          transform="translate(440 261)"
          fill="none"
          stroke="#909090"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.2"
        />
        <path
          id="Vector-2"
          data-name="Vector"
          d="M10,18.817H3.939c-3.47,0-4.92-2.48-3.24-5.51l3.12-5.62,2.94-5.28c1.78-3.21,4.7-3.21,6.48,0l2.94,5.29,3.12,5.62c1.68,3.03.22,5.51-3.24,5.51H10Z"
          transform="translate(430.001 254.592)"
          fill="none"
          stroke="#909090"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.2"
        />
        <path
          id="Vector-3"
          data-name="Vector"
          d="M0,0H.009"
          transform="translate(439.995 269)"
          fill="none"
          stroke="#909090"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
        <path
          id="Vector-4"
          data-name="Vector"
          d="M0,0H24V24H0Z"
          transform="translate(428 252)"
          fill="none"
          opacity="0"
        />
      </g>
    </svg>
  );
}

export function ic_res_geofences() {
  return (
    <svg
      id="ic_res_geofences"
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
    >
      <rect id="Box" width="32" height="32" fill="none" />
      <g id="icon" transform="translate(-5168 -1646.45)">
        <path
          id="Path"
          d="M5176.3,1666l-3.3,6.6h22l-3.3-6.6"
          transform="translate(0 0.3)"
          fill="none"
          stroke="#909090"
          strokeLinecap="round"
          strokeWidth="1.2"
        />
        <g id="Pin" transform="translate(5177.4 1652)">
          <path
            id="Path-2"
            data-name="Path"
            d="M5189.2,1656.6c0,4.073-6.6,10.725-6.6,10.725s-6.6-6.652-6.6-10.725a6.6,6.6,0,0,1,13.2,0Z"
            transform="translate(-5176 -1650)"
            fill="none"
            stroke="#909090"
            strokeLinecap="round"
            strokeWidth="1.2"
          />
          <circle
            id="Path-3"
            data-name="Path"
            cx="2.063"
            cy="2.063"
            r="2.063"
            transform="translate(4.537 4.537)"
            fill="none"
            stroke="#909090"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.2"
          />
        </g>
      </g>
    </svg>
  );
}

export function ic_res_maint_schedule() {
  return (
    <svg
      id="ic_res_maint_schedule"
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
    >
      <rect id="Box" width="32" height="32" fill="none" />
      <g id="calendar-2" transform="translate(-168 -248)">
        <path
          id="Vector"
          d="M0,0V3"
          transform="translate(180 254)"
          fill="none"
          stroke="#909090"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.2"
        />
        <path
          id="Vector-2"
          data-name="Vector"
          d="M0,0V3"
          transform="translate(188 254)"
          fill="none"
          stroke="#909090"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.2"
        />
        <path
          id="Vector-3"
          data-name="Vector"
          d="M0,0H17"
          transform="translate(175.5 261.09)"
          fill="none"
          stroke="#909090"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.2"
        />
        <path
          id="Vector-4"
          data-name="Vector"
          d="M18,5v8.5c0,3-1.5,5-5,5H5c-3.5,0-5-2-5-5V5C0,2,1.5,0,5,0h8C16.5,0,18,2,18,5Z"
          transform="translate(175 255.5)"
          fill="none"
          stroke="#909090"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.2"
        />
      </g>
    </svg>
  );
}

export function ic_res_manuals() {
  return (
    <svg
      id="ic_res_manuals"
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
    >
      <g id="ic_sub_manuals">
        <rect id="Box" width="32" height="32" fill="none" />
        <g id="book" transform="translate(6 6.662)">
          <path
            id="Vector"
            d="M20,14.078V2.008A1.97,1.97,0,0,0,17.83.018h-.06a18.851,18.851,0,0,0-7.07,2.37l-.17.11a1.108,1.108,0,0,1-1.06,0l-.25-.15A18.757,18.757,0,0,0,2.16.008,1.967,1.967,0,0,0,0,2v12.08a2.055,2.055,0,0,0,1.74,1.98l.29.04a25.693,25.693,0,0,1,7.44,2.44l.04.02a1.08,1.08,0,0,0,.96,0,25.461,25.461,0,0,1,7.46-2.46l.33-.04A2.055,2.055,0,0,0,20,14.078Z"
            fill="none"
            stroke="#909090"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.2"
          />
          <path
            id="Vector-2"
            data-name="Vector"
            d="M0,0V15"
            transform="translate(10 2.828)"
            fill="none"
            stroke="#909090"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.2"
          />
          <path
            id="Vector-3"
            data-name="Vector"
            d="M2.25,0H0"
            transform="translate(3.5 5.828)"
            fill="none"
            stroke="#909090"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.2"
          />
          <path
            id="Vector-4"
            data-name="Vector"
            d="M3,0H0"
            transform="translate(3.5 8.828)"
            fill="none"
            stroke="#909090"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.2"
          />
        </g>
      </g>
    </svg>
  );
}

export function ic_res_restart() {
  return (
    <svg
      id="ic_res_restart"
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
    >
      <rect id="Box" width="32" height="32" fill="none" />
      <g id="key" transform="translate(-680 -184)">
        <path
          id="Vector"
          d="M17.793,12.923a7.575,7.575,0,0,1-7.6,1.87l-4.71,4.7a1.935,1.935,0,0,1-1.49.49l-2.18-.3a1.888,1.888,0,0,1-1.5-1.5L.013,16a2.015,2.015,0,0,1,.49-1.49l4.7-4.7a7.571,7.571,0,1,1,12.59,3.11Z"
          transform="translate(685.997 190.008)"
          fill="none"
          stroke="#909090"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.2"
        />
        <path
          id="Vector-2"
          data-name="Vector"
          d="M0,0,2.3,2.3"
          transform="translate(690.89 205.49)"
          fill="none"
          stroke="#909090"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.2"
        />
        <path
          id="Vector-3"
          data-name="Vector"
          d="M3,1.5A1.5,1.5,0,1,1,1.5,0,1.5,1.5,0,0,1,3,1.5Z"
          transform="translate(697 196)"
          fill="none"
          stroke="#909090"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.2"
        />
        <path
          id="Vector-4"
          data-name="Vector"
          d="M0,0H24V24H0Z"
          transform="translate(708 212) rotate(180)"
          fill="none"
          opacity="0"
        />
      </g>
    </svg>
  );
}

export function ic_res_track_maintenance() {
  return (
    <svg
      id="ic_res_track_maintenance"
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
    >
      <g id="ic_sub_maint_schedule">
        <rect id="Box" width="32" height="32" fill="none" />
        <g id="calendar-search" transform="translate(7 6)">
          <path
            id="Vector"
            d="M0,0V3"
            transform="translate(5)"
            fill="none"
            stroke="#1a1a1a"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.2"
          />
          <path
            id="Vector-2"
            data-name="Vector"
            d="M0,0V3"
            transform="translate(13)"
            fill="none"
            stroke="#1a1a1a"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.2"
          />
          <path
            id="Vector-3"
            data-name="Vector"
            d="M0,0H17"
            transform="translate(0.5 6.09)"
            fill="none"
            stroke="#1a1a1a"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.2"
          />
          <path
            id="Vector-4"
            data-name="Vector"
            d="M18,5v8.5c0,3-1.5,5-5,5H5c-3.5,0-5-2-5-5V5C0,2,1.5,0,5,0h8C16.5,0,18,2,18,5Z"
            transform="translate(0 1.5)"
            fill="none"
            stroke="#1a1a1a"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.2"
          />
          <path
            id="Icon_metro-wrench"
            data-name="Icon metro-wrench"
            d="M2.752,9.137,6.591,5.575A2.483,2.483,0,0,1,9.5,2.035L8.07,3.469a.553.553,0,0,0,0,.78l.875.875a.553.553,0,0,0,.78,0l1.434-1.434A2.483,2.483,0,0,1,7.619,6.6L3.945,10.345a.5.5,0,0,1-.749.029l-.473-.487a.5.5,0,0,1,.029-.749Z"
            transform="translate(2.082 6.273)"
            fill="#1a1a1a"
          />
        </g>
      </g>
    </svg>
  );
}

export function ic_res_video() {
  return (
    <svg
      id="ic_res_video"
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
    >
      <rect
        id="Rectangle_73"
        data-name="Rectangle 73"
        width="32"
        height="32"
        fill="none"
      />
      <g id="video" transform="translate(6 7.58)">
        <path
          id="Vector"
          d="M10.53,16.84H4.21C1.05,16.84,0,14.74,0,12.63V4.21C0,1.05,1.05,0,4.21,0h6.32c3.16,0,4.21,1.05,4.21,4.21v8.42C14.74,15.79,13.68,16.84,10.53,16.84Z"
          fill="none"
          stroke="#909090"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.2"
        />
        <path
          id="Vector-2"
          data-name="Vector"
          d="M2.78,10.667,0,8.717V2.407L2.78.457c1.36-.95,2.48-.37,2.48,1.3v7.62C5.26,11.047,4.14,11.627,2.78,10.667Z"
          transform="translate(14.74 2.853)"
          fill="none"
          stroke="#909090"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.2"
        />
        <path
          id="Vector-3"
          data-name="Vector"
          d="M3,1.5A1.5,1.5,0,1,1,1.5,0,1.5,1.5,0,0,1,3,1.5Z"
          transform="translate(8 4.42)"
          fill="none"
          stroke="#909090"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.2"
        />
      </g>
    </svg>
  );
}

export function ic_res_warranty_info() {
  return (
    <svg
      id="ic_res_warranty_info"
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
    >
      <g id="ic_sub_warranty_inf">
        <rect id="Box" width="32" height="32" fill="none" />
        <g id="shield-tick" transform="translate(7.41 5.998)">
          <path
            id="Vector"
            d="M7.08.233,2.09,2.113A3.47,3.47,0,0,0,0,5.122v7.43a4.862,4.862,0,0,0,1.73,3.44l4.3,3.21a4.552,4.552,0,0,0,5.14,0l4.3-3.21a4.862,4.862,0,0,0,1.73-3.44V5.122A3.472,3.472,0,0,0,15.11,2.1L10.12.233A5.085,5.085,0,0,0,7.08.233Z"
            fill="none"
            stroke="#909090"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.2"
          />
          <path
            id="Vector-2"
            data-name="Vector"
            d="M0,2.69,1.61,4.3,5.91,0"
            transform="translate(5.64 7.182)"
            fill="none"
            stroke="#909090"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.2"
          />
        </g>
      </g>
    </svg>
  );
}

export function ic_search() {
  return (
    <svg
      id="ic_search"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <rect id="Box" width="24" height="24" fill="none" />
      <g id="Icon" transform="translate(4.438 4.438)">
        <path
          id="Path_421"
          data-name="Path 421"
          d="M11.63,5.815A5.815,5.815,0,1,1,5.815,0,5.815,5.815,0,0,1,11.63,5.815Z"
          fill="none"
          stroke="#1a1a1a"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          id="Path_422"
          data-name="Path 422"
          d="M5.2,5.2,0,0"
          transform="translate(9.922 9.922)"
          fill="none"
          stroke="#1a1a1a"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
      </g>
    </svg>
  );
}

export function ic_switch_list() {
  return (
    <svg
      id="ic_switch_list"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <rect id="Box" width="24" height="24" fill="none" />
      <g id="Icon" transform="translate(408 -620) rotate(90)">
        <path
          id="Vector"
          d="M6,13.425V1.575C6,.45,5.553,0,4.424,0H1.576C.447,0,0,.45,0,1.575v11.85C0,14.55.447,15,1.576,15H4.424C5.553,15,6,14.55,6,13.425Z"
          transform="translate(624.325 388.5)"
          fill="none"
          stroke="#909090"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.2"
        />
        <path
          id="Vector-2"
          data-name="Vector"
          d="M6,13.425V1.575C6,.45,5.553,0,4.424,0H1.576C.455,0,0,.45,0,1.575v11.85C0,14.55.447,15,1.576,15H4.424C5.553,15,6,14.55,6,13.425Z"
          transform="translate(633.675 388.5)"
          fill="none"
          stroke="#909090"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.2"
        />
        <path
          id="Vector-3"
          data-name="Vector"
          d="M0,0H24V24H0Z"
          transform="translate(620 384)"
          fill="none"
          opacity="0"
        />
      </g>
    </svg>
  );
}

export function ic_switch_map() {
  return (
    <svg
      id="ic_switch_map"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <rect id="Box" width="24" height="24" fill="none" />
      <g id="map" transform="translate(-684 -252)">
        <path
          id="Vector"
          d="M0,4.442v9.73c0,1.9,1.35,2.68,2.99,1.74l2.35-1.34a2.232,2.232,0,0,1,1.89-.05l5.25,2.63a2.268,2.268,0,0,0,1.89-.05l4.33-2.48a2.24,2.24,0,0,0,1.01-1.74V3.152c0-1.9-1.35-2.68-2.99-1.74l-2.35,1.34a2.232,2.232,0,0,1-1.89.05L7.23.182a2.268,2.268,0,0,0-1.89.05L1.01,2.712A2.21,2.21,0,0,0,0,4.442Z"
          transform="translate(686.29 255.338)"
          fill="none"
          stroke="#909090"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.2"
        />
        <path
          id="Vector-2"
          data-name="Vector"
          d="M0,0V13"
          transform="translate(692.56 256)"
          fill="none"
          stroke="#909090"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.2"
        />
        <path
          id="Vector-3"
          data-name="Vector"
          d="M0,0V13.38"
          transform="translate(699.73 258.62)"
          fill="none"
          stroke="#909090"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.2"
        />
        <path
          id="Vector-4"
          data-name="Vector"
          d="M0,0H24V24H0Z"
          transform="translate(708 276) rotate(180)"
          fill="none"
          opacity="0"
        />
      </g>
    </svg>
  );
}

export function ic_tele_battery_critical() {
  return (
    <svg
      id="ic_tele_battery_critical"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <rect id="Box" width="24" height="24" fill="none" />
      <path
        id="Icon_awesome-car-battery"
        data-name="Icon awesome-car-battery"
        d="M19.763,7.135H18.445V5.159a.659.659,0,0,0-.659-.659H13.834a.659.659,0,0,0-.659.659V7.135H7.905V5.159A.659.659,0,0,0,7.246,4.5H3.294a.659.659,0,0,0-.659.659V7.135H1.318A1.318,1.318,0,0,0,0,8.453v10.54A1.318,1.318,0,0,0,1.318,20.31H19.763a1.318,1.318,0,0,0,1.318-1.318V8.453A1.318,1.318,0,0,0,19.763,7.135Zm-11.858,5.6a.329.329,0,0,1-.329.329H2.964a.329.329,0,0,1-.329-.329v-.659a.329.329,0,0,1,.329-.329H7.576a.329.329,0,0,1,.329.329Zm10.54,0a.329.329,0,0,1-.329.329H16.469v1.647a.329.329,0,0,1-.329.329h-.659a.329.329,0,0,1-.329-.329V13.064H13.5a.329.329,0,0,1-.329-.329v-.659a.329.329,0,0,1,.329-.329h1.647V10.1a.329.329,0,0,1,.329-.329h.659a.329.329,0,0,1,.329.329v1.647h1.647a.329.329,0,0,1,.329.329Z"
        transform="translate(1.459 -0.406)"
        fill="#ff0700"
      />
    </svg>
  );
}

export function ic_tele_battery_critical_small() {
  return (
    <svg
      id="ic_tele_battery_normal_small"
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
    >
      <rect id="Box" width="16" height="16" fill="none" />
      <path
        id="Icon_awesome-car-battery"
        data-name="Icon awesome-car-battery"
        d="M13.783,6.338h-.919V4.959A.459.459,0,0,0,12.4,4.5H9.648a.459.459,0,0,0-.459.459V6.338H5.513V4.959A.459.459,0,0,0,5.054,4.5H2.3a.459.459,0,0,0-.459.459V6.338H.919A.919.919,0,0,0,0,7.257v7.351a.919.919,0,0,0,.919.919H13.783a.919.919,0,0,0,.919-.919V7.257A.919.919,0,0,0,13.783,6.338Zm-8.27,3.905a.23.23,0,0,1-.23.23H2.067a.23.23,0,0,1-.23-.23V9.783a.23.23,0,0,1,.23-.23H5.283a.23.23,0,0,1,.23.23Zm7.351,0a.23.23,0,0,1-.23.23H11.486v1.149a.23.23,0,0,1-.23.23H10.8a.23.23,0,0,1-.23-.23V10.472H9.418a.23.23,0,0,1-.23-.23V9.783a.23.23,0,0,1,.23-.23h1.149V8.405a.23.23,0,0,1,.23-.23h.459a.23.23,0,0,1,.23.23V9.554h1.149a.23.23,0,0,1,.23.23Z"
        transform="translate(0.676 -1.805)"
        fill="#ff0700"
      />
    </svg>
  );
}

export function ic_tele_battery_normal() {
  return (
    <svg
      id="ic_tele_battery_normal"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <rect id="Box" width="24" height="24" fill="none" />
      <path
        id="Icon_awesome-car-battery"
        data-name="Icon awesome-car-battery"
        d="M19.763,7.135H18.445V5.159a.659.659,0,0,0-.659-.659H13.834a.659.659,0,0,0-.659.659V7.135H7.905V5.159A.659.659,0,0,0,7.246,4.5H3.294a.659.659,0,0,0-.659.659V7.135H1.318A1.318,1.318,0,0,0,0,8.453v10.54A1.318,1.318,0,0,0,1.318,20.31H19.763a1.318,1.318,0,0,0,1.318-1.318V8.453A1.318,1.318,0,0,0,19.763,7.135Zm-11.858,5.6a.329.329,0,0,1-.329.329H2.964a.329.329,0,0,1-.329-.329v-.659a.329.329,0,0,1,.329-.329H7.576a.329.329,0,0,1,.329.329Zm10.54,0a.329.329,0,0,1-.329.329H16.469v1.647a.329.329,0,0,1-.329.329h-.659a.329.329,0,0,1-.329-.329V13.064H13.5a.329.329,0,0,1-.329-.329v-.659a.329.329,0,0,1,.329-.329h1.647V10.1a.329.329,0,0,1,.329-.329h.659a.329.329,0,0,1,.329.329v1.647h1.647a.329.329,0,0,1,.329.329Z"
        transform="translate(1.459 -0.406)"
        fill="#1aad7f"
      />
    </svg>
  );
}

export function ic_tele_battery_normal_small() {
  return (
    <svg
      id="ic_tele_battery_normal_small"
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
    >
      <rect id="Box" width="16" height="16" fill="none" />
      <path
        id="Icon_awesome-car-battery"
        data-name="Icon awesome-car-battery"
        d="M13.783,6.338h-.919V4.959A.459.459,0,0,0,12.4,4.5H9.648a.459.459,0,0,0-.459.459V6.338H5.513V4.959A.459.459,0,0,0,5.054,4.5H2.3a.459.459,0,0,0-.459.459V6.338H.919A.919.919,0,0,0,0,7.257v7.351a.919.919,0,0,0,.919.919H13.783a.919.919,0,0,0,.919-.919V7.257A.919.919,0,0,0,13.783,6.338Zm-8.27,3.905a.23.23,0,0,1-.23.23H2.067a.23.23,0,0,1-.23-.23V9.783a.23.23,0,0,1,.23-.23H5.283a.23.23,0,0,1,.23.23Zm7.351,0a.23.23,0,0,1-.23.23H11.486v1.149a.23.23,0,0,1-.23.23H10.8a.23.23,0,0,1-.23-.23V10.472H9.418a.23.23,0,0,1-.23-.23V9.783a.23.23,0,0,1,.23-.23h1.149V8.405a.23.23,0,0,1,.23-.23h.459a.23.23,0,0,1,.23.23V9.554h1.149a.23.23,0,0,1,.23.23Z"
        transform="translate(0.676 -1.805)"
        fill="#1aad7f"
      />
    </svg>
  );
}

export function ic_tele_battery_warning() {
  return (
    <svg
      id="ic_tele_battery_warning"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <rect id="Box" width="24" height="24" fill="none" />
      <path
        id="Icon_awesome-car-battery"
        data-name="Icon awesome-car-battery"
        d="M19.763,7.135H18.445V5.159a.659.659,0,0,0-.659-.659H13.834a.659.659,0,0,0-.659.659V7.135H7.905V5.159A.659.659,0,0,0,7.246,4.5H3.294a.659.659,0,0,0-.659.659V7.135H1.318A1.318,1.318,0,0,0,0,8.453v10.54A1.318,1.318,0,0,0,1.318,20.31H19.763a1.318,1.318,0,0,0,1.318-1.318V8.453A1.318,1.318,0,0,0,19.763,7.135Zm-11.858,5.6a.329.329,0,0,1-.329.329H2.964a.329.329,0,0,1-.329-.329v-.659a.329.329,0,0,1,.329-.329H7.576a.329.329,0,0,1,.329.329Zm10.54,0a.329.329,0,0,1-.329.329H16.469v1.647a.329.329,0,0,1-.329.329h-.659a.329.329,0,0,1-.329-.329V13.064H13.5a.329.329,0,0,1-.329-.329v-.659a.329.329,0,0,1,.329-.329h1.647V10.1a.329.329,0,0,1,.329-.329h.659a.329.329,0,0,1,.329.329v1.647h1.647a.329.329,0,0,1,.329.329Z"
        transform="translate(1.459 -0.406)"
        fill="#e88f25"
      />
    </svg>
  );
}

export function ic_tele_battery_warning_small() {
  return (
    <svg
      id="ic_tele_battery_warning_small"
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
    >
      <rect id="Box" width="16" height="16" fill="none" />
      <path
        id="Icon_awesome-car-battery"
        data-name="Icon awesome-car-battery"
        d="M13.783,6.338h-.919V4.959A.459.459,0,0,0,12.4,4.5H9.648a.459.459,0,0,0-.459.459V6.338H5.513V4.959A.459.459,0,0,0,5.054,4.5H2.3a.459.459,0,0,0-.459.459V6.338H.919A.919.919,0,0,0,0,7.257v7.351a.919.919,0,0,0,.919.919H13.783a.919.919,0,0,0,.919-.919V7.257A.919.919,0,0,0,13.783,6.338Zm-8.27,3.905a.23.23,0,0,1-.23.23H2.067a.23.23,0,0,1-.23-.23V9.783a.23.23,0,0,1,.23-.23H5.283a.23.23,0,0,1,.23.23Zm7.351,0a.23.23,0,0,1-.23.23H11.486v1.149a.23.23,0,0,1-.23.23H10.8a.23.23,0,0,1-.23-.23V10.472H9.418a.23.23,0,0,1-.23-.23V9.783a.23.23,0,0,1,.23-.23h1.149V8.405a.23.23,0,0,1,.23-.23h.459a.23.23,0,0,1,.23.23V9.554h1.149a.23.23,0,0,1,.23.23Z"
        transform="translate(0.676 -1.805)"
        fill="#e88f25"
      />
    </svg>
  );
}

export function ic_tele_driving() {
  return (
    <svg
      id="ic_tele_driving"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <rect id="Box" width="24" height="24" fill="none" />
      <g id="icon">
        <circle id="BG" cx="12" cy="12" r="12" fill="#f0f0f0" />
        <g id="Icon-2" data-name="Icon" transform="translate(4.172 3.884)">
          <path
            id="tractor-solid"
            d="M10.82,6.885a1.8,1.8,0,1,0,1.8,1.8,1.8,1.8,0,0,0-1.8-1.8Zm0,2.3a.492.492,0,1,1,.492-.492A.492.492,0,0,1,10.82,9.181Zm1.639-5.9H11.148V2.455a1.314,1.314,0,0,1,.27-.8.315.315,0,0,0-.027-.4L10.947.765a.334.334,0,0,0-.506.016,2.627,2.627,0,0,0-.6,1.675v.824h-2.1L6.59.6a.982.982,0,0,0-.9-.6H2.951a.985.985,0,0,0-.984.983v3a.446.446,0,0,0-.592.03l-.638.637a.451.451,0,0,0,0,.638l.1.1A3.109,3.109,0,0,0,.6,5.985H.451A.451.451,0,0,0,0,6.435v.9a.451.451,0,0,0,.451.451H.6a3.124,3.124,0,0,0,.245.589l-.1.1a.451.451,0,0,0,0,.638l.638.638a.451.451,0,0,0,.638,0l.1-.1a3.109,3.109,0,0,0,.589.245v.147a.451.451,0,0,0,.45.449h.9a.451.451,0,0,0,.451-.451V9.9A3.109,3.109,0,0,0,5.1,9.65l.1.1a.451.451,0,0,0,.638,0l.638-.638a.451.451,0,0,0,0-.638l-.1-.1a3.109,3.109,0,0,0,.245-.589h.147a.451.451,0,0,0,.451-.451V7.213h1.65a2.418,2.418,0,0,1,3.018-.734l1.04-1.04a.656.656,0,0,0,.192-.464V3.935a.655.655,0,0,0-.655-.656ZM3.607,8.525A1.64,1.64,0,1,1,5.246,6.885,1.64,1.64,0,0,1,3.607,8.525Zm.451-5.246H3.279V1.312h2.19l.843,1.967Z"
            transform="translate(0 4.635)"
            fill="#1a1a1a"
          />
          <path
            id="Path_440"
            data-name="Path 440"
            d="M3.3,4.433V3.694H.275A.274.274,0,0,1,0,3.419V2.6a.274.274,0,0,1,.275-.275H3.3V1.582a.275.275,0,0,1,.462-.2L5.279,2.807a.275.275,0,0,1,0,.4L3.758,4.634a.269.269,0,0,1-.186.075A.275.275,0,0,1,3.3,4.433Z"
            transform="translate(8.289 -1.306)"
            fill="#1a1a1a"
          />
        </g>
      </g>
    </svg>
  );
}

export function ic_tele_error() {
  return (
    <svg
      id="ic_tele_error"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <g id="ic_warning">
        <rect id="Box" width="24" height="24" fill="none" />
        <path
          id="Icon"
          d="M8.252,3.147a2,2,0,0,1,3.5,0l6.6,11.882A2,2,0,0,1,16.6,18H3.4a2,2,0,0,1-1.748-2.971Z"
          transform="translate(2 2)"
          fill="#ff0700"
        />
      </g>
    </svg>
  );
}

export function ic_tele_hours() {
  return (
    <svg
      id="ic_tele_hours"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <rect id="Box" width="24" height="24" fill="none" />
      <g
        id="Icon_feather-clock"
        data-name="Icon feather-clock"
        transform="translate(2.754 2.623)"
      >
        <path
          id="Path_433"
          data-name="Path 433"
          d="M22.14,12.57A9.57,9.57,0,1,1,12.57,3a9.57,9.57,0,0,1,9.57,9.57Z"
          transform="translate(-3 -3)"
          fill="#1a1a1a"
        />
        <path
          id="Path_434"
          data-name="Path 434"
          d="M18,9v5.748l3.832,1.916"
          transform="translate(-8.433 -5.175)"
          fill="none"
          stroke="#fff"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.2"
        />
      </g>
    </svg>
  );
}

export function ic_tele_hours_small() {
  return (
    <svg
      id="ic_tele_hours_small"
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
    >
      <rect id="Box" width="16" height="16" fill="none" />
      <g
        id="Icon_feather-clock"
        data-name="Icon feather-clock"
        transform="translate(1.658 1.57)"
      >
        <path
          id="Path_433"
          data-name="Path 433"
          d="M16.127,9.564A6.564,6.564,0,1,1,9.564,3a6.564,6.564,0,0,1,6.564,6.564Z"
          transform="translate(-3 -3)"
          fill="#1a1a1a"
        />
        <path
          id="Path_434"
          data-name="Path 434"
          d="M18,9v3.942l2.628,1.314"
          transform="translate(-11.438 -6.376)"
          fill="none"
          stroke="#fff"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        />
      </g>
    </svg>
  );
}

export function ic_tele_ignite_inhibited() {
  return (
    <svg
      id="ic_tele_ignite_inhibited"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <rect id="Box" width="24" height="24" fill="none" />
      <g id="icon">
        <circle id="BG" cx="12" cy="12" r="12" fill="#f0f0f0" />
        <path
          id="Icon_ionic-md-key"
          data-name="Icon ionic-md-key"
          d="M10.309,13.169a3.778,3.778,0,0,0-3.453-2.481,3.507,3.507,0,0,0-3.481,3.584,3.565,3.565,0,0,0,3.55,3.584,3.684,3.684,0,0,0,3.384-2.481h3.543V17.58h2.381V15.374h1.478V13.169ZM6.945,15.46a1.189,1.189,0,1,1,1.189-1.189A1.191,1.191,0,0,1,6.945,15.46Z"
          transform="translate(1.406 -2.271)"
          fill="#1a1a1a"
          stroke="#f0f0f0"
          strokeWidth="0.5"
        />
        <g id="Overlay" transform="translate(0)">
          <g
            id="BG-2"
            data-name="BG"
            fill="none"
            stroke="#ff0700"
            strokeWidth="1.5"
          >
            <circle cx="12" cy="12" r="12" stroke="none" />
            <circle cx="12" cy="12" r="11.25" fill="none" />
          </g>
          <rect
            id="Rectangle_70"
            data-name="Rectangle 70"
            width="21.946"
            height="1.309"
            transform="translate(5.057 3.882) rotate(45)"
            fill="#ff0700"
          />
        </g>
      </g>
    </svg>
  );
}

export function ic_tele_ingnite_on() {
  return (
    <svg
      id="ic_tele_ingnite_on"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <rect id="Box" width="24" height="24" fill="none" />
      <g id="icon">
        <circle id="BG" cx="12" cy="12" r="12" fill="#f0f0f0" />
        <path
          id="Icon_ionic-md-key"
          data-name="Icon ionic-md-key"
          d="M10.309,13.169a3.778,3.778,0,0,0-3.453-2.481,3.507,3.507,0,0,0-3.481,3.584,3.565,3.565,0,0,0,3.55,3.584,3.684,3.684,0,0,0,3.384-2.481h3.543V17.58h2.381V15.374h1.478V13.169ZM6.945,15.46a1.189,1.189,0,1,1,1.189-1.189A1.191,1.191,0,0,1,6.945,15.46Z"
          transform="translate(1.406 -2.271)"
          fill="#1a1a1a"
          stroke="#f0f0f0"
          strokeWidth="0.5"
        />
      </g>
    </svg>
  );
}

export function ic_tele_parked() {
  return (
    <svg
      id="ic_tele_parked"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <rect id="Box" width="24" height="24" fill="none" />
      <g id="Icon">
        <circle id="BG" cx="12" cy="12" r="12" fill="#f0f0f0" />
        <path
          id="Path_435"
          data-name="Path 435"
          d="M3.709-9.3V-12.47h1.81a4.878,4.878,0,0,1,.771.059,1.8,1.8,0,0,1,.653.23A1.253,1.253,0,0,1,7.4-11.7a1.7,1.7,0,0,1,.171.816,1.7,1.7,0,0,1-.171.816,1.253,1.253,0,0,1-.452.482,1.8,1.8,0,0,1-.653.23,4.878,4.878,0,0,1-.771.059ZM1.38-14.28V-3.689H3.709v-3.8H6.157a4.411,4.411,0,0,0,1.691-.289,3.164,3.164,0,0,0,1.135-.764A2.925,2.925,0,0,0,9.62-9.63a4.028,4.028,0,0,0,.2-1.253,4.006,4.006,0,0,0-.2-1.261,2.935,2.935,0,0,0-.638-1.083,3.164,3.164,0,0,0-1.135-.764,4.411,4.411,0,0,0-1.691-.289Z"
          transform="translate(7.426 20.984)"
          fill="#1a1a1a"
        />
      </g>
    </svg>
  );
}

export function ic_tele_temperature_critical() {
  return (
    <svg
      id="ic_tele_temperature_warning"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <rect id="Box" width="24" height="24" fill="none" />
      <g id="Icon" transform="translate(22025.443 23510.01)">
        <path
          id="Icon_awesome-temperature-low"
          data-name="Icon awesome-temperature-low"
          d="M10.719,4.69a4.69,4.69,0,0,0-9.379,0v6.972a6.019,6.019,0,1,0,10.719,3.748,5.976,5.976,0,0,0-1.34-3.748Z"
          transform="translate(-22019.473 -23508.729)"
          fill="#f0f0f0"
        />
        <path
          id="Path_475"
          data-name="Path 475"
          d="M0,11.349A3.306,3.306,0,0,1,2.2,8.232V1.1a1.1,1.1,0,1,1,2.2,0v7.13A3.306,3.306,0,1,1,0,11.349Z"
          transform="translate(-22016.748 -23504.621)"
          fill="#ff0700"
        />
      </g>
    </svg>
  );
}

export function ic_tele_temperature_normal() {
  return (
    <svg
      id="ic_tele_temperature_normal"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <rect id="Box" width="24" height="24" fill="none" />
      <g id="Icon" transform="translate(22025.174 23509.531)">
        <path
          id="Icon_awesome-temperature-low"
          data-name="Icon awesome-temperature-low"
          d="M11.2,4.9a4.9,4.9,0,0,0-9.8,0v7.283A6.287,6.287,0,1,0,12.6,16.1a6.242,6.242,0,0,0-1.4-3.915Z"
          transform="translate(-22019.473 -23508.729)"
          fill="#f0f0f0"
        />
        <path
          id="Path_475"
          data-name="Path 475"
          d="M0,11.855A3.454,3.454,0,0,1,2.3,8.6V1.151a1.151,1.151,0,1,1,2.3,0V8.6A3.453,3.453,0,1,1,0,11.855Z"
          transform="translate(-22016.627 -23504.438)"
          fill="#1aad7f"
        />
      </g>
    </svg>
  );
}

export function ic_tele_temperature_warning() {
  return (
    <svg
      id="ic_tele_temperature_warning"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <rect id="Box" width="24" height="24" fill="none" />
      <g id="Icon" transform="translate(22025.443 23510.01)">
        <path
          id="Icon_awesome-temperature-low"
          data-name="Icon awesome-temperature-low"
          d="M10.719,4.69a4.69,4.69,0,0,0-9.379,0v6.972a6.019,6.019,0,1,0,10.719,3.748,5.976,5.976,0,0,0-1.34-3.748Z"
          transform="translate(-22019.473 -23508.729)"
          fill="#f0f0f0"
        />
        <path
          id="Path_475"
          data-name="Path 475"
          d="M0,11.349A3.306,3.306,0,0,1,2.2,8.232V1.1a1.1,1.1,0,1,1,2.2,0v7.13A3.306,3.306,0,1,1,0,11.349Z"
          transform="translate(-22016.748 -23504.621)"
          fill="#e88f25"
        />
      </g>
    </svg>
  );
}

export function ill_banner_email() {
  return (
    <svg
      id="ill_banner_email"
      xmlns="http://www.w3.org/2000/svg"
      width="42"
      height="42"
      viewBox="0 0 42 42"
    >
      <rect
        id="Box"
        width="32"
        height="32"
        transform="translate(5 4.998)"
        fill="none"
      />
      <circle id="Circle" cx="21" cy="21" r="21" fill="#dc4405" />
      <g id="sms-notification" transform="translate(-675 -241)">
        <path
          id="Vector"
          d="M20,7v5c0,3.5-2,5-5,5H5c-3,0-5-1.5-5-5V5C0,1.5,2,0,5,0h7"
          transform="translate(686 253.5)"
          fill="none"
          stroke="#fff"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          id="Vector-2"
          data-name="Vector"
          d="M0,0,3.13,2.5a3.166,3.166,0,0,0,3.75,0l1.18-.94"
          transform="translate(691 259)"
          fill="none"
          stroke="#fff"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          id="Vector-3"
          data-name="Vector"
          d="M5,2.5A2.5,2.5,0,1,1,2.5,0,2.5,2.5,0,0,1,5,2.5Z"
          transform="translate(701 253)"
          fill="none"
          stroke="#fff"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          id="Vector-4"
          data-name="Vector"
          d="M0,0H24V24H0Z"
          transform="translate(684 250)"
          fill="none"
          opacity="0"
        />
      </g>
    </svg>
  );
}

export function ill_banner_error() {
  return (
    <svg
      id="ill_banner_error"
      xmlns="http://www.w3.org/2000/svg"
      width="42"
      height="42"
      viewBox="0 0 42 42"
    >
      <rect id="Box" width="42" height="42" fill="none" />
      <circle id="Circle" cx="21" cy="21" r="21" fill="#ff0700" />
      <g id="Add" transform="translate(21 8.066) rotate(45)">
        <path
          id="Path_436"
          data-name="Path 436"
          d="M18,7.5V25.792"
          transform="translate(-8.854 -7.5)"
          fill="none"
          stroke="#fff"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
        <path
          id="Path_437"
          data-name="Path 437"
          d="M7.5,18H25.792"
          transform="translate(-7.5 -8.854)"
          fill="none"
          stroke="#fff"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
      </g>
    </svg>
  );
}

export function ill_delete() {
  return (
    <svg
      id="ill_delete"
      xmlns="http://www.w3.org/2000/svg"
      width="120"
      height="120"
      viewBox="0 0 120 120"
    >
      <rect id="BG" width="120" height="120" rx="60" fill="#f7f7f7" />
      <g id="trash" transform="translate(-78 -158.001)">
        <path
          id="Vector"
          d="M44.709,0H.029"
          transform="translate(115.544 201.7)"
          fill="none"
          stroke="#ff0700"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
        <path
          id="Vector-2"
          data-name="Vector"
          d="M0,7.425.55,4.15C.95,1.775,1.25,0,5.475,0h6.55c4.225,0,4.55,1.875,4.925,4.175l.55,3.25"
          transform="translate(129.25 193)"
          fill="none"
          stroke="#ff0700"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
        <path
          id="Vector-3"
          data-name="Vector"
          d="M34.25,0,32.625,25.175c-.275,3.925-.5,6.975-7.475,6.975H9.1c-6.975,0-7.2-3.05-7.475-6.975L0,0"
          transform="translate(120.875 210.85)"
          fill="none"
          stroke="#ff0700"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
        <path
          id="Vector-4"
          data-name="Vector"
          d="M0,0H8.325"
          transform="translate(133.825 229.25)"
          fill="none"
          stroke="#ff0700"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
        <path
          id="Vector-5"
          data-name="Vector"
          d="M0,0H12.5"
          transform="translate(131.75 219.25)"
          fill="none"
          stroke="#ff0700"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
        <path
          id="Vector-6"
          data-name="Vector"
          d="M0,0H60V60H0Z"
          transform="translate(108 188)"
          fill="none"
          opacity="0"
        />
      </g>
    </svg>
  );
}

export function ill_delete_equip() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="ill_delete_equip"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <g id="trash" transform="translate(-108 -188)">
        <path
          id="Vector"
          d="M17.9,0H.029"
          transform="translate(111 193.48)"
          fill="none"
          stroke="#ff0700"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          id="Vector-2"
          data-name="Vector"
          d="M0,2.97.22,1.66C.38.71.5,0,2.19,0H4.81C6.5,0,6.63.75,6.78,1.67L7,2.97"
          transform="translate(116.5 190)"
          fill="none"
          stroke="#ff0700"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          id="Vector-3"
          data-name="Vector"
          d="M13.7,0l-.65,10.07c-.11,1.57-.2,2.79-2.99,2.79H3.64C.85,12.86.76,11.64.65,10.07L0,0"
          transform="translate(113.15 197.14)"
          fill="none"
          stroke="#ff0700"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          id="Vector-4"
          data-name="Vector"
          d="M0,0H3.33"
          transform="translate(118.33 204.5)"
          fill="none"
          stroke="#ff0700"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          id="Vector-5"
          data-name="Vector"
          d="M0,0H5"
          transform="translate(117.5 200.5)"
          fill="none"
          stroke="#ff0700"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          id="Vector-6"
          data-name="Vector"
          d="M0,0H24V24H0Z"
          transform="translate(108 188)"
          fill="none"
          opacity="0"
        />
      </g>
    </svg>
  );
}

export function ill_empty_dealers() {
  return (
    <svg
      id="ill_empty_dealers"
      xmlns="http://www.w3.org/2000/svg"
      width="160"
      height="160.001"
      viewBox="0 0 160 160.001"
    >
      <rect id="Box" width="160" height="160" fill="none" />
      <circle
        id="BG"
        cx="80"
        cy="80"
        r="80"
        transform="translate(0 0.001)"
        fill="#fff"
      />
      <g id="Icon" transform="translate(47.749 47.679)">
        <path
          id="Vector"
          d="M47.285.5,17.694,7.917a14.727,14.727,0,0,0-9.774,9.774L.5,47.283C-1.736,56.223,3.747,61.736,12.717,59.5l29.591-7.39a14.847,14.847,0,0,0,9.774-9.774L59.5,12.715C61.738,3.775,56.225-1.738,47.285.5Z"
          transform="translate(2.25 2.322)"
          fill="none"
          stroke="#909090"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
        <path
          id="Vector-2"
          data-name="Vector"
          d="M18.461,9.231A9.231,9.231,0,1,1,9.231,0,9.231,9.231,0,0,1,18.461,9.231Z"
          transform="translate(23.019 23.091)"
          fill="none"
          stroke="#909090"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
      </g>
    </svg>
  );
}

export function ill_empty_favorites() {
  return (
    <svg
      id="ill_empty_favorites"
      xmlns="http://www.w3.org/2000/svg"
      width="160"
      height="160.001"
      viewBox="0 0 160 160.001"
    >
      <rect id="Box" width="160" height="160" fill="none" />
      <circle
        id="BG"
        cx="80"
        cy="80"
        r="80"
        transform="translate(0 0.001)"
        fill="#fff"
      />
      <path
        id="star"
        d="M38.21,57.293,60.588,70.8,54.649,45.343,74.42,28.216,48.385,25.971,38.21,2,28.035,25.971,2,28.216,21.734,45.343,15.832,70.8Z"
        transform="translate(41.79 43.6)"
        fill="none"
        stroke="#909090"
        strokeWidth="2"
      />
    </svg>
  );
}

export function ill_empty_history() {
  return (
    <svg
      id="ill_empty_history"
      xmlns="http://www.w3.org/2000/svg"
      width="120"
      height="120"
      viewBox="0 0 120 120"
    >
      <rect id="BG" width="120" height="120" rx="60" fill="#f7f7f7" />
      <g id="task" transform="translate(-400 -286.002)">
        <path
          id="Vector"
          d="M0,0H25"
          transform="translate(435.5 364.75)"
          fill="none"
          stroke="#909090"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="3"
        />
        <path
          id="Vector-2"
          data-name="Vector"
          d="M0,0H25"
          transform="translate(435.5 347.25)"
          fill="none"
          stroke="#909090"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="3"
        />
        <path
          id="Vector-3"
          data-name="Vector"
          d="M0,0H25"
          transform="translate(435.5 329.75)"
          fill="none"
          stroke="#909090"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="3"
        />
        <path
          id="Vector-4"
          data-name="Vector"
          d="M0,5,2.5,7.5,10,0"
          transform="translate(474.5 324.75)"
          fill="none"
          stroke="#909090"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="3"
        />
        <path
          id="Vector-5"
          data-name="Vector"
          d="M0,5,2.5,7.5,10,0"
          transform="translate(474.5 342.25)"
          fill="none"
          stroke="#909090"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="3"
        />
        <path
          id="Vector-6"
          data-name="Vector"
          d="M0,5,2.5,7.5,10,0"
          transform="translate(474.5 359.75)"
          fill="none"
          stroke="#909090"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="3"
        />
        <path
          id="Vector-7"
          data-name="Vector"
          d="M0,0H60V60H0Z"
          transform="translate(428 316)"
          fill="none"
          opacity="0"
        />
      </g>
    </svg>
  );
}

export function ill_howto_addequip() {
  return (
    <svg
      id="ill_howto_addequip"
      xmlns="http://www.w3.org/2000/svg"
      width="384"
      height="848"
      viewBox="0 0 384 848"
    >
      <rect id="BG" width="384" height="848" rx="4" fill="#f7f7f7" />
      <g id="ph_image" transform="translate(57 217)">
        <rect id="Box" width="280" height="280" fill="none" />
        <g id="Icon" transform="translate(61.004 81.258)" opacity="0.404">
          <path
            id="Path_1"
            data-name="Path 1"
            d="M13,29.027v84.324a7.048,7.048,0,0,0,7.027,7.027H135.973a6.829,6.829,0,0,0,5.446-2.635c.176-.176.176-.176.176-.351A7.038,7.038,0,0,0,143,113.351V29.027A7.048,7.048,0,0,0,135.973,22H20.027A7.048,7.048,0,0,0,13,29.027Zm7.027,84.324V99.3L52,63.986a.544.544,0,0,1,.351-.176c.176,0,.351,0,.351.176l42.338,49.365Zm86.432-29.162,25.824,29.162H104.176l-13-15.108Zm29.514-55.162v78L111.378,79.27a6.4,6.4,0,0,0-9.486-.351L86.784,92.973,57.973,59.243a8.06,8.06,0,0,0-5.446-2.635,7.421,7.421,0,0,0-5.622,2.284L20.027,88.757V29.027Z"
            transform="translate(0.996 -12.446)"
            fill="#8a8f9f"
          />
          <path
            id="Path_2"
            data-name="Path 2"
            d="M55.659,49.317A7.659,7.659,0,1,0,48,41.659,7.714,7.714,0,0,0,55.659,49.317Zm0-11.233a3.574,3.574,0,1,1-3.574,3.574A3.618,3.618,0,0,1,55.659,38.085Z"
            transform="translate(34.028 -0.136)"
            fill="#8a8f9f"
          />
        </g>
      </g>
    </svg>
  );
}

export function ill_inhibit_disabled() {
  return (
    <svg
      id="ill_inhibit_disabled"
      xmlns="http://www.w3.org/2000/svg"
      width="88"
      height="88"
      viewBox="0 0 88 88"
    >
      <g id="Border" fill="#fff" stroke="#ff0700" strokeWidth="6">
        <circle cx="44" cy="44" r="44" stroke="none" />
        <circle cx="44" cy="44" r="41" fill="none" />
      </g>
      <path
        id="Icon_metro-key"
        data-name="Icon metro-key"
        d="M26.642,38.751A12.117,12.117,0,0,1,14.735,24.423L0,9.688V2.422A2.422,2.422,0,0,1,2.422,0H4.844V2.422H9.688V7.266h4.844V12.11h4.844l3.143,3.143a12.111,12.111,0,1,1,4.123,23.5ZM30.27,26.637A3.633,3.633,0,1,0,33.9,30.27,3.633,3.633,0,0,0,30.27,26.637Z"
        transform="translate(71.402 44) rotate(135)"
        fill="#1a1a1a"
      />
      <line
        id="Line_44"
        data-name="Line 44"
        x2="85.871"
        transform="translate(13.64 13.995) rotate(45)"
        fill="none"
        stroke="#ff0700"
        strokeWidth="6"
      />
    </svg>
  );
}

export function ill_inhibit_enabled() {
  return (
    <svg
      id="ill_inhibit_enabled"
      xmlns="http://www.w3.org/2000/svg"
      width="88"
      height="88"
      viewBox="0 0 88 88"
    >
      <g
        id="Border"
        fill="rgba(26,173,127,0.05)"
        stroke="rgba(27,173,127,0.1)"
        strokeWidth="6"
      >
        <circle cx="44" cy="44" r="44" stroke="none" />
        <circle cx="44" cy="44" r="41" fill="none" />
      </g>
      <path
        id="Icon_metro-key"
        data-name="Icon metro-key"
        d="M26.642,38.751A12.117,12.117,0,0,1,14.735,24.423L0,9.688V2.422A2.422,2.422,0,0,1,2.422,0H4.844V2.422H9.688V7.266h4.844V12.11h4.844l3.143,3.143a12.111,12.111,0,1,1,4.123,23.5ZM30.27,26.637A3.633,3.633,0,1,0,33.9,30.27,3.633,3.633,0,0,0,30.27,26.637Z"
        transform="translate(71.402 44) rotate(135)"
        fill="#1aad7f"
      />
    </svg>
  );
}

export function ic_tele_geofence_out_small() {
  return (
    <svg
      id="ic_tele_geofence_out_small"
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
    >
      <circle id="BG" cx="8" cy="8" r="8" fill="none" />
      <g id="icon" transform="translate(1.799 0.42)">
        <path
          id="Path_439"
          data-name="Path 439"
          d="M-809,1568.166a6.183,6.183,0,0,1,6.2-6.165,6.184,6.184,0,0,1,6.2,6.165c0,4.831-5.037,8.994-6.2,8.994S-809,1573-809,1568.166Z"
          transform="translate(809 -1562)"
          fill="#ff0700"
        />
        <g id="icon-2" data-name="icon" transform="translate(5.201 3.58)">
          <rect
            id="Rectangle_68"
            data-name="Rectangle 68"
            width="2"
            height="5"
            rx="1"
            fill="#fff"
          />
          <rect
            id="Rectangle_69"
            data-name="Rectangle 69"
            width="2"
            height="2"
            rx="1"
            transform="translate(0 6)"
            fill="#fff"
          />
        </g>
      </g>
    </svg>
  );
}

export function ic_tele_geofence_in_small() {
  return (
    <svg
      id="ic_tele_geofence_in_small"
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
    >
      <circle id="BG" cx="8" cy="8" r="8" fill="none" />
      <path
        id="Icon"
        d="M4402.672,8210.461a6.183,6.183,0,0,0-6.2,6.166c0,4.83,5.039,9,6.2,9s6.2-4.165,6.2-9A6.184,6.184,0,0,0,4402.672,8210.461Zm-.036,8.627a2.5,2.5,0,1,1,2.511-2.494A2.5,2.5,0,0,1,4402.636,8219.088Z"
        transform="translate(-4394.672 -8210.041)"
        fill="#1a1a1a"
        fillRule="evenodd"
      />
    </svg>
  );
}

export function map_pin() {
  return (
    <svg
      id="map_pin"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="36"
      height="36"
      viewBox="0 0 36 36"
    >
      <defs>
        <filter
          id="Icon"
          x="4.042"
          y="0.908"
          width="29.06"
          height="34.186"
          filterUnits="userSpaceOnUse"
        >
          <feOffset input="SourceAlpha" />
          <feGaussianBlur stdDeviation="1" result="blur" />
          <feFlood floodOpacity="0.2" />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <rect id="Box" width="36" height="36" fill="none" />
      <g transform="matrix(1, 0, 0, 1, 0, 0)" filter="url(#Icon)">
        <path
          id="Icon-2"
          data-name="Icon"
          d="M4408,8210.461a11.5,11.5,0,0,0-11.531,11.464c0,8.98,9.369,16.722,11.531,16.722s11.529-7.741,11.529-16.722A11.5,11.5,0,0,0,4408,8210.461Zm-.069,16.041a4.644,4.644,0,1,1,4.671-4.644A4.656,4.656,0,0,1,4407.932,8226.5Z"
          transform="translate(-4389.43 -8206.55)"
          fill="#1a1a1a"
          fillRule="evenodd"
        />
      </g>
      <circle
        id="Ellipse_42"
        data-name="Ellipse 42"
        cx="4.676"
        cy="4.676"
        r="4.676"
        transform="translate(13.803 10.635)"
        fill="#fff"
      />
    </svg>
  );
}

export function map_pin_fav() {
  return (
    <svg
      id="map_pin_fav"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="36"
      height="36"
      viewBox="0 0 36 36"
    >
      <defs>
        <filter
          id="Icon"
          x="4.042"
          y="0.908"
          width="29.06"
          height="34.186"
          filterUnits="userSpaceOnUse"
        >
          <feOffset input="SourceAlpha" />
          <feGaussianBlur stdDeviation="1" result="blur" />
          <feFlood flood-opacity="0.2" />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <rect id="Box" width="36" height="36" fill="none" />
      <g transform="matrix(1, 0, 0, 1, 0, 0)" filter="url(#Icon)">
        <path
          id="Icon-2"
          data-name="Icon"
          d="M4408,8210.461a11.5,11.5,0,0,0-11.531,11.464c0,8.98,9.369,16.722,11.531,16.722s11.529-7.741,11.529-16.722A11.5,11.5,0,0,0,4408,8210.461Z"
          transform="translate(-4389.43 -8206.55)"
          fill="#dc4405"
          fillRule="evenodd"
        />
      </g>
      <path
        id="star"
        d="M8.013,11.181l3.716,2.243L10.742,9.2l3.283-2.844L9.7,5.98,8.013,2,6.323,5.98,2,6.353,5.277,9.2,4.3,13.424Z"
        transform="translate(10.559 7.788)"
        fill="#fff"
      />
    </svg>
  );
}

export function map_pin_selected() {
  return (
    <svg
      id="map_pin_selected"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="60"
      height="60"
      viewBox="0 0 60 60"
    >
      <defs>
        <filter
          id="Icon"
          x="8.722"
          y="3.494"
          width="44.466"
          height="53.016"
          filterUnits="userSpaceOnUse"
        >
          <feOffset input="SourceAlpha" />
          <feGaussianBlur stdDeviation="1" result="blur" />
          <feFlood flood-opacity="0.2" />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <rect id="Box" width="60" height="60" fill="none" />
      <g transform="matrix(1, 0, 0, 1, 0, 0)" filter="url(#Icon)">
        <path
          id="Icon-2"
          data-name="Icon"
          d="M4415.7,8210.461a19.177,19.177,0,0,0-19.234,19.123c0,14.98,15.627,27.893,19.234,27.893s19.231-12.912,19.231-27.893A19.179,19.179,0,0,0,4415.7,8210.461Zm-.116,26.758a7.747,7.747,0,1,1,7.792-7.746A7.767,7.767,0,0,1,4415.589,8237.219Z"
          transform="translate(-4384.75 -8203.97)"
          fill="#1a1a1a"
          fillRule="evenodd"
        />
      </g>
      <circle
        id="Ellipse_42"
        data-name="Ellipse 42"
        cx="7.8"
        cy="7.8"
        r="7.8"
        transform="translate(22.998 17.714)"
        fill="#fff"
      />
    </svg>
  );
}

export function notification_email() {
  return (
    <svg
      id="ill_banner_email"
      xmlns="http://www.w3.org/2000/svg"
      width="42"
      height="42"
      viewBox="0 0 42 42"
    >
      <rect
        id="Box"
        width="32"
        height="32"
        transform="translate(5 4.998)"
        fill="none"
      />
      <circle id="Circle" cx="21" cy="21" r="21" fill="#dc4405" />
      <g id="sms-notification" transform="translate(-675 -241)">
        <path
          id="Vector"
          d="M20,7v5c0,3.5-2,5-5,5H5c-3,0-5-1.5-5-5V5C0,1.5,2,0,5,0h7"
          transform="translate(686 253.5)"
          fill="none"
          stroke="#fff"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          id="Vector-2"
          data-name="Vector"
          d="M0,0,3.13,2.5a3.166,3.166,0,0,0,3.75,0l1.18-.94"
          transform="translate(691 259)"
          fill="none"
          stroke="#fff"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          id="Vector-3"
          data-name="Vector"
          d="M5,2.5A2.5,2.5,0,1,1,2.5,0,2.5,2.5,0,0,1,5,2.5Z"
          transform="translate(701 253)"
          fill="none"
          stroke="#fff"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          id="Vector-4"
          data-name="Vector"
          d="M0,0H24V24H0Z"
          transform="translate(684 250)"
          fill="none"
          opacity="0"
        />
      </g>
    </svg>
  );
}

export function notification_success() {
  return (
    <svg
      id="ic_banner_add"
      xmlns="http://www.w3.org/2000/svg"
      width="42"
      height="42"
      viewBox="0 0 42 42"
    >
      <rect id="Box" width="42" height="42" fill="none" />
      <circle
        id="Ellipse_59"
        data-name="Ellipse 59"
        cx="21"
        cy="21"
        r="21"
        fill="#1aad7f"
      />
      <path
        id="Path_492"
        data-name="Path 492"
        d="M392.658,25.977l7.472,7.472,12.686-12.686"
        transform="translate(-381.738 -5.106)"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="3"
      />
    </svg>
  );
}

export function shield_tick() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18.4"
      height="21.433"
      viewBox="0 0 18.4 21.433"
    >
      <g id="shield-tick" transform="translate(0.6 0.649)">
        <path
          id="Vector"
          d="M7.08.233,2.09,2.113A3.47,3.47,0,0,0,0,5.122v7.43a4.862,4.862,0,0,0,1.73,3.44l4.3,3.21a4.552,4.552,0,0,0,5.14,0l4.3-3.21a4.862,4.862,0,0,0,1.73-3.44V5.122A3.472,3.472,0,0,0,15.11,2.1L10.12.233A5.085,5.085,0,0,0,7.08.233Z"
          fill="none"
          stroke="#1a1a1a"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.2"
        />
        <path
          id="Vector-2"
          data-name="Vector"
          d="M0,2.69,1.61,4.3,5.91,0"
          transform="translate(5.64 7.182)"
          fill="none"
          stroke="#1a1a1a"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.2"
        />
      </g>
    </svg>
  );
}

export function video() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21.2"
      height="18.04"
      viewBox="0 0 21.2 18.04"
    >
      <g id="video" transform="translate(0.6 0.6)">
        <path
          id="Vector"
          d="M10.53,16.84H4.21C1.05,16.84,0,14.74,0,12.63V4.21C0,1.05,1.05,0,4.21,0h6.32c3.16,0,4.21,1.05,4.21,4.21v8.42C14.74,15.79,13.68,16.84,10.53,16.84Z"
          fill="none"
          stroke="#1a1a1a"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.2"
        />
        <path
          id="Vector-2"
          data-name="Vector"
          d="M2.78,10.667,0,8.717V2.407L2.78.457c1.36-.95,2.48-.37,2.48,1.3v7.62C5.26,11.047,4.14,11.627,2.78,10.667Z"
          transform="translate(14.74 2.853)"
          fill="none"
          stroke="#1a1a1a"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.2"
        />
        <path
          id="Vector-3"
          data-name="Vector"
          d="M3,1.5A1.5,1.5,0,1,1,1.5,0,1.5,1.5,0,0,1,3,1.5Z"
          transform="translate(8 4.42)"
          fill="none"
          stroke="#1a1a1a"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.2"
        />
      </g>
    </svg>
  );
}

export function ic_player_video_close() {
  return (
    <svg
      id="ic_player_video_close"
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
    >
      <rect id="Box" width="32" height="32" fill="none" />
      <g id="Icon" transform="translate(-2082.743 -717.744)">
        <line
          id="Line_1"
          data-name="Line 1"
          x2="24"
          y2="24"
          transform="translate(2086.743 721.743)"
          fill="none"
          stroke="#fff"
          strokeLinecap="round"
          strokeWidth="3"
        />
        <line
          id="Line_2"
          data-name="Line 2"
          x1="24"
          y2="24"
          transform="translate(2086.743 721.743)"
          fill="none"
          stroke="#fff"
          strokeLinecap="round"
          strokeWidth="3"
        />
      </g>
    </svg>
  );
}

export function ic_player_video_play() {
  return (
    <svg
      id="ic_player_video_play"
      xmlns="http://www.w3.org/2000/svg"
      width="72"
      height="72"
      viewBox="0 0 72 72"
    >
      <rect id="Box" width="72" height="72" fill="none" />
      <path
        id="Icon"
        d="M27.8,2.772a2,2,0,0,1,3.408,0l25.923,42.18A2,2,0,0,1,55.423,48H3.577a2,2,0,0,1-1.7-3.047Z"
        transform="translate(67.001 7) rotate(90)"
        fill="#fff"
      />
    </svg>
  );
}

export function ic_preview_play() {
  return (
    <svg
      id="ic_preview_play"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <rect id="Box" width="24" height="24" fill="none" />
      <path
        id="Icon"
        d="M6.732,1.377a1,1,0,0,1,1.7,0l5.789,9.373a1,1,0,0,1-.851,1.525H1.793a1,1,0,0,1-.851-1.525Z"
        transform="translate(20.341 4.418) rotate(90)"
        fill="#1a1a1a"
      />
    </svg>
  );
}

export function ill_empty_faultcodes() {
  return (
    <svg
      id="ill_empty_faultcodes"
      xmlns="http://www.w3.org/2000/svg"
      width="120"
      height="120"
      viewBox="0 0 120 120"
    >
      <rect id="BG" width="120" height="120" rx="60" fill="#f7f7f7" />
      <g id="task" transform="translate(-406.298 -299.299)">
        <path
          id="Vector"
          d="M0,0H76.6V76.6H0Z"
          transform="translate(428 316)"
          fill="none"
          opacity="0"
        />
        <g id="ic_warning" transform="translate(435.658 326.214)">
          <g id="Icon" transform="translate(-0.361 0.085)" fill="none">
            <path
              d="M26.626,7.9a5,5,0,0,1,8.749,0L57.892,48.578A5,5,0,0,1,53.517,56H8.483a5,5,0,0,1-4.374-7.422Z"
              stroke="none"
            />
            <path
              d="M 30.99999809265137 5.323837280273438 C 29.28854751586914 5.323837280273438 27.57709503173828 6.183315277099609 26.62553405761719 7.902263641357422 L 4.108375549316406 48.57842254638672 C 2.263584136962891 51.91095352172852 4.673774719238281 56.00000381469727 8.482845306396484 55.99999237060547 L 53.51716613769531 55.99999237060547 C 53.51739501953125 55.99999237060547 53.51694488525391 55.99999237060547 53.51717758178711 55.99999237060547 C 57.32583618164062 55.99999237060547 59.73631286621094 51.91075134277344 57.89163208007812 48.57842254638672 L 35.37446594238281 7.902263641357422 C 34.42290496826172 6.183315277099609 32.71144866943359 5.323837280273438 30.99999809265137 5.323837280273438 M 30.9999942779541 3.323833465576172 C 32.21481323242188 3.323833465576172 33.40983581542969 3.636173248291016 34.45588302612305 4.227073669433594 C 35.56965637207031 4.856243133544922 36.49236297607422 5.792152404785156 37.12425231933594 6.933631896972656 L 59.64142227172852 47.60979461669922 C 60.85425567626953 49.80072402954102 60.81911468505859 52.39681243896484 59.54740524291992 54.55434417724609 C 58.27568435668945 56.7119026184082 56.02139282226562 57.99999237060547 53.51717376708984 57.99999237060547 L 8.482845306396484 57.99999237060547 C 5.978473663330078 58.00000381469727 3.724124908447266 56.71195220947266 2.452442169189453 54.55448150634766 C 1.180763244628906 52.39700317382812 1.145683288574219 49.80085372924805 2.358585357666016 47.60979461669922 L 24.8757438659668 6.933631896972656 C 25.50763320922852 5.792152404785156 26.43034362792969 4.856243133544922 27.54411315917969 4.227073669433594 C 28.59015274047852 3.636173248291016 29.78518295288086 3.323833465576172 30.9999942779541 3.323833465576172 Z"
              stroke="none"
              fill="#909090"
            />
          </g>
          <rect
            id="Rectangle_239"
            data-name="Rectangle 239"
            width="4"
            height="13.338"
            transform="translate(28.639 23.639)"
            fill="#909090"
          />
          <rect
            id="Rectangle_240"
            data-name="Rectangle 240"
            width="4"
            height="4"
            transform="translate(28.639 41.424)"
            fill="#909090"
          />
        </g>
      </g>
    </svg>
  );
}

export function ic_delete() {
  return (
    <svg
      id="ic_delete"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <rect id="Box" width="24" height="24" fill="none" />
      <g id="Icon" transform="translate(-2078.936 -713.936)">
        <line
          id="Line_1"
          data-name="Line 1"
          x2="8"
          y2="8"
          transform="translate(2086.935 721.935)"
          fill="none"
          stroke="#1a1a1a"
          strokeLinecap="round"
          strokeWidth="1.2"
        />
        <line
          id="Line_2"
          data-name="Line 2"
          x1="8"
          y2="8"
          transform="translate(2086.935 721.935)"
          fill="none"
          stroke="#1a1a1a"
          strokeLinecap="round"
          strokeWidth="1.2"
        />
      </g>
    </svg>
  );
}

export function ic_edit() {
  return (
    <svg
      id="ic_edit"
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
    >
      <rect id="Box" width="32" height="32" fill="none" />
      <g id="edit-2" transform="translate(5.641 5.484)">
        <path
          id="Vector"
          d="M8.386,1.3.954,9.17a2.761,2.761,0,0,0-.607,1.295L.012,13.4A1.383,1.383,0,0,0,1.705,15l2.915-.5a2.6,2.6,0,0,0,1.258-.679l7.433-7.867c1.286-1.358,1.865-2.906-.136-4.8C11.184-.716,9.672-.055,8.386,1.3Z"
          transform="translate(3.114 1.593)"
          fill="none"
          stroke="#1a1a1a"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          id="Vector-2"
          d="M0,0A5.546,5.546,0,0,0,4.934,4.663"
          transform="translate(10.261 4.209)"
          fill="none"
          stroke="#1a1a1a"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          id="Vector-3"
          d="M0,0H16.3"
          transform="translate(2.212 19.555)"
          fill="none"
          stroke="#1a1a1a"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
      </g>
    </svg>
  );
}

export function ic_more() {
  return (
    <svg
      id="ic_more"
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
    >
      <g id="ic_more-2" transform="translate(8 4)">
        <rect id="Box" width="16" height="24" fill="none" />
        <g id="ic_more-3" transform="translate(-192 580) rotate(-90)">
          <path
            id="Vector"
            className="dot"
            d="M2,0A2,2,0,1,0,4,2,2.006,2.006,0,0,0,2,0Z"
            transform="translate(559 198)"
            fill="#1a1a1a"
          />
          <path
            id="Vector-2"
            className="dot"
            d="M2,0A2,2,0,1,0,4,2,2.006,2.006,0,0,0,2,0Z"
            transform="translate(573 198)"
            fill="#1a1a1a"
          />
          <path
            id="Vector-3"
            className="dot"
            d="M2,0A2,2,0,1,0,4,2,2.006,2.006,0,0,0,2,0Z"
            transform="translate(566 198)"
            fill="#1a1a1a"
          />
        </g>
      </g>
    </svg>
  );
}

export function ic_more_secondary() {
  return (
    <svg
      id="ic_more"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="32"
      viewBox="0 0 24 32"
    >
      <g id="ic_more-2" data-name="ic_more" transform="translate(4 4)">
        <rect id="Box" width="16" height="24" fill="none" />
        <g
          id="ic_more-3"
          data-name="ic_more"
          transform="translate(6 21) rotate(-90)"
        >
          <path
            id="Vector"
            d="M2,0A2,2,0,1,0,4,2,2.006,2.006,0,0,0,2,0Z"
            fill="#909090"
          />
          <path
            id="Vector-2"
            data-name="Vector"
            d="M2,0A2,2,0,1,0,4,2,2.006,2.006,0,0,0,2,0Z"
            transform="translate(14)"
            fill="#909090"
          />
          <path
            id="Vector-3"
            data-name="Vector"
            d="M2,0A2,2,0,1,0,4,2,2.006,2.006,0,0,0,2,0Z"
            transform="translate(7)"
            fill="#909090"
          />
        </g>
      </g>
      <rect id="Box-2" data-name="Box" width="24" height="32" fill="none" />
    </svg>
  );
}

export function ic_res_maintenance_guides() {
  return (
    <svg
      id="ic_res_maintenance_guides"
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
    >
      <rect id="Box" width="32" height="32" fill="none" />
      <g id="setting" transform="translate(-223 -175.111)">
        <path
          id="Vector"
          d="M0,4.667V8.513c0,1.413,0,1.413,1.333,2.313L5,12.947a2.2,2.2,0,0,0,2,0l3.667-2.12C12,9.927,12,9.927,12,8.52V4.667C12,3.26,12,3.26,10.667,2.36L7,.24a2.2,2.2,0,0,0-2,0L1.333,2.36C0,3.26,0,3.26,0,4.667Z"
          transform="translate(239 190.11)"
          fill="none"
          stroke="#909090"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.2"
        />
        <path
          id="Vector-2"
          data-name="Vector"
          d="M4,2A2,2,0,1,1,2,0,2,2,0,0,1,4,2Z"
          transform="translate(243 194.703)"
          fill="none"
          stroke="#909090"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.2"
        />
      </g>
      <g id="document" transform="translate(-488 -249)">
        <path
          id="Vector-3"
          data-name="Vector"
          d="M0,0V2A2.006,2.006,0,0,0,2,4H4"
          transform="translate(506.5 256.5)"
          fill="none"
          stroke="#909090"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.2"
        />
        <path
          id="Vector-4"
          data-name="Vector"
          d="M6.906,20.6H5.6c-3.5,0-5-2-5-5V5.6c0-3,1.5-5,5-5h8c3.5,0,5,2,5,5V8.781"
          transform="translate(494.4 253.4)"
          fill="none"
          stroke="#909090"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.2"
        />
      </g>
    </svg>
  );
}

export function ic_guides_forward() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
    >
      <g id="ic_guides_forward" transform="translate(32 32) rotate(180)">
        <rect id="Box" width="32" height="32" fill="none" />
        <g id="Icon" transform="translate(10.5 10.5)">
          <path
            id="ic_nav_up"
            d="M1.483,8.482H12.142"
            transform="translate(-1.483 -2.982)"
            fill="none"
            stroke="#1a1a1a"
            strokeLinecap="round"
            strokeWidth="1.5"
          />
          <path
            id="Path_470"
            data-name="Path 470"
            d="M16.2,16.018l5.319,5.5-5.319,5.5"
            transform="translate(-10.519 -16.018)"
            fill="none"
            stroke="#1a1a1a"
            strokeLinecap="round"
            strokeWidth="1.5"
          />
        </g>
      </g>
      <rect id="Box-2" width="32" height="32" fill="none" />
    </svg>
  );
}

export function ic_account_page() {
  return (
    <svg
      id="ic_account_page"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <path id="Vector" d="M0,0H24V24H0Z" fill="none" opacity="0" />
      <g id="icon" transform="translate(-491.6 -251)">
        <g
          id="Vector-2"
          data-name="Vector"
          transform="translate(495.1 253)"
          fill="none"
          stroke="#909090"
          strokeWidth="1.2"
        >
          <path
            d="M.5,0H14a3,3,0,0,1,3,3V19.5a.5.5,0,0,1-.5.5H.5a.5.5,0,0,1-.5-.5V.5A.5.5,0,0,1,.5,0Z"
            stroke="none"
          />
          <path
            d="M.7.6H14A2.4,2.4,0,0,1,16.4,3V19.3a.1.1,0,0,1-.1.1H.7a.1.1,0,0,1-.1-.1V.7A.1.1,0,0,1,.7.6Z"
            fill="none"
          />
        </g>
        <path
          id="Vector-3"
          data-name="Vector"
          d="M0,0V1.8A1.805,1.805,0,0,0,1.8,3.6H3.6"
          transform="translate(505.35 256.25)"
          fill="none"
          stroke="#909090"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.2"
        />
        <path
          id="Vector-4"
          data-name="Vector"
          d="M0,0H4.119"
          transform="translate(499.461 263.9)"
          fill="none"
          stroke="#909090"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.2"
        />
        <path
          id="Vector-5"
          data-name="Vector"
          d="M0,0H8.238"
          transform="translate(499.461 267.5)"
          fill="none"
          stroke="#909090"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.2"
        />
      </g>
    </svg>
  );
}

export function ic_guides_back() {
  return (
    <svg
      id="ic_guides_back"
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
    >
      <rect id="Box" width="32" height="32" fill="none" />
      <g id="Icon" transform="translate(22731.977 23949.23)">
        <path
          id="ic_nav_up"
          d="M12.142,8.482H1.483"
          transform="translate(-22722.619 -23941.713)"
          fill="none"
          stroke="#1a1a1a"
          strokeLinecap="round"
          strokeWidth="1.5"
        />
        <path
          id="Path_470"
          data-name="Path 470"
          d="M21.519,16.018l-5.319,5.5,5.319,5.5"
          transform="translate(-22737.676 -23954.748)"
          fill="none"
          stroke="#1a1a1a"
          strokeLinecap="round"
          strokeWidth="1.5"
        />
      </g>
    </svg>
  );
}

export function ill_empty_notif() {
  return (
    <svg
      id="ill_empty_notif"
      xmlns="http://www.w3.org/2000/svg"
      width="120"
      height="120"
      viewBox="0 0 120 120"
    >
      <rect id="BG" width="120" height="120" rx="60" fill="#f7f7f7" />
      <g id="Icon" transform="translate(37.115 37.115)">
        <path
          id="Vector"
          d="M22.413,0A16.444,16.444,0,0,0,5.964,16.45v5.187a12.824,12.824,0,0,1-1.556,5.631L1.271,32.5c-2.229,3.165-2.639,8.332,2.964,8.027,17.389.309,21.591.049,36.382,0,5.6-.183,6.1-3.164,2.964-8.027l-3.137-5.236a12.916,12.916,0,0,1-1.556-5.631V16.45A16.545,16.545,0,0,0,22.413,0Z"
          transform="translate(0.264)"
          fill="none"
          stroke="#909090"
          strokeLinecap="round"
          strokeWidth="2"
        />
        <path
          id="Vector-2"
          data-name="Vector"
          d="M16.45,0A8.254,8.254,0,0,1,8.225,8.225,8.239,8.239,0,0,1,2.421,5.8,8.239,8.239,0,0,1,0,0"
          transform="translate(14.417 41.545)"
          fill="none"
          stroke="#909090"
          strokeWidth="2"
        />
      </g>
      <g id="Dot">
        <g
          id="Dot-2"
          data-name="Dot"
          transform="translate(65 28.999)"
          fill="#ccc"
          stroke="#f7f7f7"
          strokeWidth="2"
        >
          <circle cx="12" cy="12" r="12" stroke="none" />
          <circle cx="12" cy="12" r="11" fill="none" />
        </g>
        <path
          id="O"
          d="M1.956-4.236q0-.216.006-.522T2-5.388a4.423,4.423,0,0,1,.12-.642,2.213,2.213,0,0,1,.234-.57,1.252,1.252,0,0,1,.384-.408,1.027,1.027,0,0,1,.582-.156,1.056,1.056,0,0,1,.588.156,1.287,1.287,0,0,1,.4.408,1.963,1.963,0,0,1,.234.57,5.85,5.85,0,0,1,.12.642,5.784,5.784,0,0,1,.048.63q.006.306.006.522,0,.36-.024.87a4.675,4.675,0,0,1-.15.984,2.066,2.066,0,0,1-.408.81,1,1,0,0,1-.81.336.966.966,0,0,1-.792-.336,2.111,2.111,0,0,1-.4-.81,4.675,4.675,0,0,1-.15-.984Q1.956-3.876,1.956-4.236Zm-1.7,0A7.663,7.663,0,0,0,.5-2.13,3.7,3.7,0,0,0,1.164-.78a2.388,2.388,0,0,0,.978.72A3.245,3.245,0,0,0,3.324.156,3.279,3.279,0,0,0,4.518-.06,2.432,2.432,0,0,0,5.5-.78a3.646,3.646,0,0,0,.672-1.35A7.663,7.663,0,0,0,6.42-4.236a7.374,7.374,0,0,0-.246-2.058A3.648,3.648,0,0,0,5.5-7.632a2.432,2.432,0,0,0-.984-.72,3.279,3.279,0,0,0-1.194-.216,3.245,3.245,0,0,0-1.182.216,2.388,2.388,0,0,0-.978.72A3.707,3.707,0,0,0,.5-6.294,7.374,7.374,0,0,0,.252-4.236Z"
          transform="translate(73.664 45.205)"
          fill="#fff"
        />
      </g>
    </svg>
  );
}

export function ic_res_compatible() {
  return (
    <svg
      id="ic_res_compatible"
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
    >
      <g id="setting" transform="translate(-233 -185.099)">
        <path
          id="Vector"
          d="M0,7.778v6.411c0,2.356,0,2.356,2.222,3.856l6.111,3.533a3.672,3.672,0,0,0,3.333,0l6.111-3.533C20,16.544,20,16.544,20,14.2V7.778c0-2.344,0-2.344-2.222-3.844L11.667.4A3.672,3.672,0,0,0,8.333.4L2.222,3.933C0,5.433,0,5.433,0,7.778Z"
          transform="translate(239 190.11)"
          fill="none"
          stroke="#909090"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.2"
        />
        <path
          id="Vector-2"
          data-name="Vector"
          d="M6.667,3.333A3.333,3.333,0,1,1,3.333,0,3.333,3.333,0,0,1,6.667,3.333Z"
          transform="translate(245.667 197.766)"
          fill="none"
          stroke="#909090"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.2"
        />
      </g>
      <rect id="Box" width="32" height="32" fill="none" />
    </svg>
  );
}

export function ic_undo() {
  return (
    <svg
      id="ic_undo"
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
    >
      <rect id="Box" width="32" height="32" fill="none" />
      <g id="undo" transform="translate(-104.87 -312.675)">
        <path
          id="Vector"
          d="M3.321,11.07h8.856a5.535,5.535,0,0,0,0-11.07H0"
          transform="translate(112.158 324.59)"
          fill="none"
          stroke="#1a1a1a"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
        />
        <path
          id="Vector-2"
          data-name="Vector"
          d="M2.834,5.668,0,2.834,2.834,0"
          transform="translate(111.87 321.69)"
          fill="none"
          stroke="#1a1a1a"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
        />
      </g>
    </svg>
  );
}

export function ill_code_fmi_fr() {
  <svg
    id="ill_code_fmi"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width="369"
    height="124.002"
    viewBox="0 0 369 124.002"
  >
    <defs>
      <filter
        id="Union_7"
        x="104.999"
        y="69"
        width="49.999"
        height="55.002"
        filterUnits="userSpaceOnUse"
      >
        <feOffset dy="3" input="SourceAlpha" />
        <feGaussianBlur stdDeviation="3" result="blur" />
        <feFlood flood-opacity="0.078" />
        <feComposite operator="in" in2="blur" />
        <feComposite in="SourceGraphic" />
      </filter>
      <filter
        id="BG"
        x="136.998"
        y="3"
        width="58"
        height="64.254"
        filterUnits="userSpaceOnUse"
      >
        <feOffset dy="3" input="SourceAlpha" />
        <feGaussianBlur stdDeviation="3" result="blur-2" />
        <feFlood flood-opacity="0.078" />
        <feComposite operator="in" in2="blur-2" />
        <feComposite in="SourceGraphic" />
      </filter>
    </defs>
    <rect id="BG-2" data-name="BG" width="369" height="124" fill="none" />
    <g id="Error" transform="translate(737 -299)">
      <g
        id="BG-3"
        data-name="BG"
        transform="translate(-716 349)"
        fill="#fff"
        stroke="#f0f0f0"
        strokeWidth="1"
      >
        <rect width="322" height="32" rx="4" stroke="none" />
        <rect x="0.5" y="0.5" width="321" height="31" rx="3.5" fill="none" />
      </g>
      <path
        id="Code"
        d="M6.174-2.492V-10H4.844v7.308A2.255,2.255,0,0,1,4.5-1.372a1.428,1.428,0,0,1-1.253.49,1.909,1.909,0,0,1-.8-.147,1.155,1.155,0,0,1-.49-.413,1.727,1.727,0,0,1-.245-.63,4.233,4.233,0,0,1-.07-.8v-.42H.308v.616A2.884,2.884,0,0,0,1.064-.511,2.967,2.967,0,0,0,3.22.224,3.744,3.744,0,0,0,4.627-.007a2.412,2.412,0,0,0,.91-.616,2.29,2.29,0,0,0,.49-.875A3.442,3.442,0,0,0,6.174-2.492ZM12.754,0V-9.926h-.91A2.182,2.182,0,0,1,11.48-9a1.963,1.963,0,0,1-.651.574,2.676,2.676,0,0,1-.861.287,6.128,6.128,0,0,1-.98.077v.952h2.576V0Zm5.18-2.394h-1.19a2.556,2.556,0,0,0,.938,1.918,3.318,3.318,0,0,0,2.072.63,2.824,2.824,0,0,0,2.625-1.379A7.821,7.821,0,0,0,23.2-5.18a8.333,8.333,0,0,0-.273-2.331A3.87,3.87,0,0,0,22.19-8.96a2.528,2.528,0,0,0-1.078-.749A3.932,3.932,0,0,0,19.8-9.926a3.548,3.548,0,0,0-1.316.238,3.064,3.064,0,0,0-1.036.665A2.953,2.953,0,0,0,16.772-8a3.494,3.494,0,0,0-.238,1.309,4.272,4.272,0,0,0,.2,1.344,2.842,2.842,0,0,0,.6,1.05,2.762,2.762,0,0,0,.987.679,3.469,3.469,0,0,0,1.344.245,2.557,2.557,0,0,0,1.344-.371,2.549,2.549,0,0,0,.952-1l.028.028a6.324,6.324,0,0,1-.6,2.891,1.775,1.775,0,0,1-1.638.945,1.983,1.983,0,0,1-1.232-.392A1.515,1.515,0,0,1,17.934-2.394Zm3.85-4.214a2.5,2.5,0,0,1-.14.833,2.09,2.09,0,0,1-.406.7,1.931,1.931,0,0,1-.644.476,1.975,1.975,0,0,1-.84.175,1.773,1.773,0,0,1-.791-.175,1.965,1.965,0,0,1-.616-.469,2.23,2.23,0,0,1-.406-.672,2.145,2.145,0,0,1-.147-.784,3.624,3.624,0,0,1,.1-.882,2.232,2.232,0,0,1,.336-.749,1.683,1.683,0,0,1,.6-.525,1.913,1.913,0,0,1,.9-.2,2.012,2.012,0,0,1,.882.182,1.855,1.855,0,0,1,.637.5,2.2,2.2,0,0,1,.392.721A2.771,2.771,0,0,1,21.784-6.608ZM27.4-5.67v1.008a5.763,5.763,0,0,1,.714-.042,2.808,2.808,0,0,1,.833.119,1.8,1.8,0,0,1,.665.364,1.816,1.816,0,0,1,.448.6,1.9,1.9,0,0,1,.168.819,1.8,1.8,0,0,1-.175.8,1.81,1.81,0,0,1-.469.6,2.127,2.127,0,0,1-.686.378,2.553,2.553,0,0,1-.826.133,1.953,1.953,0,0,1-1.554-.609,2.419,2.419,0,0,1-.56-1.575h-1.19a3.623,3.623,0,0,0,.217,1.372,2.726,2.726,0,0,0,.665,1.015,2.819,2.819,0,0,0,1.05.623,4.233,4.233,0,0,0,1.372.21,4.534,4.534,0,0,0,1.323-.189A3.124,3.124,0,0,0,30.478-.6a2.735,2.735,0,0,0,.735-.945,2.983,2.983,0,0,0,.273-1.309,2.725,2.725,0,0,0-.441-1.554,2.068,2.068,0,0,0-1.351-.854v-.028a2.507,2.507,0,0,0,.98-.784,1.919,1.919,0,0,0,.392-1.19,2.834,2.834,0,0,0-.231-1.19,2.209,2.209,0,0,0-.637-.826,2.77,2.77,0,0,0-.959-.483,4.266,4.266,0,0,0-1.2-.161,3.359,3.359,0,0,0-1.309.238,2.607,2.607,0,0,0-.945.658,2.9,2.9,0,0,0-.581,1.008,4.518,4.518,0,0,0-.231,1.3h1.19a2.993,2.993,0,0,1,.112-.826,1.975,1.975,0,0,1,.343-.686,1.669,1.669,0,0,1,.588-.469,1.871,1.871,0,0,1,.833-.175,1.967,1.967,0,0,1,1.26.4,1.434,1.434,0,0,1,.5,1.2,1.544,1.544,0,0,1-.154.7,1.48,1.48,0,0,1-.413.511,1.837,1.837,0,0,1-.6.308,2.45,2.45,0,0,1-.721.105h-.392A.649.649,0,0,1,27.4-5.67ZM34.51-2.394H33.32a2.556,2.556,0,0,0,.938,1.918,3.318,3.318,0,0,0,2.072.63,2.824,2.824,0,0,0,2.625-1.379,7.821,7.821,0,0,0,.819-3.955A8.333,8.333,0,0,0,39.5-7.511a3.87,3.87,0,0,0-.735-1.449,2.528,2.528,0,0,0-1.078-.749,3.932,3.932,0,0,0-1.316-.217,3.548,3.548,0,0,0-1.316.238,3.064,3.064,0,0,0-1.036.665A2.953,2.953,0,0,0,33.348-8a3.494,3.494,0,0,0-.238,1.309,4.272,4.272,0,0,0,.2,1.344,2.842,2.842,0,0,0,.6,1.05,2.762,2.762,0,0,0,.987.679,3.469,3.469,0,0,0,1.344.245,2.557,2.557,0,0,0,1.344-.371,2.55,2.55,0,0,0,.952-1l.028.028a6.324,6.324,0,0,1-.6,2.891,1.775,1.775,0,0,1-1.638.945A1.983,1.983,0,0,1,35.1-1.274,1.515,1.515,0,0,1,34.51-2.394Zm3.85-4.214a2.5,2.5,0,0,1-.14.833,2.09,2.09,0,0,1-.406.7,1.931,1.931,0,0,1-.644.476,1.975,1.975,0,0,1-.84.175,1.773,1.773,0,0,1-.791-.175,1.965,1.965,0,0,1-.616-.469,2.23,2.23,0,0,1-.406-.672,2.145,2.145,0,0,1-.147-.784,3.624,3.624,0,0,1,.1-.882,2.232,2.232,0,0,1,.336-.749,1.683,1.683,0,0,1,.6-.525,1.913,1.913,0,0,1,.9-.2,2.012,2.012,0,0,1,.882.182,1.855,1.855,0,0,1,.637.5,2.2,2.2,0,0,1,.392.721A2.771,2.771,0,0,1,38.36-6.608Zm9.674.924V-7.238H46.48v1.554ZM46.48-1.554V0h1.554V-1.554ZM57.3-5.838v1.4q.364,0,.763.021a2.315,2.315,0,0,1,.735.154,1.244,1.244,0,0,1,.553.427,1.424,1.424,0,0,1,.217.854,1.435,1.435,0,0,1-.462,1.127,1.64,1.64,0,0,1-1.134.413,1.689,1.689,0,0,1-.749-.154,1.531,1.531,0,0,1-.525-.413,1.842,1.842,0,0,1-.322-.616,2.828,2.828,0,0,1-.126-.749h-1.89a3.928,3.928,0,0,0,.245,1.512,3.072,3.072,0,0,0,.735,1.113A3.157,3.157,0,0,0,56.5-.056,4.525,4.525,0,0,0,58,.182a4.485,4.485,0,0,0,1.372-.21,3.555,3.555,0,0,0,1.162-.616,3,3,0,0,0,.805-1.008,3.027,3.027,0,0,0,.3-1.372,2.3,2.3,0,0,0-.462-1.442,2.134,2.134,0,0,0-1.274-.784v-.028a1.72,1.72,0,0,0,1.029-.742,2.318,2.318,0,0,0,.343-1.26,2.264,2.264,0,0,0-.294-1.162,2.842,2.842,0,0,0-.763-.854,3.347,3.347,0,0,0-1.057-.525A4.1,4.1,0,0,0,57.988-10a3.683,3.683,0,0,0-1.372.245,3.039,3.039,0,0,0-1.057.693,3.149,3.149,0,0,0-.686,1.071A4.165,4.165,0,0,0,54.6-6.608h1.89a1.924,1.924,0,0,1,.371-1.253A1.354,1.354,0,0,1,58-8.358a1.5,1.5,0,0,1,.966.336,1.165,1.165,0,0,1,.42.966,1.04,1.04,0,0,1-.2.672A1.3,1.3,0,0,1,58.667-6a2.159,2.159,0,0,1-.679.161A4.2,4.2,0,0,1,57.3-5.838Zm8.288,0v1.4q.364,0,.763.021a2.315,2.315,0,0,1,.735.154,1.244,1.244,0,0,1,.553.427,1.424,1.424,0,0,1,.217.854A1.435,1.435,0,0,1,67.4-1.855a1.64,1.64,0,0,1-1.134.413,1.689,1.689,0,0,1-.749-.154,1.531,1.531,0,0,1-.525-.413,1.842,1.842,0,0,1-.322-.616,2.828,2.828,0,0,1-.126-.749H62.65A3.928,3.928,0,0,0,62.9-1.862,3.072,3.072,0,0,0,63.63-.749a3.157,3.157,0,0,0,1.155.693A4.525,4.525,0,0,0,66.29.182a4.485,4.485,0,0,0,1.372-.21,3.555,3.555,0,0,0,1.162-.616,3,3,0,0,0,.805-1.008,3.027,3.027,0,0,0,.3-1.372,2.3,2.3,0,0,0-.462-1.442,2.134,2.134,0,0,0-1.274-.784v-.028a1.72,1.72,0,0,0,1.029-.742,2.318,2.318,0,0,0,.343-1.26,2.263,2.263,0,0,0-.294-1.162,2.842,2.842,0,0,0-.763-.854,3.347,3.347,0,0,0-1.057-.525A4.1,4.1,0,0,0,66.276-10a3.683,3.683,0,0,0-1.372.245,3.039,3.039,0,0,0-1.057.693,3.149,3.149,0,0,0-.686,1.071,4.165,4.165,0,0,0-.273,1.379h1.89a1.924,1.924,0,0,1,.371-1.253,1.354,1.354,0,0,1,1.141-.5,1.5,1.5,0,0,1,.966.336,1.165,1.165,0,0,1,.42.966,1.04,1.04,0,0,1-.2.672A1.3,1.3,0,0,1,66.955-6a2.159,2.159,0,0,1-.679.161A4.2,4.2,0,0,1,65.59-5.838Zm9.1.756a1.336,1.336,0,0,1,.665.161,1.4,1.4,0,0,1,.469.42,1.889,1.889,0,0,1,.273.588,2.535,2.535,0,0,1,.091.679,2.248,2.248,0,0,1-.1.658A1.76,1.76,0,0,1,75.8-2a1.561,1.561,0,0,1-.469.406,1.275,1.275,0,0,1-.637.154,1.427,1.427,0,0,1-.672-.154,1.52,1.52,0,0,1-.5-.413,1.861,1.861,0,0,1-.308-.588,2.175,2.175,0,0,1-.105-.665,2.415,2.415,0,0,1,.1-.693,1.749,1.749,0,0,1,.294-.581,1.394,1.394,0,0,1,.5-.4A1.56,1.56,0,0,1,74.69-5.082Zm1.428-2.2h1.89a3.39,3.39,0,0,0-.35-1.162,2.715,2.715,0,0,0-.686-.847,3.022,3.022,0,0,0-.966-.525A3.7,3.7,0,0,0,74.83-10a3.252,3.252,0,0,0-1.778.462,3.785,3.785,0,0,0-1.19,1.2,5.308,5.308,0,0,0-.672,1.645,8.07,8.07,0,0,0-.21,1.82,10.044,10.044,0,0,0,.168,1.841,4.759,4.759,0,0,0,.6,1.617A3.4,3.4,0,0,0,72.912-.259a3.488,3.488,0,0,0,1.834.441,3.485,3.485,0,0,0,1.4-.273,3.244,3.244,0,0,0,1.085-.756,3.359,3.359,0,0,0,.7-1.134,3.963,3.963,0,0,0,.245-1.407,3.824,3.824,0,0,0-.182-1.162,2.837,2.837,0,0,0-.574-1.022A3.083,3.083,0,0,0,76.4-6.307a2.954,2.954,0,0,0-1.232-.273,2.977,2.977,0,0,0-1.26.252,2.377,2.377,0,0,0-.952.84l-.028-.028a6.178,6.178,0,0,1,.112-.924,4.155,4.155,0,0,1,.308-.973,2.3,2.3,0,0,1,.567-.77A1.3,1.3,0,0,1,74.8-8.5a1.156,1.156,0,0,1,.868.364A1.686,1.686,0,0,1,76.118-7.28ZM84.462,0V-9.8H82.88a2.164,2.164,0,0,1-.35.938,2.13,2.13,0,0,1-.651.609,2.611,2.611,0,0,1-.868.322,4.706,4.706,0,0,1-1,.077v1.5h2.464V0ZM95.55-10.234,91.42.224h1.008l4.144-10.458ZM114.6-4.452v1.12h4.046v-1.12Z"
        transform="translate(-676 371)"
        fill="#1a1a1a"
      />
      <path
        id="_5"
        data-name="5"
        d="M108.22-8.162V-9.8h-5.474l-.966,5.418h1.792a2.026,2.026,0,0,1,.63-.6,1.759,1.759,0,0,1,.868-.189,1.71,1.71,0,0,1,.714.14,1.577,1.577,0,0,1,.532.392,1.668,1.668,0,0,1,.336.588,2.243,2.243,0,0,1,.112.714,2.142,2.142,0,0,1-.119.707,1.894,1.894,0,0,1-.336.6,1.686,1.686,0,0,1-.532.42,1.531,1.531,0,0,1-.707.161,1.571,1.571,0,0,1-1.106-.4,1.626,1.626,0,0,1-.5-1.071h-1.988a3.019,3.019,0,0,0,.315,1.351,2.914,2.914,0,0,0,.805.973,3.408,3.408,0,0,0,1.155.581,4.871,4.871,0,0,0,1.365.189,3.6,3.6,0,0,0,1.4-.245A3.511,3.511,0,0,0,107.667-.8a3.587,3.587,0,0,0,.791-1.127,3.378,3.378,0,0,0,.294-1.407,4.069,4.069,0,0,0-.2-1.295,3.111,3.111,0,0,0-.588-1.057,2.829,2.829,0,0,0-.945-.714,2.969,2.969,0,0,0-1.288-.266,2.949,2.949,0,0,0-1.05.175,2.469,2.469,0,0,0-.868.581l-.028-.028.392-2.226Z"
        transform="translate(-676 371)"
        fill="#dc4405"
      />
      <g id="Icon" transform="translate(-1520 16730)">
        <g id="ic_tele_error" transform="translate(812 -16377)">
          <g id="ic_warning">
            <rect id="Box" width="24" height="24" fill="none" />
            <path
              id="Icon-2"
              data-name="Icon"
              d="M8.252,3.147a2,2,0,0,1,3.5,0l6.6,11.882A2,2,0,0,1,16.6,18H3.4a2,2,0,0,1-1.748-2.971Z"
              transform="translate(2 2)"
              fill="#ff0700"
            />
          </g>
        </g>
        <path
          id="_1"
          data-name="1"
          d="M3.528,0V-6.3H2.511a1.391,1.391,0,0,1-.225.6,1.369,1.369,0,0,1-.419.391,1.679,1.679,0,0,1-.558.207,3.025,3.025,0,0,1-.643.05v.963H2.25V0Z"
          transform="translate(821.5 -16360)"
          fill="#fff"
        />
      </g>
      <path
        id="Code-2"
        data-name="Code"
        d="M1.148-10V0h1.33V-10ZM4.522-7.238V0h1.19V-4.088a2.932,2.932,0,0,1,.133-.9,2.051,2.051,0,0,1,.4-.721,1.772,1.772,0,0,1,.665-.476,2.425,2.425,0,0,1,.945-.168,1.457,1.457,0,0,1,1.078.392A1.438,1.438,0,0,1,9.324-4.9V0h1.19V-4.76A4.479,4.479,0,0,0,10.4-5.831a2.028,2.028,0,0,0-.413-.833,1.956,1.956,0,0,0-.77-.546,3.141,3.141,0,0,0-1.19-.2A2.506,2.506,0,0,0,5.67-6.09H5.642V-7.238Zm9.044-1.3V-10h-1.19V-8.54Zm0,9.45V-7.238h-1.19V.714a1.535,1.535,0,0,1-.14.777.586.586,0,0,1-.532.217h-.252a.743.743,0,0,1-.1-.007q-.049-.007-.119-.021V2.7a3.069,3.069,0,0,0,.6.056A1.775,1.775,0,0,0,13.1,2.317,1.854,1.854,0,0,0,13.566.91ZM20.44-4.312H16.282a2.479,2.479,0,0,1,.182-.791,2.11,2.11,0,0,1,.42-.651,1.924,1.924,0,0,1,.637-.441,2.072,2.072,0,0,1,.833-.161,2.036,2.036,0,0,1,.819.161,2.061,2.061,0,0,1,.644.434,2.04,2.04,0,0,1,.434.651A2.435,2.435,0,0,1,20.44-4.312ZM21.588-2.3H20.412a1.692,1.692,0,0,1-.637,1.064,2.06,2.06,0,0,1-1.239.35,2.465,2.465,0,0,1-1.022-.2A2,2,0,0,1,16.8-1.6a2.045,2.045,0,0,1-.406-.756,2.873,2.873,0,0,1-.112-.9H21.7a5.762,5.762,0,0,0-.119-1.386,4.012,4.012,0,0,0-.532-1.344,3.17,3.17,0,0,0-1.022-1.015,2.969,2.969,0,0,0-1.6-.4,3.291,3.291,0,0,0-1.365.28,3.208,3.208,0,0,0-1.078.784,3.614,3.614,0,0,0-.707,1.19,4.355,4.355,0,0,0-.252,1.512,5.8,5.8,0,0,0,.245,1.526,3.33,3.33,0,0,0,.651,1.2,2.967,2.967,0,0,0,1.071.784,3.718,3.718,0,0,0,1.5.28,3.285,3.285,0,0,0,2.044-.616A2.892,2.892,0,0,0,21.588-2.3Zm6.258-2.618h1.232a2.861,2.861,0,0,0-.336-1.113,2.484,2.484,0,0,0-.679-.777,2.813,2.813,0,0,0-.952-.455,4.374,4.374,0,0,0-1.155-.147,3.5,3.5,0,0,0-1.5.3,2.99,2.99,0,0,0-1.071.826,3.513,3.513,0,0,0-.637,1.232,5.311,5.311,0,0,0-.21,1.519,4.877,4.877,0,0,0,.217,1.491A3.27,3.27,0,0,0,23.4-.868a2.837,2.837,0,0,0,1.064.756,3.77,3.77,0,0,0,1.463.266,3.145,3.145,0,0,0,2.191-.728,3.333,3.333,0,0,0,1-2.072H27.9a2.086,2.086,0,0,1-.609,1.3,1.947,1.947,0,0,1-1.379.462,1.97,1.97,0,0,1-.966-.224A1.88,1.88,0,0,1,24.29-1.7a2.627,2.627,0,0,1-.371-.847,4.025,4.025,0,0,1-.119-.98,4.923,4.923,0,0,1,.112-1.057,2.651,2.651,0,0,1,.371-.9,1.922,1.922,0,0,1,.693-.63,2.219,2.219,0,0,1,1.078-.238,1.806,1.806,0,0,1,1.2.378A1.814,1.814,0,0,1,27.846-4.914ZM32.1-7.238v-2.17h-1.19v2.17H29.68v1.05h1.232v4.606a2.75,2.75,0,0,0,.1.812.987.987,0,0,0,.3.476,1.162,1.162,0,0,0,.532.231A4.273,4.273,0,0,0,32.634,0h.91V-1.05H33a3.969,3.969,0,0,1-.455-.021.588.588,0,0,1-.273-.091.346.346,0,0,1-.133-.2,1.3,1.3,0,0,1-.035-.336V-6.188h1.442v-1.05Zm7.784,2.926H35.728A2.479,2.479,0,0,1,35.91-5.1a2.11,2.11,0,0,1,.42-.651,1.924,1.924,0,0,1,.637-.441,2.072,2.072,0,0,1,.833-.161,2.036,2.036,0,0,1,.819.161,2.061,2.061,0,0,1,.644.434,2.04,2.04,0,0,1,.434.651A2.435,2.435,0,0,1,39.886-4.312ZM41.034-2.3H39.858a1.692,1.692,0,0,1-.637,1.064,2.06,2.06,0,0,1-1.239.35,2.465,2.465,0,0,1-1.022-.2,2,2,0,0,1-.714-.525,2.045,2.045,0,0,1-.406-.756,2.873,2.873,0,0,1-.112-.9h5.418a5.763,5.763,0,0,0-.119-1.386A4.012,4.012,0,0,0,40.5-5.992a3.17,3.17,0,0,0-1.022-1.015,2.969,2.969,0,0,0-1.6-.4,3.291,3.291,0,0,0-1.365.28,3.208,3.208,0,0,0-1.078.784,3.614,3.614,0,0,0-.707,1.19,4.356,4.356,0,0,0-.252,1.512,5.8,5.8,0,0,0,.245,1.526,3.33,3.33,0,0,0,.651,1.2,2.967,2.967,0,0,0,1.071.784,3.718,3.718,0,0,0,1.505.28,3.285,3.285,0,0,0,2.044-.616A2.892,2.892,0,0,0,41.034-2.3ZM48.37,0V-7.238H47.18V-3.15a2.932,2.932,0,0,1-.133.9,2.051,2.051,0,0,1-.4.721,1.772,1.772,0,0,1-.665.476,2.425,2.425,0,0,1-.945.168,1.457,1.457,0,0,1-1.078-.392,1.438,1.438,0,0,1-.392-1.064v-4.9h-1.19v4.76A4.479,4.479,0,0,0,42.5-1.407a2.028,2.028,0,0,0,.413.833,1.9,1.9,0,0,0,.77.539,3.246,3.246,0,0,0,1.19.189,2.894,2.894,0,0,0,1.386-.315,2.432,2.432,0,0,0,.966-.987h.028V0Zm1.75-7.238V0h1.19V-3.22a4.948,4.948,0,0,1,.14-1.239,2.375,2.375,0,0,1,.448-.917,1.92,1.92,0,0,1,.812-.574,3.366,3.366,0,0,1,1.218-.2v-1.26a2.674,2.674,0,0,0-1.6.392,3.224,3.224,0,0,0-1.064,1.3H51.24V-7.238ZM58.912-10V0h1.33V-4.578h4.592V-5.7H60.242V-8.876h5.236V-10Zm8.036,0V0h6.944V-1.12H68.278V-4.578h5.194V-5.7H68.278V-8.876H73.85V-10ZM76.832-1.12V-8.876h2.24a4.1,4.1,0,0,1,1.554.259,2.521,2.521,0,0,1,1.029.756,3.073,3.073,0,0,1,.574,1.2,6.691,6.691,0,0,1,.175,1.6,5.707,5.707,0,0,1-.189,1.575,3.836,3.836,0,0,1-.483,1.085,2.527,2.527,0,0,1-.665.686,3.263,3.263,0,0,1-.749.385,3.141,3.141,0,0,1-.714.168,5.578,5.578,0,0,1-.56.035ZM75.5-10V0h3.43a6,6,0,0,0,2.156-.35,3.762,3.762,0,0,0,1.5-1.015A4.174,4.174,0,0,0,83.454-3a8.091,8.091,0,0,0,.28-2.233A4.708,4.708,0,0,0,82.488-8.82,4.984,4.984,0,0,0,78.932-10ZM93.968-4.914H95.2a2.861,2.861,0,0,0-.336-1.113,2.484,2.484,0,0,0-.679-.777,2.813,2.813,0,0,0-.952-.455,4.374,4.374,0,0,0-1.155-.147,3.5,3.5,0,0,0-1.5.3,2.99,2.99,0,0,0-1.071.826,3.513,3.513,0,0,0-.637,1.232,5.311,5.311,0,0,0-.21,1.519,4.877,4.877,0,0,0,.217,1.491,3.27,3.27,0,0,0,.644,1.169,2.837,2.837,0,0,0,1.064.756A3.77,3.77,0,0,0,92.05.154a3.145,3.145,0,0,0,2.191-.728,3.333,3.333,0,0,0,1-2.072H94.024a2.086,2.086,0,0,1-.609,1.3,1.947,1.947,0,0,1-1.379.462,1.97,1.97,0,0,1-.966-.224,1.88,1.88,0,0,1-.658-.595,2.627,2.627,0,0,1-.371-.847,4.025,4.025,0,0,1-.119-.98,4.923,4.923,0,0,1,.112-1.057,2.651,2.651,0,0,1,.371-.9,1.922,1.922,0,0,1,.693-.63,2.219,2.219,0,0,1,1.078-.238,1.806,1.806,0,0,1,1.2.378A1.814,1.814,0,0,1,93.968-4.914Zm3.472,1.3a3.6,3.6,0,0,1,.175-1.169,2.523,2.523,0,0,1,.483-.861,2.057,2.057,0,0,1,.721-.532,2.146,2.146,0,0,1,.875-.182,2.146,2.146,0,0,1,.875.182,2.057,2.057,0,0,1,.721.532,2.523,2.523,0,0,1,.483.861,3.6,3.6,0,0,1,.175,1.169,3.6,3.6,0,0,1-.175,1.169,2.446,2.446,0,0,1-.483.854,2.1,2.1,0,0,1-.721.525,2.146,2.146,0,0,1-.875.182,2.146,2.146,0,0,1-.875-.182,2.1,2.1,0,0,1-.721-.525,2.446,2.446,0,0,1-.483-.854A3.6,3.6,0,0,1,97.44-3.612Zm-1.26,0A4.755,4.755,0,0,0,96.4-2.128a3.387,3.387,0,0,0,.672,1.2,3.091,3.091,0,0,0,1.106.8,3.75,3.75,0,0,0,1.512.287,3.738,3.738,0,0,0,1.519-.287,3.106,3.106,0,0,0,1.1-.8,3.387,3.387,0,0,0,.672-1.2,4.755,4.755,0,0,0,.224-1.484,4.821,4.821,0,0,0-.224-1.491,3.378,3.378,0,0,0-.672-1.2,3.182,3.182,0,0,0-1.1-.805,3.66,3.66,0,0,0-1.519-.294,3.673,3.673,0,0,0-1.512.294,3.166,3.166,0,0,0-1.106.805A3.378,3.378,0,0,0,96.4-5.1,4.821,4.821,0,0,0,96.18-3.612ZM110.6,0V-7.238h-1.19V-3.15a2.932,2.932,0,0,1-.133.9,2.051,2.051,0,0,1-.4.721,1.772,1.772,0,0,1-.665.476,2.425,2.425,0,0,1-.945.168,1.457,1.457,0,0,1-1.078-.392,1.438,1.438,0,0,1-.392-1.064v-4.9h-1.19v4.76a4.479,4.479,0,0,0,.119,1.071,2.028,2.028,0,0,0,.413.833,1.9,1.9,0,0,0,.77.539,3.246,3.246,0,0,0,1.19.189,2.894,2.894,0,0,0,1.386-.315,2.432,2.432,0,0,0,.966-.987h.028V0Zm1.75-7.238V0h1.19V-3.22a4.949,4.949,0,0,1,.14-1.239,2.375,2.375,0,0,1,.448-.917,1.92,1.92,0,0,1,.812-.574,3.366,3.366,0,0,1,1.218-.2v-1.26a2.674,2.674,0,0,0-1.6.392,3.224,3.224,0,0,0-1.064,1.3h-.028V-7.238Zm6.356,0v-2.17h-1.19v2.17h-1.232v1.05h1.232v4.606a2.75,2.75,0,0,0,.1.812.987.987,0,0,0,.3.476,1.162,1.162,0,0,0,.532.231,4.273,4.273,0,0,0,.791.063h.91V-1.05H119.6a3.969,3.969,0,0,1-.455-.021.588.588,0,0,1-.273-.091.346.346,0,0,1-.133-.2,1.3,1.3,0,0,1-.035-.336V-6.188h1.442v-1.05Zm2.562,2.786v1.12h4.046v-1.12Zm10.556-.462h1.232a2.861,2.861,0,0,0-.336-1.113,2.484,2.484,0,0,0-.679-.777,2.813,2.813,0,0,0-.952-.455,4.374,4.374,0,0,0-1.155-.147,3.5,3.5,0,0,0-1.5.3,2.99,2.99,0,0,0-1.071.826,3.513,3.513,0,0,0-.637,1.232,5.311,5.311,0,0,0-.21,1.519,4.877,4.877,0,0,0,.217,1.491,3.27,3.27,0,0,0,.644,1.169,2.837,2.837,0,0,0,1.064.756,3.77,3.77,0,0,0,1.463.266A3.145,3.145,0,0,0,132.1-.574a3.333,3.333,0,0,0,1-2.072H131.88a2.086,2.086,0,0,1-.609,1.3,1.947,1.947,0,0,1-1.379.462,1.97,1.97,0,0,1-.966-.224,1.88,1.88,0,0,1-.658-.595,2.627,2.627,0,0,1-.371-.847,4.025,4.025,0,0,1-.119-.98,4.923,4.923,0,0,1,.112-1.057,2.651,2.651,0,0,1,.371-.9,1.922,1.922,0,0,1,.693-.63,2.219,2.219,0,0,1,1.078-.238,1.806,1.806,0,0,1,1.2.378A1.814,1.814,0,0,1,131.824-4.914Zm3.864-3.626V-10H134.5V-8.54Zm-1.19,1.3V0h1.19V-7.238Zm13.02,5.684V0h1.554V-1.554Zm-4.662,0V0h1.554V-1.554Zm-4.662,0V0h1.554V-1.554Z"
        transform="translate(-552 371)"
        fill="#1a1a1a"
      />
    </g>
    <g id="Dot" transform="translate(-1097 -406)">
      <g transform="matrix(1, 0, 0, 1, 1097, 406)" filter="url(#Union_7)">
        <g
          id="Union_7-2"
          data-name="Union 7"
          transform="translate(112 -17826)"
          fill="#f7f7f7"
        >
          <path
            d="M 17.99838066101074 17937.501953125 C 13.8585205078125 17937.501953125 9.966150283813477 17935.888671875 7.038280487060547 17932.9609375 C 4.110960483551025 17930.033203125 2.498820543289185 17926.140625 2.498820543289185 17922.001953125 C 2.498820543289185 17920.201171875 2.804490566253662 17918.4375 3.407330751419067 17916.759765625 C 3.989920616149902 17915.138671875 4.836010456085205 17913.6328125 5.922080516815186 17912.28515625 C 8.097220420837402 17909.583984375 11.144850730896 17907.671875 14.50354099273682 17906.896484375 L 14.69706058502197 17906.853515625 L 14.80723094940186 17906.6875 L 17.99838066101074 17901.900390625 L 21.18954086303711 17906.6875 L 21.29971122741699 17906.853515625 L 21.49323081970215 17906.896484375 C 24.85192108154297 17907.671875 27.89953994750977 17909.583984375 30.0746898651123 17912.28515625 C 31.1607608795166 17913.6328125 32.00683975219727 17915.138671875 32.58943176269531 17916.759765625 C 33.1922721862793 17918.4375 33.49794006347656 17920.201171875 33.49794006347656 17922.001953125 C 33.49794006347656 17926.140625 31.88580131530762 17930.033203125 28.95848083496094 17932.9609375 C 26.03061103820801 17935.888671875 22.13824081420898 17937.501953125 17.99838066101074 17937.501953125 Z"
            stroke="none"
          />
          <path
            d="M 17.99838066101074 17937.001953125 C 22.00466156005859 17937.001953125 25.77145004272461 17935.44140625 28.60488128662109 17932.607421875 C 31.43778991699219 17929.7734375 32.99794006347656 17926.0078125 32.99794006347656 17922.001953125 C 32.99794006347656 17920.259765625 32.70217895507812 17918.552734375 32.11886978149414 17916.9296875 C 31.55515098571777 17915.359375 30.73640060424805 17913.90234375 29.68534088134766 17912.59765625 C 27.58017158508301 17909.986328125 24.63092994689941 17908.134765625 21.38090133666992 17907.384765625 L 20.99386024475098 17907.294921875 L 20.77353096008301 17906.96484375 L 17.99838256835938 17902.802734375 L 15.00291061401367 17907.294921875 L 14.61587047576904 17907.384765625 C 11.36584091186523 17908.134765625 8.416600227355957 17909.986328125 6.311420440673828 17912.59765625 C 5.26037073135376 17913.90234375 4.441610813140869 17915.359375 3.877890586853027 17916.9296875 C 3.294580698013306 17918.552734375 2.998820543289185 17920.259765625 2.998820543289185 17922.001953125 C 2.998820543289185 17926.0078125 4.55897045135498 17929.7734375 7.391880512237549 17932.607421875 C 10.22531032562256 17935.44140625 13.99210071563721 17937.001953125 17.99838066101074 17937.001953125 M 17.99838066101074 17938.001953125 C 9.161260604858398 17938.001953125 1.998820662498474 17930.833984375 1.998820662498474 17922.001953125 C 1.998820662498474 17914.404296875 7.291800498962402 17908.046875 14.39122104644775 17906.41015625 L 17.99838066101074 17901 L 21.60555076599121 17906.41015625 C 28.70497131347656 17908.046875 33.99794006347656 17914.404296875 33.99794006347656 17922.001953125 C 33.99794006347656 17930.833984375 26.83550071716309 17938.001953125 17.99838066101074 17938.001953125 Z"
            stroke="none"
            fill="#ccc"
          />
        </g>
      </g>
      <path
        id="NPS"
        d="M-8.635-6.426V0h1.323V-4.3h.018L-4.622,0h1.413V-6.426H-4.532v4.311H-4.55L-7.232-6.426ZM-.554-3.4V-5.328h1.1a2.959,2.959,0,0,1,.468.036,1.089,1.089,0,0,1,.4.139.76.76,0,0,1,.275.293,1.028,1.028,0,0,1,.1.495,1.028,1.028,0,0,1-.1.5.76.76,0,0,1-.275.293,1.089,1.089,0,0,1-.4.14A2.959,2.959,0,0,1,.544-3.4ZM-1.967-6.426V0H-.554V-2.3H.931A2.676,2.676,0,0,0,1.957-2.48a1.92,1.92,0,0,0,.688-.463A1.775,1.775,0,0,0,3.033-3.6a2.444,2.444,0,0,0,.122-.761,2.43,2.43,0,0,0-.122-.765,1.781,1.781,0,0,0-.387-.657,1.92,1.92,0,0,0-.688-.464A2.676,2.676,0,0,0,.931-6.426ZM5-2.133H3.631a2.122,2.122,0,0,0,.216,1.026A2.023,2.023,0,0,0,4.455-.4a2.592,2.592,0,0,0,.882.409,4.06,4.06,0,0,0,1.03.131A3.957,3.957,0,0,0,7.524-.009a2.446,2.446,0,0,0,.837-.428,1.779,1.779,0,0,0,.508-.652,1.964,1.964,0,0,0,.171-.819,1.575,1.575,0,0,0-.229-.886,1.917,1.917,0,0,0-.545-.554,2.394,2.394,0,0,0-.635-.3q-.319-.094-.5-.131-.6-.153-.976-.252a3.622,3.622,0,0,1-.585-.2.643.643,0,0,1-.284-.216.578.578,0,0,1-.072-.306.6.6,0,0,1,.09-.342.782.782,0,0,1,.23-.225.915.915,0,0,1,.311-.126,1.656,1.656,0,0,1,.342-.036,2.41,2.41,0,0,1,.481.045,1.161,1.161,0,0,1,.391.153.8.8,0,0,1,.274.3,1.136,1.136,0,0,1,.122.477H8.824a1.974,1.974,0,0,0-.212-.95A1.844,1.844,0,0,0,8.042-6.1a2.413,2.413,0,0,0-.824-.365,4.088,4.088,0,0,0-.968-.112,3.293,3.293,0,0,0-.864.117,2.412,2.412,0,0,0-.774.36,1.916,1.916,0,0,0-.554.608,1.683,1.683,0,0,0-.211.859,1.571,1.571,0,0,0,.167.751,1.589,1.589,0,0,0,.436.517,2.412,2.412,0,0,0,.612.338,6.153,6.153,0,0,0,.7.22q.351.1.693.18a4.357,4.357,0,0,1,.612.189,1.32,1.32,0,0,1,.437.27.564.564,0,0,1,.167.423.621.621,0,0,1-.126.4.884.884,0,0,1-.315.247,1.409,1.409,0,0,1-.4.122,2.815,2.815,0,0,1-.405.031,2.148,2.148,0,0,1-.54-.067,1.344,1.344,0,0,1-.454-.207,1.022,1.022,0,0,1-.31-.365A1.179,1.179,0,0,1,5-2.133Z"
        transform="translate(1226.795 505)"
        fill="#1a1a1a"
      />
    </g>
    <g id="Dot-2" data-name="Dot" transform="translate(-1065.001 -477)">
      <g transform="matrix(1, 0, 0, 1, 1065, 477)" filter="url(#BG)">
        <path
          id="BG-4"
          data-name="BG"
          d="M0,26.254A20.006,20.006,0,0,1,15.491,6.764L20,0l4.509,6.764A20,20,0,1,1,0,26.254Z"
          transform="translate(186 55.25) rotate(180)"
          fill="#dc4405"
        />
      </g>
      <path
        id="IMD"
        d="M-9.927-7.854V0H-8.2V-7.854Zm3.245,0V0h1.617V-5.511h.022L-3.118,0h1.331L.138-5.566H.16V0H1.777V-7.854H-.655l-1.738,5.4h-.022l-1.837-5.4Zm11.7,6.4V-6.4H6.254a2.789,2.789,0,0,1,1.073.182,1.683,1.683,0,0,1,.7.523,2.14,2.14,0,0,1,.38.819A4.579,4.579,0,0,1,8.52-3.806a3.218,3.218,0,0,1-.165,1.1,2.018,2.018,0,0,1-.44.732,1.6,1.6,0,0,1-.627.4,2.218,2.218,0,0,1-.726.121Zm-1.727-6.4V0H6.683A3.76,3.76,0,0,0,8.25-.3a3.118,3.118,0,0,0,1.111-.831,3.485,3.485,0,0,0,.665-1.254,5.441,5.441,0,0,0,.22-1.584,4.894,4.894,0,0,0-.269-1.7,3.352,3.352,0,0,0-.748-1.21A3.068,3.068,0,0,0,8.1-7.612a4.044,4.044,0,0,0-1.414-.242Z"
        transform="translate(1231 510)"
        fill="#fff"
      />
    </g>
  </svg>;
}

export function ill_codes_spn_fr() {
  <svg
    id="ill_codes_spn"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width="369"
    height="127.254"
    viewBox="0 0 369 127.254"
  >
    <defs>
      <filter
        id="BG"
        x="140.998"
        y="6.252"
        width="50"
        height="55.002"
        filterUnits="userSpaceOnUse"
      >
        <feOffset dy="3" input="SourceAlpha" />
        <feGaussianBlur stdDeviation="3" result="blur" />
        <feFlood flood-opacity="0.078" />
        <feComposite operator="in" in2="blur" />
        <feComposite in="SourceGraphic" />
      </filter>
      <filter
        id="BG-2"
        x="100.998"
        y="63"
        width="58"
        height="64.254"
        filterUnits="userSpaceOnUse"
      >
        <feOffset dy="3" input="SourceAlpha" />
        <feGaussianBlur stdDeviation="3" result="blur-2" />
        <feFlood flood-opacity="0.078" />
        <feComposite operator="in" in2="blur-2" />
        <feComposite in="SourceGraphic" />
      </filter>
    </defs>
    <rect id="BG-3" data-name="BG" width="369" height="124" fill="none" />
    <g id="Error" transform="translate(737 -305)">
      <g
        id="BG-4"
        data-name="BG"
        transform="translate(-716 349)"
        fill="#fff"
        stroke="#f0f0f0"
        strokeWidth="1"
      >
        <rect width="322" height="32" rx="4" stroke="none" />
        <rect x="0.5" y="0.5" width="321" height="31" rx="3.5" fill="none" />
      </g>
      <path
        id="Code"
        d="M18697.113,700.458l4.129-10.458h1.021l-4.146,10.458Zm-90.359-.734a2.9,2.9,0,0,1-.752-2.164v-.615h1.33v.417a4.6,4.6,0,0,0,.066.8,1.681,1.681,0,0,0,.246.63,1.148,1.148,0,0,0,.492.412,1.884,1.884,0,0,0,.8.147,1.42,1.42,0,0,0,1.25-.488,2.231,2.231,0,0,0,.346-1.316v-7.31h1.33v7.5a3.594,3.594,0,0,1-.146.994,2.34,2.34,0,0,1-.492.876,2.372,2.372,0,0,1-.91.615,3.687,3.687,0,0,1-1.4.232A2.993,2.993,0,0,1,18606.754,699.725Zm104.051.691a4.817,4.817,0,0,1-1.367-.189,3.32,3.32,0,0,1-1.156-.582,2.917,2.917,0,0,1-.8-.971,3.046,3.046,0,0,1-.312-1.349h1.988a1.61,1.61,0,0,0,.5,1.07,1.575,1.575,0,0,0,1.107.4,1.494,1.494,0,0,0,.705-.161,1.662,1.662,0,0,0,.531-.421,1.79,1.79,0,0,0,.336-.6,2.117,2.117,0,0,0,.123-.705,2.206,2.206,0,0,0-.113-.715,1.725,1.725,0,0,0-.336-.587,1.59,1.59,0,0,0-.535-.393,1.671,1.671,0,0,0-.711-.142,1.814,1.814,0,0,0-.871.189,2.114,2.114,0,0,0-.629.6h-1.789l.965-5.416h5.473v1.638h-4.043l-.393,2.225.027.028a2.506,2.506,0,0,1,.867-.582,2.916,2.916,0,0,1,1.051-.175,3,3,0,0,1,1.287.265,2.839,2.839,0,0,1,.943.715,3.114,3.114,0,0,1,.592,1.056,4.151,4.151,0,0,1,.2,1.3,3.34,3.34,0,0,1-.3,1.406,3.592,3.592,0,0,1-.785,1.127,3.6,3.6,0,0,1-2.479.981Zm-70.854-.658a2.533,2.533,0,0,1-.937-1.917h1.189a1.528,1.528,0,0,0,.586,1.122,1.989,1.989,0,0,0,1.23.388,1.773,1.773,0,0,0,1.639-.942,6.263,6.263,0,0,0,.6-2.893l-.023-.028a2.606,2.606,0,0,1-.957,1,2.548,2.548,0,0,1-1.34.369,3.419,3.419,0,0,1-1.344-.246,2.739,2.739,0,0,1-.99-.677,2.883,2.883,0,0,1-.6-1.051,4.231,4.231,0,0,1-.2-1.344,3.526,3.526,0,0,1,.236-1.307,3.021,3.021,0,0,1,.672-1.023,3.106,3.106,0,0,1,1.037-.668,3.617,3.617,0,0,1,1.316-.237,3.88,3.88,0,0,1,1.316.218,2.5,2.5,0,0,1,1.08.748,3.919,3.919,0,0,1,.732,1.449,8.181,8.181,0,0,1,.275,2.329,7.86,7.86,0,0,1-.818,3.958,2.836,2.836,0,0,1-2.629,1.378A3.3,3.3,0,0,1,18639.951,699.758Zm1.15-8.2a1.748,1.748,0,0,0-.6.526,2.3,2.3,0,0,0-.336.748,3.836,3.836,0,0,0-.1.885,2.177,2.177,0,0,0,.146.781,2.313,2.313,0,0,0,.406.672,1.915,1.915,0,0,0,.617.469,1.75,1.75,0,0,0,.789.175,1.978,1.978,0,0,0,.844-.175,1.946,1.946,0,0,0,.643-.473,2.206,2.206,0,0,0,.408-.7,2.586,2.586,0,0,0,.137-.833,2.776,2.776,0,0,0-.133-.871,2.2,2.2,0,0,0-.393-.72,1.841,1.841,0,0,0-.639-.5,2.05,2.05,0,0,0-.881-.18A1.965,1.965,0,0,0,18641.1,691.553Zm-8.711,8.626a2.849,2.849,0,0,1-1.051-.625,2.741,2.741,0,0,1-.668-1.013,3.7,3.7,0,0,1-.213-1.373h1.188a2.457,2.457,0,0,0,.559,1.576,1.973,1.973,0,0,0,1.559.606,2.511,2.511,0,0,0,.824-.133,2.1,2.1,0,0,0,.686-.379,1.812,1.812,0,0,0,.469-.6,1.769,1.769,0,0,0,.176-.8,1.939,1.939,0,0,0-.166-.819,1.918,1.918,0,0,0-.449-.6,1.868,1.868,0,0,0-.668-.365,2.772,2.772,0,0,0-.834-.118,5.6,5.6,0,0,0-.709.043v-1.008a.6.6,0,0,0,.123.014h.393a2.4,2.4,0,0,0,.719-.1,1.841,1.841,0,0,0,.6-.308,1.526,1.526,0,0,0,.418-.511,1.627,1.627,0,0,0,.15-.7,1.436,1.436,0,0,0-.5-1.2,1.974,1.974,0,0,0-1.26-.4,1.842,1.842,0,0,0-.832.175,1.56,1.56,0,0,0-.588.469,1.962,1.962,0,0,0-.346.687,2.919,2.919,0,0,0-.113.824h-1.187a4.456,4.456,0,0,1,.23-1.3,2.875,2.875,0,0,1,.578-1.008,2.679,2.679,0,0,1,.947-.658,3.411,3.411,0,0,1,1.311-.237,4.166,4.166,0,0,1,1.193.161,2.821,2.821,0,0,1,.961.483,2.269,2.269,0,0,1,.641.824,2.9,2.9,0,0,1,.227,1.193,1.928,1.928,0,0,1-.389,1.188,2.573,2.573,0,0,1-.984.786v.028a2.042,2.042,0,0,1,1.354.852,2.735,2.735,0,0,1,.441,1.553,2.94,2.94,0,0,1-.275,1.311,2.672,2.672,0,0,1-.734.942,2.982,2.982,0,0,1-1.084.568,4.475,4.475,0,0,1-1.32.189A4.312,4.312,0,0,1,18632.391,700.179Zm-9.02-.421a2.571,2.571,0,0,1-.937-1.917h1.189a1.533,1.533,0,0,0,.592,1.122,1.977,1.977,0,0,0,1.23.388,1.775,1.775,0,0,0,1.639-.942,6.364,6.364,0,0,0,.6-2.893l-.029-.028a2.583,2.583,0,0,1-2.3,1.373,3.433,3.433,0,0,1-1.344-.246,2.716,2.716,0,0,1-.984-.677,2.8,2.8,0,0,1-.6-1.051,4.231,4.231,0,0,1-.2-1.344,3.526,3.526,0,0,1,.236-1.307,2.964,2.964,0,0,1,.672-1.023,3.106,3.106,0,0,1,1.037-.668,3.594,3.594,0,0,1,1.316-.237,3.9,3.9,0,0,1,1.316.218,2.45,2.45,0,0,1,1.074.748,3.837,3.837,0,0,1,.738,1.449,8.421,8.421,0,0,1,.27,2.329,7.8,7.8,0,0,1-.818,3.958,2.821,2.821,0,0,1-2.623,1.378A3.329,3.329,0,0,1,18623.371,699.758Zm1.16-8.2a1.726,1.726,0,0,0-.605.526,2.182,2.182,0,0,0-.336.748,3.54,3.54,0,0,0-.1.885,2.218,2.218,0,0,0,.553,1.453,1.866,1.866,0,0,0,.615.469,1.746,1.746,0,0,0,.791.175,1.933,1.933,0,0,0,.838-.175,1.91,1.91,0,0,0,.648-.473,2.088,2.088,0,0,0,.4-.7,2.441,2.441,0,0,0,.143-.833,2.776,2.776,0,0,0-.133-.871,2.316,2.316,0,0,0-.393-.72,1.956,1.956,0,0,0-.639-.5,2.05,2.05,0,0,0-.881-.18A1.92,1.92,0,0,0,18624.531,691.553Zm27.639,8.683v-1.558h1.553v1.558Zm-34.914,0V693.12h-2.576v-.952a6.062,6.062,0,0,0,.98-.076,2.649,2.649,0,0,0,.861-.289,1.929,1.929,0,0,0,.648-.573,2.105,2.105,0,0,0,.365-.923h.908v9.928ZM18720.3,696.9v-1.122h4.043V696.9Zm-68.127-2.353V693h1.553v1.553Z"
        transform="translate(-19281.691 -329.234)"
        fill="#1a1a1a"
      />
      <path
        id="_3361"
        data-name="3361"
        d="M18678.6,699.976a3.435,3.435,0,0,1-1.16-1.155,4.7,4.7,0,0,1-.6-1.619,9.724,9.724,0,0,1-.172-1.837,8.253,8.253,0,0,1,.209-1.823,5.473,5.473,0,0,1,.672-1.643,3.787,3.787,0,0,1,1.193-1.2,3.251,3.251,0,0,1,1.775-.464,3.667,3.667,0,0,1,1.18.185,2.9,2.9,0,0,1,.965.526,2.721,2.721,0,0,1,.686.843,3.444,3.444,0,0,1,.352,1.165h-1.895a1.643,1.643,0,0,0-.445-.852,1.142,1.142,0,0,0-.865-.365,1.3,1.3,0,0,0-.891.312,2.4,2.4,0,0,0-.568.772,4.146,4.146,0,0,0-.307.971,5.876,5.876,0,0,0-.113.923l.027.028a2.4,2.4,0,0,1,.951-.838,2.954,2.954,0,0,1,1.26-.251,3,3,0,0,1,1.236.27,3.16,3.16,0,0,1,1.018.739,2.8,2.8,0,0,1,.578,1.023,3.915,3.915,0,0,1,.18,1.16,4.043,4.043,0,0,1-.242,1.406,3.355,3.355,0,0,1-.705,1.136,3.142,3.142,0,0,1-1.084.753,3.417,3.417,0,0,1-1.4.275A3.513,3.513,0,0,1,18678.6,699.976Zm1.084-4.677a1.482,1.482,0,0,0-.5.4,1.811,1.811,0,0,0-.293.582,2.537,2.537,0,0,0-.1.7,2.15,2.15,0,0,0,.1.663,1.868,1.868,0,0,0,.309.587,1.448,1.448,0,0,0,.5.412,1.415,1.415,0,0,0,.674.156,1.244,1.244,0,0,0,.633-.156,1.54,1.54,0,0,0,.475-.4,1.867,1.867,0,0,0,.293-.578,2.188,2.188,0,0,0,.1-.658,2.523,2.523,0,0,0-.09-.677,1.884,1.884,0,0,0-.275-.587,1.358,1.358,0,0,0-.469-.421,1.309,1.309,0,0,0-.662-.161A1.626,1.626,0,0,0,18679.686,695.3Zm-9.207,4.881a3.193,3.193,0,0,1-1.156-.7,3.113,3.113,0,0,1-.738-1.113,3.959,3.959,0,0,1-.24-1.51h1.889a2.776,2.776,0,0,0,.127.748,1.745,1.745,0,0,0,.322.615,1.413,1.413,0,0,0,.525.412,1.662,1.662,0,0,0,.748.156,1.637,1.637,0,0,0,1.131-.412,1.437,1.437,0,0,0,.465-1.127,1.453,1.453,0,0,0-.219-.857,1.261,1.261,0,0,0-.553-.426,2.276,2.276,0,0,0-.734-.151c-.266-.014-.521-.024-.762-.024v-1.4a4.1,4.1,0,0,0,.682,0,2.025,2.025,0,0,0,.682-.161,1.23,1.23,0,0,0,.516-.383,1.029,1.029,0,0,0,.2-.672,1.16,1.16,0,0,0-.416-.966,1.513,1.513,0,0,0-.971-.336,1.36,1.36,0,0,0-1.141.5,1.926,1.926,0,0,0-.369,1.255h-1.889a4.13,4.13,0,0,1,.27-1.378,3.13,3.13,0,0,1,.691-1.075,2.976,2.976,0,0,1,1.055-.691,3.621,3.621,0,0,1,1.369-.246,4.225,4.225,0,0,1,1.178.175,3.382,3.382,0,0,1,1.057.526,2.782,2.782,0,0,1,.762.852,2.241,2.241,0,0,1,.3,1.165,2.344,2.344,0,0,1-.346,1.259,1.724,1.724,0,0,1-1.027.743v.028a2.141,2.141,0,0,1,1.273.781,2.3,2.3,0,0,1,.459,1.444,3.059,3.059,0,0,1-.3,1.373,3.106,3.106,0,0,1-.8,1.008,3.591,3.591,0,0,1-1.164.615,4.753,4.753,0,0,1-2.873-.028Zm-8.291,0a3.218,3.218,0,0,1-1.154-.7,3.03,3.03,0,0,1-.734-1.113,3.883,3.883,0,0,1-.246-1.51h1.889a2.777,2.777,0,0,0,.129.748,1.811,1.811,0,0,0,.322.615,1.445,1.445,0,0,0,.525.412,1.656,1.656,0,0,0,.748.156,1.624,1.624,0,0,0,1.131-.412,1.671,1.671,0,0,0,.246-1.984,1.25,1.25,0,0,0-.549-.426,2.333,2.333,0,0,0-.738-.151c-.266-.014-.521-.024-.764-.024v-1.4a4.168,4.168,0,0,0,.688,0,2.047,2.047,0,0,0,.682-.161,1.255,1.255,0,0,0,.516-.383,1.052,1.052,0,0,0,.2-.672,1.163,1.163,0,0,0-.42-.966,1.51,1.51,0,0,0-.967-.336,1.35,1.35,0,0,0-1.141.5,1.926,1.926,0,0,0-.369,1.255h-1.895a4.082,4.082,0,0,1,.275-1.378,3.2,3.2,0,0,1,.686-1.075,3,3,0,0,1,1.057-.691,3.655,3.655,0,0,1,1.373-.246,4.2,4.2,0,0,1,1.174.175,3.424,3.424,0,0,1,1.061.526,2.859,2.859,0,0,1,.762.852,2.277,2.277,0,0,1,.295,1.165,2.341,2.341,0,0,1-.342,1.259,1.739,1.739,0,0,1-1.031.743v.028a2.141,2.141,0,0,1,1.273.781,2.318,2.318,0,0,1,.463,1.444,2.979,2.979,0,0,1-1.107,2.381,3.632,3.632,0,0,1-1.16.615,4.772,4.772,0,0,1-2.879-.028Zm25.979.057v-6.358h-2.463v-1.5a4.632,4.632,0,0,0,1-.081,2.477,2.477,0,0,0,.865-.322,2.105,2.105,0,0,0,.654-.606,2.255,2.255,0,0,0,.35-.937h1.582v9.8Z"
        transform="translate(-19281.691 -329.234)"
        fill="#dc4405"
      />
      <g id="Icon" transform="translate(-1520 16730)">
        <g id="ic_tele_error" transform="translate(812 -16377)">
          <g id="ic_warning">
            <rect id="Box" width="24" height="24" fill="none" />
            <path
              id="Icon-2"
              data-name="Icon"
              d="M8.252,3.147a2,2,0,0,1,3.5,0l6.6,11.882A2,2,0,0,1,16.6,18H3.4a2,2,0,0,1-1.748-2.971Z"
              transform="translate(2 2)"
              fill="#ff0700"
            />
          </g>
        </g>
        <path
          id="_1"
          data-name="1"
          d="M3.528,0V-6.3H2.511a1.391,1.391,0,0,1-.225.6,1.369,1.369,0,0,1-.419.391,1.679,1.679,0,0,1-.558.207,3.025,3.025,0,0,1-.643.05v.963H2.25V0Z"
          transform="translate(821.5 -16360)"
          fill="#fff"
        />
      </g>
      <path
        id="Code-2"
        data-name="Code"
        d="M1.148-10V0h1.33V-10ZM4.522-7.238V0h1.19V-4.088a2.932,2.932,0,0,1,.133-.9,2.051,2.051,0,0,1,.4-.721,1.772,1.772,0,0,1,.665-.476,2.425,2.425,0,0,1,.945-.168,1.457,1.457,0,0,1,1.078.392A1.438,1.438,0,0,1,9.324-4.9V0h1.19V-4.76A4.479,4.479,0,0,0,10.4-5.831a2.028,2.028,0,0,0-.413-.833,1.956,1.956,0,0,0-.77-.546,3.141,3.141,0,0,0-1.19-.2A2.506,2.506,0,0,0,5.67-6.09H5.642V-7.238Zm9.044-1.3V-10h-1.19V-8.54Zm0,9.45V-7.238h-1.19V.714a1.535,1.535,0,0,1-.14.777.586.586,0,0,1-.532.217h-.252a.743.743,0,0,1-.1-.007q-.049-.007-.119-.021V2.7a3.069,3.069,0,0,0,.6.056A1.775,1.775,0,0,0,13.1,2.317,1.854,1.854,0,0,0,13.566.91ZM20.44-4.312H16.282a2.479,2.479,0,0,1,.182-.791,2.11,2.11,0,0,1,.42-.651,1.924,1.924,0,0,1,.637-.441,2.072,2.072,0,0,1,.833-.161,2.036,2.036,0,0,1,.819.161,2.061,2.061,0,0,1,.644.434,2.04,2.04,0,0,1,.434.651A2.435,2.435,0,0,1,20.44-4.312ZM21.588-2.3H20.412a1.692,1.692,0,0,1-.637,1.064,2.06,2.06,0,0,1-1.239.35,2.465,2.465,0,0,1-1.022-.2A2,2,0,0,1,16.8-1.6a2.045,2.045,0,0,1-.406-.756,2.873,2.873,0,0,1-.112-.9H21.7a5.762,5.762,0,0,0-.119-1.386,4.012,4.012,0,0,0-.532-1.344,3.17,3.17,0,0,0-1.022-1.015,2.969,2.969,0,0,0-1.6-.4,3.291,3.291,0,0,0-1.365.28,3.208,3.208,0,0,0-1.078.784,3.614,3.614,0,0,0-.707,1.19,4.355,4.355,0,0,0-.252,1.512,5.8,5.8,0,0,0,.245,1.526,3.33,3.33,0,0,0,.651,1.2,2.967,2.967,0,0,0,1.071.784,3.718,3.718,0,0,0,1.5.28,3.285,3.285,0,0,0,2.044-.616A2.892,2.892,0,0,0,21.588-2.3Zm6.258-2.618h1.232a2.861,2.861,0,0,0-.336-1.113,2.484,2.484,0,0,0-.679-.777,2.813,2.813,0,0,0-.952-.455,4.374,4.374,0,0,0-1.155-.147,3.5,3.5,0,0,0-1.5.3,2.99,2.99,0,0,0-1.071.826,3.513,3.513,0,0,0-.637,1.232,5.311,5.311,0,0,0-.21,1.519,4.877,4.877,0,0,0,.217,1.491A3.27,3.27,0,0,0,23.4-.868a2.837,2.837,0,0,0,1.064.756,3.77,3.77,0,0,0,1.463.266,3.145,3.145,0,0,0,2.191-.728,3.333,3.333,0,0,0,1-2.072H27.9a2.086,2.086,0,0,1-.609,1.3,1.947,1.947,0,0,1-1.379.462,1.97,1.97,0,0,1-.966-.224A1.88,1.88,0,0,1,24.29-1.7a2.627,2.627,0,0,1-.371-.847,4.025,4.025,0,0,1-.119-.98,4.923,4.923,0,0,1,.112-1.057,2.651,2.651,0,0,1,.371-.9,1.922,1.922,0,0,1,.693-.63,2.219,2.219,0,0,1,1.078-.238,1.806,1.806,0,0,1,1.2.378A1.814,1.814,0,0,1,27.846-4.914ZM32.1-7.238v-2.17h-1.19v2.17H29.68v1.05h1.232v4.606a2.75,2.75,0,0,0,.1.812.987.987,0,0,0,.3.476,1.162,1.162,0,0,0,.532.231A4.273,4.273,0,0,0,32.634,0h.91V-1.05H33a3.969,3.969,0,0,1-.455-.021.588.588,0,0,1-.273-.091.346.346,0,0,1-.133-.2,1.3,1.3,0,0,1-.035-.336V-6.188h1.442v-1.05Zm7.784,2.926H35.728A2.479,2.479,0,0,1,35.91-5.1a2.11,2.11,0,0,1,.42-.651,1.924,1.924,0,0,1,.637-.441,2.072,2.072,0,0,1,.833-.161,2.036,2.036,0,0,1,.819.161,2.061,2.061,0,0,1,.644.434,2.04,2.04,0,0,1,.434.651A2.435,2.435,0,0,1,39.886-4.312ZM41.034-2.3H39.858a1.692,1.692,0,0,1-.637,1.064,2.06,2.06,0,0,1-1.239.35,2.465,2.465,0,0,1-1.022-.2,2,2,0,0,1-.714-.525,2.045,2.045,0,0,1-.406-.756,2.873,2.873,0,0,1-.112-.9h5.418a5.763,5.763,0,0,0-.119-1.386A4.012,4.012,0,0,0,40.5-5.992a3.17,3.17,0,0,0-1.022-1.015,2.969,2.969,0,0,0-1.6-.4,3.291,3.291,0,0,0-1.365.28,3.208,3.208,0,0,0-1.078.784,3.614,3.614,0,0,0-.707,1.19,4.356,4.356,0,0,0-.252,1.512,5.8,5.8,0,0,0,.245,1.526,3.33,3.33,0,0,0,.651,1.2,2.967,2.967,0,0,0,1.071.784,3.718,3.718,0,0,0,1.505.28,3.285,3.285,0,0,0,2.044-.616A2.892,2.892,0,0,0,41.034-2.3ZM48.37,0V-7.238H47.18V-3.15a2.932,2.932,0,0,1-.133.9,2.051,2.051,0,0,1-.4.721,1.772,1.772,0,0,1-.665.476,2.425,2.425,0,0,1-.945.168,1.457,1.457,0,0,1-1.078-.392,1.438,1.438,0,0,1-.392-1.064v-4.9h-1.19v4.76A4.479,4.479,0,0,0,42.5-1.407a2.028,2.028,0,0,0,.413.833,1.9,1.9,0,0,0,.77.539,3.246,3.246,0,0,0,1.19.189,2.894,2.894,0,0,0,1.386-.315,2.432,2.432,0,0,0,.966-.987h.028V0Zm1.75-7.238V0h1.19V-3.22a4.948,4.948,0,0,1,.14-1.239,2.375,2.375,0,0,1,.448-.917,1.92,1.92,0,0,1,.812-.574,3.366,3.366,0,0,1,1.218-.2v-1.26a2.674,2.674,0,0,0-1.6.392,3.224,3.224,0,0,0-1.064,1.3H51.24V-7.238ZM58.912-10V0h1.33V-4.578h4.592V-5.7H60.242V-8.876h5.236V-10Zm8.036,0V0h6.944V-1.12H68.278V-4.578h5.194V-5.7H68.278V-8.876H73.85V-10ZM76.832-1.12V-8.876h2.24a4.1,4.1,0,0,1,1.554.259,2.521,2.521,0,0,1,1.029.756,3.073,3.073,0,0,1,.574,1.2,6.691,6.691,0,0,1,.175,1.6,5.707,5.707,0,0,1-.189,1.575,3.836,3.836,0,0,1-.483,1.085,2.527,2.527,0,0,1-.665.686,3.263,3.263,0,0,1-.749.385,3.141,3.141,0,0,1-.714.168,5.578,5.578,0,0,1-.56.035ZM75.5-10V0h3.43a6,6,0,0,0,2.156-.35,3.762,3.762,0,0,0,1.5-1.015A4.174,4.174,0,0,0,83.454-3a8.091,8.091,0,0,0,.28-2.233A4.708,4.708,0,0,0,82.488-8.82,4.984,4.984,0,0,0,78.932-10ZM93.968-4.914H95.2a2.861,2.861,0,0,0-.336-1.113,2.484,2.484,0,0,0-.679-.777,2.813,2.813,0,0,0-.952-.455,4.374,4.374,0,0,0-1.155-.147,3.5,3.5,0,0,0-1.5.3,2.99,2.99,0,0,0-1.071.826,3.513,3.513,0,0,0-.637,1.232,5.311,5.311,0,0,0-.21,1.519,4.877,4.877,0,0,0,.217,1.491,3.27,3.27,0,0,0,.644,1.169,2.837,2.837,0,0,0,1.064.756A3.77,3.77,0,0,0,92.05.154a3.145,3.145,0,0,0,2.191-.728,3.333,3.333,0,0,0,1-2.072H94.024a2.086,2.086,0,0,1-.609,1.3,1.947,1.947,0,0,1-1.379.462,1.97,1.97,0,0,1-.966-.224,1.88,1.88,0,0,1-.658-.595,2.627,2.627,0,0,1-.371-.847,4.025,4.025,0,0,1-.119-.98,4.923,4.923,0,0,1,.112-1.057,2.651,2.651,0,0,1,.371-.9,1.922,1.922,0,0,1,.693-.63,2.219,2.219,0,0,1,1.078-.238,1.806,1.806,0,0,1,1.2.378A1.814,1.814,0,0,1,93.968-4.914Zm3.472,1.3a3.6,3.6,0,0,1,.175-1.169,2.523,2.523,0,0,1,.483-.861,2.057,2.057,0,0,1,.721-.532,2.146,2.146,0,0,1,.875-.182,2.146,2.146,0,0,1,.875.182,2.057,2.057,0,0,1,.721.532,2.523,2.523,0,0,1,.483.861,3.6,3.6,0,0,1,.175,1.169,3.6,3.6,0,0,1-.175,1.169,2.446,2.446,0,0,1-.483.854,2.1,2.1,0,0,1-.721.525,2.146,2.146,0,0,1-.875.182,2.146,2.146,0,0,1-.875-.182,2.1,2.1,0,0,1-.721-.525,2.446,2.446,0,0,1-.483-.854A3.6,3.6,0,0,1,97.44-3.612Zm-1.26,0A4.755,4.755,0,0,0,96.4-2.128a3.387,3.387,0,0,0,.672,1.2,3.091,3.091,0,0,0,1.106.8,3.75,3.75,0,0,0,1.512.287,3.738,3.738,0,0,0,1.519-.287,3.106,3.106,0,0,0,1.1-.8,3.387,3.387,0,0,0,.672-1.2,4.755,4.755,0,0,0,.224-1.484,4.821,4.821,0,0,0-.224-1.491,3.378,3.378,0,0,0-.672-1.2,3.182,3.182,0,0,0-1.1-.805,3.66,3.66,0,0,0-1.519-.294,3.673,3.673,0,0,0-1.512.294,3.166,3.166,0,0,0-1.106.805A3.378,3.378,0,0,0,96.4-5.1,4.821,4.821,0,0,0,96.18-3.612ZM110.6,0V-7.238h-1.19V-3.15a2.932,2.932,0,0,1-.133.9,2.051,2.051,0,0,1-.4.721,1.772,1.772,0,0,1-.665.476,2.425,2.425,0,0,1-.945.168,1.457,1.457,0,0,1-1.078-.392,1.438,1.438,0,0,1-.392-1.064v-4.9h-1.19v4.76a4.479,4.479,0,0,0,.119,1.071,2.028,2.028,0,0,0,.413.833,1.9,1.9,0,0,0,.77.539,3.246,3.246,0,0,0,1.19.189,2.894,2.894,0,0,0,1.386-.315,2.432,2.432,0,0,0,.966-.987h.028V0Zm1.75-7.238V0h1.19V-3.22a4.949,4.949,0,0,1,.14-1.239,2.375,2.375,0,0,1,.448-.917,1.92,1.92,0,0,1,.812-.574,3.366,3.366,0,0,1,1.218-.2v-1.26a2.674,2.674,0,0,0-1.6.392,3.224,3.224,0,0,0-1.064,1.3h-.028V-7.238Zm6.356,0v-2.17h-1.19v2.17h-1.232v1.05h1.232v4.606a2.75,2.75,0,0,0,.1.812.987.987,0,0,0,.3.476,1.162,1.162,0,0,0,.532.231,4.273,4.273,0,0,0,.791.063h.91V-1.05H119.6a3.969,3.969,0,0,1-.455-.021.588.588,0,0,1-.273-.091.346.346,0,0,1-.133-.2,1.3,1.3,0,0,1-.035-.336V-6.188h1.442v-1.05Zm2.562,2.786v1.12h4.046v-1.12Zm10.556-.462h1.232a2.861,2.861,0,0,0-.336-1.113,2.484,2.484,0,0,0-.679-.777,2.813,2.813,0,0,0-.952-.455,4.374,4.374,0,0,0-1.155-.147,3.5,3.5,0,0,0-1.5.3,2.99,2.99,0,0,0-1.071.826,3.513,3.513,0,0,0-.637,1.232,5.311,5.311,0,0,0-.21,1.519,4.877,4.877,0,0,0,.217,1.491,3.27,3.27,0,0,0,.644,1.169,2.837,2.837,0,0,0,1.064.756,3.77,3.77,0,0,0,1.463.266A3.145,3.145,0,0,0,132.1-.574a3.333,3.333,0,0,0,1-2.072H131.88a2.086,2.086,0,0,1-.609,1.3,1.947,1.947,0,0,1-1.379.462,1.97,1.97,0,0,1-.966-.224,1.88,1.88,0,0,1-.658-.595,2.627,2.627,0,0,1-.371-.847,4.025,4.025,0,0,1-.119-.98,4.923,4.923,0,0,1,.112-1.057,2.651,2.651,0,0,1,.371-.9,1.922,1.922,0,0,1,.693-.63,2.219,2.219,0,0,1,1.078-.238,1.806,1.806,0,0,1,1.2.378A1.814,1.814,0,0,1,131.824-4.914Zm3.864-3.626V-10H134.5V-8.54Zm-1.19,1.3V0h1.19V-7.238Zm13.02,5.684V0h1.554V-1.554Zm-4.662,0V0h1.554V-1.554Zm-4.662,0V0h1.554V-1.554Z"
        transform="translate(-552 371)"
        fill="#1a1a1a"
      />
    </g>
    <g id="Dot" transform="translate(-1061 -468.748)">
      <g transform="matrix(1, 0, 0, 1, 1061, 468.75)" filter="url(#BG)">
        <g
          id="BG-5"
          data-name="BG"
          transform="translate(182 49.25) rotate(180)"
          fill="#f7f7f7"
        >
          <path
            d="M 16 36.50195693969727 C 11.86003017425537 36.50195693969727 7.96753978729248 34.88908767700195 5.03957986831665 31.96045684814453 C 2.112190008163452 29.03238677978516 0.5 25.14058685302734 0.5 21.00195693969727 C 0.5 19.20147705078125 0.805679976940155 17.4377269744873 1.408540010452271 15.75969696044922 C 1.991140007972717 14.13803672790527 2.837249994277954 12.63233661651611 3.923350095748901 11.28441619873047 C 6.098559856414795 8.584856986999512 9.146269798278809 6.671696662902832 12.50506019592285 5.897376537322998 L 12.69857978820801 5.852766513824463 L 12.80875015258789 5.687536716461182 L 16 0.9013065099716187 L 19.19125938415527 5.687536716461182 L 19.30142974853516 5.852766513824463 L 19.49494934082031 5.897376537322998 C 22.85374069213867 6.671696662902832 25.90144920349121 8.584856986999512 28.07665061950684 11.28441619873047 C 29.16275024414062 12.63233661651611 30.00885963439941 14.13803672790527 30.59145927429199 15.75969696044922 C 31.19432067871094 17.4377269744873 31.5 19.20147705078125 31.5 21.00195693969727 C 31.5 25.14058685302734 29.88780975341797 29.03238677978516 26.96042060852051 31.96045684814453 C 24.0324592590332 34.88908767700195 20.13998031616211 36.50195693969727 16 36.50195693969727 Z"
            stroke="none"
          />
          <path
            d="M 16 36.00195693969727 C 20.00639915466309 36.00195693969727 23.7733097076416 34.44110488891602 26.60683059692383 31.60694694519043 C 29.43980979919434 28.77330589294434 31 25.00704574584961 31 21.00195693969727 C 31 19.2592658996582 30.7042293548584 17.55238723754883 30.12091064453125 15.92874622344971 C 29.55718040466309 14.35961627960205 28.73838996887207 12.90258693695068 27.68730926513672 11.59812641143799 C 25.58208084106445 8.985406875610352 22.63274955749512 7.133866786956787 19.38262939453125 6.384596347808838 L 18.99559020996094 6.295376777648926 L 16.00000190734863 1.802606463432312 L 13.00442028045654 6.295376777648926 L 12.61738014221191 6.384596347808838 C 9.367259979248047 7.133866786956787 6.417930126190186 8.985406875610352 4.312689781188965 11.59813690185547 C 3.26161003112793 12.90258693695068 2.442830085754395 14.35961627960205 1.879089951515198 15.92874622344971 C 1.295770049095154 17.55238723754883 1 19.2592658996582 1 21.00195693969727 C 1 25.00704574584961 2.560189962387085 28.77330589294434 5.393179893493652 31.60694694519043 C 8.226690292358398 34.44110488891602 11.9935998916626 36.00195693969727 16 36.00195693969727 M 16 37.00195693969727 C 7.16264009475708 37.00195693969727 0 29.83398628234863 0 21.00195693969727 C 0 13.404296875 5.293129920959473 7.046876430511475 12.39274024963379 5.410156726837158 L 16 -3.437500026848284e-06 L 19.60726928710938 5.410156726837158 C 26.70688056945801 7.046876430511475 32 13.404296875 32 21.00195693969727 C 32 29.83398628234863 24.83736991882324 37.00195693969727 16 37.00195693969727 Z"
            stroke="none"
            fill="#ccc"
          />
        </g>
      </g>
      <path
        id="IMD"
        d="M.621-6.426V0H2.034V-6.426Zm2.655,0V0H4.6V-4.509h.018L6.192,0H7.281L8.856-4.554h.018V0H10.2V-6.426H8.208L6.786-2.007H6.768l-1.5-4.419Zm9.576,5.238v-4.05H13.86a2.282,2.282,0,0,1,.877.148,1.377,1.377,0,0,1,.572.428,1.751,1.751,0,0,1,.311.671,3.747,3.747,0,0,1,.095.878,2.633,2.633,0,0,1-.135.9,1.651,1.651,0,0,1-.36.6,1.307,1.307,0,0,1-.513.328,1.815,1.815,0,0,1-.594.1ZM11.439-6.426V0h2.772a3.076,3.076,0,0,0,1.282-.248A2.551,2.551,0,0,0,16.4-.927a2.852,2.852,0,0,0,.544-1.026,4.452,4.452,0,0,0,.18-1.3,4,4,0,0,0-.22-1.395,2.742,2.742,0,0,0-.612-.99,2.51,2.51,0,0,0-.927-.594,3.309,3.309,0,0,0-1.156-.2Z"
        transform="translate(1218.124 501)"
        fill="#1a1a1a"
      />
    </g>
    <g id="Dot-2" data-name="Dot" transform="translate(-1101 -417)">
      <g transform="matrix(1, 0, 0, 1, 1101, 417)" filter="url(#BG-2)">
        <path
          id="BG-6"
          data-name="BG"
          d="M0,26.254A20.006,20.006,0,0,1,15.491,6.764L20,0l4.509,6.764A20,20,0,1,1,0,26.254Z"
          transform="translate(110 69)"
          fill="#dc4405"
        />
      </g>
      <path
        id="NPS"
        d="M.69-7.14V0H2.16V-4.78h.02L5.15,0H6.72V-7.14H5.25v4.79H5.23L2.25-7.14ZM9.67-3.78V-5.92h1.22a3.288,3.288,0,0,1,.52.04,1.21,1.21,0,0,1,.44.155.844.844,0,0,1,.3.325,1.142,1.142,0,0,1,.115.55,1.142,1.142,0,0,1-.115.55.844.844,0,0,1-.3.325,1.21,1.21,0,0,1-.44.155,3.288,3.288,0,0,1-.52.04ZM8.1-7.14V0H9.67V-2.56h1.65a2.974,2.974,0,0,0,1.14-.195,2.133,2.133,0,0,0,.765-.515,1.972,1.972,0,0,0,.43-.735,2.715,2.715,0,0,0,.135-.845,2.7,2.7,0,0,0-.135-.85,1.978,1.978,0,0,0-.43-.73,2.133,2.133,0,0,0-.765-.515,2.974,2.974,0,0,0-1.14-.195Zm7.74,4.77H14.32a2.358,2.358,0,0,0,.24,1.14,2.248,2.248,0,0,0,.675.79,2.88,2.88,0,0,0,.98.455A4.511,4.511,0,0,0,17.36.16a4.4,4.4,0,0,0,1.285-.17,2.717,2.717,0,0,0,.93-.475,1.977,1.977,0,0,0,.565-.725,2.182,2.182,0,0,0,.19-.91,1.75,1.75,0,0,0-.255-.985,2.13,2.13,0,0,0-.605-.615,2.66,2.66,0,0,0-.7-.335Q18.41-4.16,18.21-4.2q-.67-.17-1.085-.28a4.025,4.025,0,0,1-.65-.22.714.714,0,0,1-.315-.24.642.642,0,0,1-.08-.34.671.671,0,0,1,.1-.38.869.869,0,0,1,.255-.25,1.017,1.017,0,0,1,.345-.14,1.84,1.84,0,0,1,.38-.04,2.678,2.678,0,0,1,.535.05,1.29,1.29,0,0,1,.435.17.883.883,0,0,1,.3.33,1.262,1.262,0,0,1,.135.53h1.52a2.193,2.193,0,0,0-.235-1.055,2.049,2.049,0,0,0-.635-.715,2.681,2.681,0,0,0-.915-.405A4.542,4.542,0,0,0,17.23-7.31a3.658,3.658,0,0,0-.96.13,2.68,2.68,0,0,0-.86.4A2.129,2.129,0,0,0,14.8-6.1a1.87,1.87,0,0,0-.235.955,1.746,1.746,0,0,0,.185.835,1.766,1.766,0,0,0,.485.575,2.68,2.68,0,0,0,.68.375,6.837,6.837,0,0,0,.78.245q.39.11.77.2a4.841,4.841,0,0,1,.68.21,1.467,1.467,0,0,1,.485.3.626.626,0,0,1,.185.47.69.69,0,0,1-.14.445.982.982,0,0,1-.35.275,1.566,1.566,0,0,1-.45.135,3.128,3.128,0,0,1-.45.035,2.387,2.387,0,0,1-.6-.075,1.493,1.493,0,0,1-.5-.23,1.136,1.136,0,0,1-.345-.4A1.31,1.31,0,0,1,15.84-2.37Z"
        transform="translate(1220.488 516)"
        fill="#fff"
      />
    </g>
  </svg>;
}

export function ic_restart_inhibit_locally_disabled() {
  return (
    <svg
      id="ic_restart_inhibit_locally_disabled"
      xmlns="http://www.w3.org/2000/svg"
      width="124"
      height="124"
      viewBox="0 0 124 124"
    >
      <circle id="Border" cx="62" cy="62" r="62" fill="#f7f7f7" />
      <path
        id="Icon_metro-key"
        data-name="Icon metro-key"
        d="M19.274,28.035A8.766,8.766,0,0,1,10.66,17.669L0,7.009V1.752A1.752,1.752,0,0,1,1.752,0H3.5V1.752h3.5v3.5h3.5v3.5h3.5l2.273,2.273a8.762,8.762,0,1,1,2.983,17ZM21.9,19.27A2.628,2.628,0,1,0,24.527,21.9,2.628,2.628,0,0,0,21.9,19.27Z"
        transform="translate(81.822 65.5) rotate(135)"
        fill="#1a1a1a"
      />
      <g
        id="Polygon_6"
        data-name="Polygon 6"
        transform="translate(22 17)"
        fill="none"
      >
        <path
          d="M36.527,6.078a4,4,0,0,1,6.946,0L76.58,64.015A4,4,0,0,1,73.107,70H6.893A4,4,0,0,1,3.42,64.015Z"
          stroke="none"
        />
        <path
          d="M 39.9999885559082 6.062255859375 C 39.65102386474609 6.062255859375 38.78323364257812 6.160446166992188 38.26351165771484 7.069976806640625 L 5.156234741210938 65.00772094726562 C 4.640487670898438 65.91026306152344 4.98907470703125 66.704345703125 5.16290283203125 67.00385284423828 C 5.336708068847656 67.30336761474609 5.85321044921875 68 6.892707824707031 68 L 73.10727691650391 68 C 74.14678955078125 68 74.66329193115234 67.30336761474609 74.83709716796875 67.00384521484375 C 75.01091003417969 66.70433044433594 75.35951232910156 65.91026306152344 74.84376525878906 65.00772094726562 L 41.73647689819336 7.069976806640625 C 41.21675491333008 6.160446166992188 40.34896850585938 6.062255859375 39.9999885559082 6.062255859375 M 39.99999618530273 4.062255859375 C 41.35258483886719 4.062255859375 42.70517730712891 4.73406982421875 43.47296524047852 6.07769775390625 L 76.58025360107422 64.01544189453125 C 78.10404205322266 66.68206787109375 76.17856597900391 70 73.10727691650391 70 L 6.892707824707031 70 C 3.821418762207031 70 1.895957946777344 66.68206787109375 3.419746398925781 64.01544189453125 L 36.52702331542969 6.07769775390625 C 37.2948112487793 4.73406982421875 38.64740371704102 4.062255859375 39.99999618530273 4.062255859375 Z"
          stroke="none"
          fill="#ff0700"
        />
      </g>
    </svg>
  );
}

export function ic_notif_mark_read() {
  return (
    <svg
      id="ic_notif_mark_read"
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
    >
      <rect id="Box" width="20" height="20" fill="none" />
      <g id="Icon" transform="translate(0.55 0.947)">
        <g id="Bell" transform="translate(1.45 1.3)">
          <path
            id="Vector"
            d="M13.027,2.719A5.068,5.068,0,0,0,8.5,0"
            transform="translate(-1.398)"
            fill="none"
            stroke="#1a1a1a"
            strokeLinecap="round"
            strokeWidth="1.2"
          />
          <path
            id="Vector-2"
            data-name="Vector"
            d="M7.037,0A5.167,5.167,0,0,0,1.9,5.141h0V6.716a3.263,3.263,0,0,1-.5,1.741l-1,1.658c-.663,1-.829,2.57.912,2.488,5.39.083,6.716,0,11.277,0,1.741-.083,1.907-1,.912-2.488"
            transform="translate(0.065)"
            fill="none"
            stroke="#1a1a1a"
            strokeLinecap="round"
            strokeWidth="1.2"
          />
          <path
            id="Vector-3"
            data-name="Vector"
            d="M10.541,15.6a2.571,2.571,0,1,1-5.141,0"
            transform="translate(-0.869 -2.665)"
            fill="none"
            stroke="#1a1a1a"
            strokeWidth="1.2"
          />
        </g>
        <path
          id="Check"
          d="M393.658,25.147l3.776,3.776,6.161-6.16"
          transform="translate(-386.145 -18.884)"
          fill="none"
          stroke="#1a1a1a"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.2"
        />
      </g>
    </svg>
  );
}

export function ic_notif_delete() {
  return (
    <svg
      id="ic_notif_delete"
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
    >
      <g id="trash">
        <path id="Vector" d="M0,0H20V20H0Z" fill="none" opacity="0" />
        <g
          id="Group_348"
          data-name="Group 348"
          transform="translate(1.17 1.31)"
        >
          <path
            id="Vector-2"
            data-name="Vector"
            d="M12.582,0H.029"
            transform="translate(2.495 4.111)"
            fill="none"
            stroke="#ff0700"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.2"
          />
          <path
            id="Vector-3"
            data-name="Vector"
            d="M0,2.086l.155-.92C.267.5.351,0,1.538,0h1.84C4.565,0,4.657.527,4.762,1.173l.155.913"
            transform="translate(6.367 1.667)"
            fill="none"
            stroke="#ff0700"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.2"
          />
          <path
            id="Vector-4"
            data-name="Vector"
            d="M9.622,0,9.166,7.073c-.077,1.1-.14,1.96-2.1,1.96H2.557c-1.96,0-2.023-.857-2.1-1.96L0,0"
            transform="translate(4.014 6.682)"
            fill="none"
            stroke="#ff0700"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.2"
          />
          <path
            id="Vector-5"
            data-name="Vector"
            d="M0,0H2.339"
            transform="translate(7.652 11.851)"
            fill="none"
            stroke="#ff0700"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.2"
          />
          <path
            id="Vector-6"
            data-name="Vector"
            d="M0,0H3.512"
            transform="translate(7.069 9.042)"
            fill="none"
            stroke="#ff0700"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.2"
          />
        </g>
      </g>
    </svg>
  );
}

export function ic_btn_logs() {
  return (
    <svg
      id="ic_btn_logs"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <rect id="Box" width="24" height="24" fill="none" />
      <g id="Icon" transform="translate(-748 -316)">
        <path
          id="Vector"
          d="M0,0V3"
          transform="translate(756 318)"
          fill="none"
          stroke="#1a1a1a"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          id="Vector-2"
          data-name="Vector"
          d="M0,0V3"
          transform="translate(764 318)"
          fill="none"
          stroke="#1a1a1a"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          id="Vector-3"
          data-name="Vector"
          d="M18,5v8.5c0,3-1.5,5-5,5H5c-3.5,0-5-2-5-5V5C0,2,1.5,0,5,0h8C16.5,0,18,2,18,5Z"
          transform="translate(751 319.5)"
          fill="none"
          stroke="#1a1a1a"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          id="Vector-4"
          data-name="Vector"
          d="M0,0H8"
          transform="translate(756 327)"
          fill="none"
          stroke="#1a1a1a"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          id="Vector-5"
          data-name="Vector"
          d="M0,0H4"
          transform="translate(756 332)"
          fill="none"
          stroke="#1a1a1a"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
      </g>
    </svg>
  );
}

export function ic_btn_delete({ color = '#1a1a1a', width = 24, height = 24 }) {
  return (
    <svg
      id="ic_btn_delete"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox={`0 0 24 24`}
    >
      <rect id="BG" width={width} height={height} fill="none" />
      <g id="icon" transform="translate(6.233 5.58)">
        <path
          id="Vector"
          d="M11.5,0H.029"
          transform="translate(-0.029 2.234)"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        />
        <path
          id="Vector-2"
          data-name="Vector"
          d="M0,1.906l.141-.841C.244.456.321,0,1.406,0H3.087C4.172,0,4.256.481,4.352,1.072l.141.834"
          transform="translate(3.512)"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        />
        <path
          id="Vector-3"
          data-name="Vector"
          d="M8.794,0,8.376,6.464c-.071,1.008-.128,1.791-1.919,1.791H2.336C.546,8.254.488,7.471.417,6.464L0,0"
          transform="translate(1.362 4.583)"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        />
        <path
          id="Vector-4"
          data-name="Vector"
          d="M0,0H2.137"
          transform="translate(4.687 9.307)"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        />
        <path
          id="Vector-5"
          data-name="Vector"
          d="M0,0H3.209"
          transform="translate(4.154 6.74)"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        />
      </g>
    </svg>
  );
}

export function ic_access_edit() {
  return (
    <svg
      id="ic_edit"
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
    >
      <rect id="Box" width="20" height="20" fill="none" />
      <g id="Icon" transform="translate(4.528 4)">
        <path
          id="Vector"
          d="M5.633.875.64,6.159a1.854,1.854,0,0,0-.407.87L.008,9a.929.929,0,0,0,1.137,1.076L3.1,9.74a1.746,1.746,0,0,0,.845-.456L8.94,4A1.981,1.981,0,0,0,8.849.778,1.982,1.982,0,0,0,5.633.875Z"
          transform="translate(0.606)"
          fill="none"
          stroke="#1a1a1a"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        />
        <path
          id="Vector-2"
          data-name="Vector"
          d="M0,0A3.725,3.725,0,0,0,3.314,3.131"
          transform="translate(5.406 1.757)"
          fill="none"
          stroke="#1a1a1a"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        />
        <path
          id="Vector-3"
          data-name="Vector"
          d="M0,0H10.945"
          transform="translate(0 12.063)"
          fill="none"
          stroke="#1a1a1a"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        />
      </g>
    </svg>
  );
}
